import React, { useEffect, useState } from "react";
import Conexao from '../Config/conexao';
import axios from 'axios';
import moment from 'moment';
import Navbar from '../SGI/EPIS/NavBarSSMT';
import { CheckBox } from "@mui/icons-material";

import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import download from "downloadjs";

export default function CheckListInspecaoDeSonda(){

    const[projeto, setProjeto]=useState();
    const[mesEAno, setMesEAno]=useState();
    const[equipamento,setEquipamento]=useState();

    const[listaDados, setListaDados]=useState([]);
    const[listaDados2, setListaDados2]=useState([]);
    const[listaDados3, setListaDados3]=useState([]);


const[abrirDia1, setAbrirDia1]=useState(false);
const[abrirDia2, setAbrirDia2]=useState(false);
const[abrirDia3, setAbrirDia3]=useState(false);
const[abrirDia4, setAbrirDia4]=useState(false);
const[abrirDia5, setAbrirDia5]=useState(false);
const[abrirDia6, setAbrirDia6]=useState(false);
const[abrirDia7, setAbrirDia7]=useState(false);
const[abrirDia8, setAbrirDia8]=useState(false);
const[abrirDia9, setAbrirDia9]=useState(false);
const[abrirDia10, setAbrirDia10]=useState(false);
const[abrirDia11, setAbrirDia11]=useState(false);
const[abrirDia12, setAbrirDia12]=useState(false);
const[abrirDia13, setAbrirDia13]=useState(false);
const[abrirDia14, setAbrirDia14]=useState(false);
const[abrirDia15, setAbrirDia15]=useState(false);
const[abrirDia16, setAbrirDia16]=useState(false);
const[abrirDia17, setAbrirDia17]=useState(false);
const[abrirDia18, setAbrirDia18]=useState(false);
const[abrirDia19, setAbrirDia19]=useState(false);
const[abrirDia20, setAbrirDia20]=useState(false);
const[abrirDia21, setAbrirDia21]=useState(false);
const[abrirDia22, setAbrirDia22]=useState(false);
const[abrirDia23, setAbrirDia23]=useState(false);
const[abrirDia24, setAbrirDia24]=useState(false);
const[abrirDia25, setAbrirDia25]=useState(false);
const[abrirDia26, setAbrirDia26]=useState(false);
const[abrirDia27, setAbrirDia27]=useState(false);
const[abrirDia28, setAbrirDia28]=useState(false);
const[abrirDia29, setAbrirDia29]=useState(false);
const[abrirDia30, setAbrirDia30]=useState(false);
const[abrirDia31, setAbrirDia31]=useState(false);

    // item1

//dia 1
const[selecione1Dia1, setSelecione1Dia1]=useState();
const[selecione2Dia1, setSelecione2Dia1]=useState();
const[selecione3Dia1, setSelecione3Dia1]=useState();
const[selecione4Dia1, setSelecione4Dia1]=useState();
const[selecione5Dia1, setSelecione5Dia1]=useState();
const[selecione6Dia1, setSelecione6Dia1]=useState();
const[selecione7Dia1, setSelecione7Dia1]=useState();
const[selecione8Dia1, setSelecione8Dia1]=useState();
const[selecione9Dia1, setSelecione9Dia1]=useState();
const[selecione10Dia1, setSelecione10Dia1]=useState();
const[selecione11Dia1, setSelecione11Dia1]=useState();
const[selecione12Dia1, setSelecione12Dia1]=useState();
const[selecione13Dia1, setSelecione13Dia1]=useState();
const[selecione14Dia1, setSelecione14Dia1]=useState();
const[selecione15Dia1, setSelecione15Dia1]=useState();
const[selecione16Dia1, setSelecione16Dia1]=useState();
const[selecione17Dia1, setSelecione17Dia1]=useState();
const[selecione18Dia1, setSelecione18Dia1]=useState();
const[selecione19Dia1, setSelecione19Dia1]=useState();
const[selecione20Dia1, setSelecione20Dia1]=useState();
const[selecione21Dia1, setSelecione21Dia1]=useState();
const[selecione22Dia1, setSelecione22Dia1]=useState();
const[selecione23Dia1, setSelecione23Dia1]=useState();
const[selecione24Dia1, setSelecione24Dia1]=useState();
const[selecione25Dia1, setSelecione25Dia1]=useState();
const[selecione26Dia1, setSelecione26Dia1]=useState();
const[selecione27Dia1, setSelecione27Dia1]=useState();
const[selecione28Dia1, setSelecione28Dia1]=useState();
const[selecione29Dia1, setSelecione29Dia1]=useState();
const[selecione30Dia1, setSelecione30Dia1]=useState();
const[selecione31Dia1, setSelecione31Dia1]=useState();

const[justifique1Dia1, setJustifique1Dia1]=useState();
const[justifique2Dia1, setJustifique2Dia1]=useState();
const[justifique3Dia1, setJustifique3Dia1]=useState();
const[justifique4Dia1, setJustifique4Dia1]=useState();
const[justifique5Dia1, setJustifique5Dia1]=useState();
const[justifique6Dia1, setJustifique6Dia1]=useState();
const[justifique7Dia1, setJustifique7Dia1]=useState();
const[justifique8Dia1, setJustifique8Dia1]=useState();
const[justifique9Dia1, setJustifique9Dia1]=useState();
const[justifique10Dia1, setJustifique10Dia1]=useState();
const[justifique11Dia1, setJustifique11Dia1]=useState();
const[justifique12Dia1, setJustifique12Dia1]=useState();
const[justifique13Dia1, setJustifique13Dia1]=useState();
const[justifique14Dia1, setJustifique14Dia1]=useState();
const[justifique15Dia1, setJustifique15Dia1]=useState();
const[justifique16Dia1, setJustifique16Dia1]=useState();
const[justifique17Dia1, setJustifique17Dia1]=useState();
const[justifique18Dia1, setJustifique18Dia1]=useState();
const[justifique19Dia1, setJustifique19Dia1]=useState();
const[justifique20Dia1, setJustifique20Dia1]=useState();
const[justifique21Dia1, setJustifique21Dia1]=useState();
const[justifique22Dia1, setJustifique22Dia1]=useState();
const[justifique23Dia1, setJustifique23Dia1]=useState();
const[justifique24Dia1, setJustifique24Dia1]=useState();
const[justifique25Dia1, setJustifique25Dia1]=useState();
const[justifique26Dia1, setJustifique26Dia1]=useState();
const[justifique27Dia1, setJustifique27Dia1]=useState();
const[justifique28Dia1, setJustifique28Dia1]=useState();
const[justifique29Dia1, setJustifique29Dia1]=useState();
const[justifique30Dia1, setJustifique30Dia1]=useState();
const[justifique31Dia1, setJustifique31Dia1]=useState();  

const[sonda1Dia1, setSonda1Dia1]=useState();
const[responsavel1Dia1, setResponsavel1Dia1]=useState();



//dia 2
const[selecione1Dia2, setSelecione1Dia2]=useState();
const[selecione2Dia2, setSelecione2Dia2]=useState();
const[selecione3Dia2, setSelecione3Dia2]=useState();
const[selecione4Dia2, setSelecione4Dia2]=useState();
const[selecione5Dia2, setSelecione5Dia2]=useState();
const[selecione6Dia2, setSelecione6Dia2]=useState();
const[selecione7Dia2, setSelecione7Dia2]=useState();
const[selecione8Dia2, setSelecione8Dia2]=useState();
const[selecione9Dia2, setSelecione9Dia2]=useState();
const[selecione10Dia2, setSelecione10Dia2]=useState();
const[selecione11Dia2, setSelecione11Dia2]=useState();
const[selecione12Dia2, setSelecione12Dia2]=useState();
const[selecione13Dia2, setSelecione13Dia2]=useState();
const[selecione14Dia2, setSelecione14Dia2]=useState();
const[selecione15Dia2, setSelecione15Dia2]=useState();
const[selecione16Dia2, setSelecione16Dia2]=useState();
const[selecione17Dia2, setSelecione17Dia2]=useState();
const[selecione18Dia2, setSelecione18Dia2]=useState();
const[selecione19Dia2, setSelecione19Dia2]=useState();
const[selecione20Dia2, setSelecione20Dia2]=useState();
const[selecione21Dia2, setSelecione21Dia2]=useState();
const[selecione22Dia2, setSelecione22Dia2]=useState();
const[selecione23Dia2, setSelecione23Dia2]=useState();
const[selecione24Dia2, setSelecione24Dia2]=useState();
const[selecione25Dia2, setSelecione25Dia2]=useState();
const[selecione26Dia2, setSelecione26Dia2]=useState();
const[selecione27Dia2, setSelecione27Dia2]=useState();
const[selecione28Dia2, setSelecione28Dia2]=useState();
const[selecione29Dia2, setSelecione29Dia2]=useState();
const[selecione30Dia2, setSelecione30Dia2]=useState();
const[selecione31Dia2, setSelecione31Dia2]=useState();

const[justifique1Dia2, setJustifique1Dia2]=useState();
const[justifique2Dia2, setJustifique2Dia2]=useState();
const[justifique3Dia2, setJustifique3Dia2]=useState();
const[justifique4Dia2, setJustifique4Dia2]=useState();
const[justifique5Dia2, setJustifique5Dia2]=useState();
const[justifique6Dia2, setJustifique6Dia2]=useState();
const[justifique7Dia2, setJustifique7Dia2]=useState();
const[justifique8Dia2, setJustifique8Dia2]=useState();
const[justifique9Dia2, setJustifique9Dia2]=useState();
const[justifique10Dia2, setJustifique10Dia2]=useState();
const[justifique11Dia2, setJustifique11Dia2]=useState();
const[justifique12Dia2, setJustifique12Dia2]=useState();
const[justifique13Dia2, setJustifique13Dia2]=useState();
const[justifique14Dia2, setJustifique14Dia2]=useState();
const[justifique15Dia2, setJustifique15Dia2]=useState();
const[justifique16Dia2, setJustifique16Dia2]=useState();
const[justifique17Dia2, setJustifique17Dia2]=useState();
const[justifique18Dia2, setJustifique18Dia2]=useState();
const[justifique19Dia2, setJustifique19Dia2]=useState();
const[justifique20Dia2, setJustifique20Dia2]=useState();
const[justifique21Dia2, setJustifique21Dia2]=useState();
const[justifique22Dia2, setJustifique22Dia2]=useState();
const[justifique23Dia2, setJustifique23Dia2]=useState();
const[justifique24Dia2, setJustifique24Dia2]=useState();
const[justifique25Dia2, setJustifique25Dia2]=useState();
const[justifique26Dia2, setJustifique26Dia2]=useState();
const[justifique27Dia2, setJustifique27Dia2]=useState();
const[justifique28Dia2, setJustifique28Dia2]=useState();
const[justifique29Dia2, setJustifique29Dia2]=useState();
const[justifique30Dia2, setJustifique30Dia2]=useState();
const[justifique31Dia2, setJustifique31Dia2]=useState();  

const[sonda1Dia2, setSonda1Dia2]=useState();
const[responsavel1Dia2, setResponsavel1Dia2]=useState();


//dia 3
const[selecione1Dia3, setSelecione1Dia3]=useState();
const[selecione2Dia3, setSelecione2Dia3]=useState();
const[selecione3Dia3, setSelecione3Dia3]=useState();
const[selecione4Dia3, setSelecione4Dia3]=useState();
const[selecione5Dia3, setSelecione5Dia3]=useState();
const[selecione6Dia3, setSelecione6Dia3]=useState();
const[selecione7Dia3, setSelecione7Dia3]=useState();
const[selecione8Dia3, setSelecione8Dia3]=useState();
const[selecione9Dia3, setSelecione9Dia3]=useState();
const[selecione10Dia3, setSelecione10Dia3]=useState();
const[selecione11Dia3, setSelecione11Dia3]=useState();
const[selecione12Dia3, setSelecione12Dia3]=useState();
const[selecione13Dia3, setSelecione13Dia3]=useState();
const[selecione14Dia3, setSelecione14Dia3]=useState();
const[selecione15Dia3, setSelecione15Dia3]=useState();
const[selecione16Dia3, setSelecione16Dia3]=useState();
const[selecione17Dia3, setSelecione17Dia3]=useState();
const[selecione18Dia3, setSelecione18Dia3]=useState();
const[selecione19Dia3, setSelecione19Dia3]=useState();
const[selecione20Dia3, setSelecione20Dia3]=useState();
const[selecione21Dia3, setSelecione21Dia3]=useState();
const[selecione22Dia3, setSelecione22Dia3]=useState();
const[selecione23Dia3, setSelecione23Dia3]=useState();
const[selecione24Dia3, setSelecione24Dia3]=useState();
const[selecione25Dia3, setSelecione25Dia3]=useState();
const[selecione26Dia3, setSelecione26Dia3]=useState();
const[selecione27Dia3, setSelecione27Dia3]=useState();
const[selecione28Dia3, setSelecione28Dia3]=useState();
const[selecione29Dia3, setSelecione29Dia3]=useState();
const[selecione30Dia3, setSelecione30Dia3]=useState();
const[selecione31Dia3, setSelecione31Dia3]=useState();

const[justifique1Dia3, setJustifique1Dia3]=useState();
const[justifique2Dia3, setJustifique2Dia3]=useState();
const[justifique3Dia3, setJustifique3Dia3]=useState();
const[justifique4Dia3, setJustifique4Dia3]=useState();
const[justifique5Dia3, setJustifique5Dia3]=useState();
const[justifique6Dia3, setJustifique6Dia3]=useState();
const[justifique7Dia3, setJustifique7Dia3]=useState();
const[justifique8Dia3, setJustifique8Dia3]=useState();
const[justifique9Dia3, setJustifique9Dia3]=useState();
const[justifique10Dia3, setJustifique10Dia3]=useState();
const[justifique11Dia3, setJustifique11Dia3]=useState();
const[justifique12Dia3, setJustifique12Dia3]=useState();
const[justifique13Dia3, setJustifique13Dia3]=useState();
const[justifique14Dia3, setJustifique14Dia3]=useState();
const[justifique15Dia3, setJustifique15Dia3]=useState();
const[justifique16Dia3, setJustifique16Dia3]=useState();
const[justifique17Dia3, setJustifique17Dia3]=useState();
const[justifique18Dia3, setJustifique18Dia3]=useState();
const[justifique19Dia3, setJustifique19Dia3]=useState();
const[justifique20Dia3, setJustifique20Dia3]=useState();
const[justifique21Dia3, setJustifique21Dia3]=useState();
const[justifique22Dia3, setJustifique22Dia3]=useState();
const[justifique23Dia3, setJustifique23Dia3]=useState();
const[justifique24Dia3, setJustifique24Dia3]=useState();
const[justifique25Dia3, setJustifique25Dia3]=useState();
const[justifique26Dia3, setJustifique26Dia3]=useState();
const[justifique27Dia3, setJustifique27Dia3]=useState();
const[justifique28Dia3, setJustifique28Dia3]=useState();
const[justifique29Dia3, setJustifique29Dia3]=useState();
const[justifique30Dia3, setJustifique30Dia3]=useState();
const[justifique31Dia3, setJustifique31Dia3]=useState();  

const[sonda1Dia3, setSonda1Dia3]=useState();
const[responsavel1Dia3, setResponsavel1Dia3]=useState();


//dia 4
const[selecione1Dia4, setSelecione1Dia4]=useState();
const[selecione2Dia4, setSelecione2Dia4]=useState();
const[selecione3Dia4, setSelecione3Dia4]=useState();
const[selecione4Dia4, setSelecione4Dia4]=useState();
const[selecione5Dia4, setSelecione5Dia4]=useState();
const[selecione6Dia4, setSelecione6Dia4]=useState();
const[selecione7Dia4, setSelecione7Dia4]=useState();
const[selecione8Dia4, setSelecione8Dia4]=useState();
const[selecione9Dia4, setSelecione9Dia4]=useState();
const[selecione10Dia4, setSelecione10Dia4]=useState();
const[selecione11Dia4, setSelecione11Dia4]=useState();
const[selecione12Dia4, setSelecione12Dia4]=useState();
const[selecione13Dia4, setSelecione13Dia4]=useState();
const[selecione14Dia4, setSelecione14Dia4]=useState();
const[selecione15Dia4, setSelecione15Dia4]=useState();
const[selecione16Dia4, setSelecione16Dia4]=useState();
const[selecione17Dia4, setSelecione17Dia4]=useState();
const[selecione18Dia4, setSelecione18Dia4]=useState();
const[selecione19Dia4, setSelecione19Dia4]=useState();
const[selecione20Dia4, setSelecione20Dia4]=useState();
const[selecione21Dia4, setSelecione21Dia4]=useState();
const[selecione22Dia4, setSelecione22Dia4]=useState();
const[selecione23Dia4, setSelecione23Dia4]=useState();
const[selecione24Dia4, setSelecione24Dia4]=useState();
const[selecione25Dia4, setSelecione25Dia4]=useState();
const[selecione26Dia4, setSelecione26Dia4]=useState();
const[selecione27Dia4, setSelecione27Dia4]=useState();
const[selecione28Dia4, setSelecione28Dia4]=useState();
const[selecione29Dia4, setSelecione29Dia4]=useState();
const[selecione30Dia4, setSelecione30Dia4]=useState();
const[selecione31Dia4, setSelecione31Dia4]=useState();

const[justifique1Dia4, setJustifique1Dia4]=useState();
const[justifique2Dia4, setJustifique2Dia4]=useState();
const[justifique3Dia4, setJustifique3Dia4]=useState();
const[justifique4Dia4, setJustifique4Dia4]=useState();
const[justifique5Dia4, setJustifique5Dia4]=useState();
const[justifique6Dia4, setJustifique6Dia4]=useState();
const[justifique7Dia4, setJustifique7Dia4]=useState();
const[justifique8Dia4, setJustifique8Dia4]=useState();
const[justifique9Dia4, setJustifique9Dia4]=useState();
const[justifique10Dia4, setJustifique10Dia4]=useState();
const[justifique11Dia4, setJustifique11Dia4]=useState();
const[justifique12Dia4, setJustifique12Dia4]=useState();
const[justifique13Dia4, setJustifique13Dia4]=useState();
const[justifique14Dia4, setJustifique14Dia4]=useState();
const[justifique15Dia4, setJustifique15Dia4]=useState();
const[justifique16Dia4, setJustifique16Dia4]=useState();
const[justifique17Dia4, setJustifique17Dia4]=useState();
const[justifique18Dia4, setJustifique18Dia4]=useState();
const[justifique19Dia4, setJustifique19Dia4]=useState();
const[justifique20Dia4, setJustifique20Dia4]=useState();
const[justifique21Dia4, setJustifique21Dia4]=useState();
const[justifique22Dia4, setJustifique22Dia4]=useState();
const[justifique23Dia4, setJustifique23Dia4]=useState();
const[justifique24Dia4, setJustifique24Dia4]=useState();
const[justifique25Dia4, setJustifique25Dia4]=useState();
const[justifique26Dia4, setJustifique26Dia4]=useState();
const[justifique27Dia4, setJustifique27Dia4]=useState();
const[justifique28Dia4, setJustifique28Dia4]=useState();
const[justifique29Dia4, setJustifique29Dia4]=useState();
const[justifique30Dia4, setJustifique30Dia4]=useState();
const[justifique31Dia4, setJustifique31Dia4]=useState();  

const[sonda1Dia4, setSonda1Dia4]=useState();
const[responsavel1Dia4, setResponsavel1Dia4]=useState();


//dia 5
const[selecione1Dia5, setSelecione1Dia5]=useState();
const[selecione2Dia5, setSelecione2Dia5]=useState();
const[selecione3Dia5, setSelecione3Dia5]=useState();
const[selecione4Dia5, setSelecione4Dia5]=useState();
const[selecione5Dia5, setSelecione5Dia5]=useState();
const[selecione6Dia5, setSelecione6Dia5]=useState();
const[selecione7Dia5, setSelecione7Dia5]=useState();
const[selecione8Dia5, setSelecione8Dia5]=useState();
const[selecione9Dia5, setSelecione9Dia5]=useState();
const[selecione10Dia5, setSelecione10Dia5]=useState();
const[selecione11Dia5, setSelecione11Dia5]=useState();
const[selecione12Dia5, setSelecione12Dia5]=useState();
const[selecione13Dia5, setSelecione13Dia5]=useState();
const[selecione14Dia5, setSelecione14Dia5]=useState();
const[selecione15Dia5, setSelecione15Dia5]=useState();
const[selecione16Dia5, setSelecione16Dia5]=useState();
const[selecione17Dia5, setSelecione17Dia5]=useState();
const[selecione18Dia5, setSelecione18Dia5]=useState();
const[selecione19Dia5, setSelecione19Dia5]=useState();
const[selecione20Dia5, setSelecione20Dia5]=useState();
const[selecione21Dia5, setSelecione21Dia5]=useState();
const[selecione22Dia5, setSelecione22Dia5]=useState();
const[selecione23Dia5, setSelecione23Dia5]=useState();
const[selecione24Dia5, setSelecione24Dia5]=useState();
const[selecione25Dia5, setSelecione25Dia5]=useState();
const[selecione26Dia5, setSelecione26Dia5]=useState();
const[selecione27Dia5, setSelecione27Dia5]=useState();
const[selecione28Dia5, setSelecione28Dia5]=useState();
const[selecione29Dia5, setSelecione29Dia5]=useState();
const[selecione30Dia5, setSelecione30Dia5]=useState();
const[selecione31Dia5, setSelecione31Dia5]=useState();

const[justifique1Dia5, setJustifique1Dia5]=useState();
const[justifique2Dia5, setJustifique2Dia5]=useState();
const[justifique3Dia5, setJustifique3Dia5]=useState();
const[justifique4Dia5, setJustifique4Dia5]=useState();
const[justifique5Dia5, setJustifique5Dia5]=useState();
const[justifique6Dia5, setJustifique6Dia5]=useState();
const[justifique7Dia5, setJustifique7Dia5]=useState();
const[justifique8Dia5, setJustifique8Dia5]=useState();
const[justifique9Dia5, setJustifique9Dia5]=useState();
const[justifique10Dia5, setJustifique10Dia5]=useState();
const[justifique11Dia5, setJustifique11Dia5]=useState();
const[justifique12Dia5, setJustifique12Dia5]=useState();
const[justifique13Dia5, setJustifique13Dia5]=useState();
const[justifique14Dia5, setJustifique14Dia5]=useState();
const[justifique15Dia5, setJustifique15Dia5]=useState();
const[justifique16Dia5, setJustifique16Dia5]=useState();
const[justifique17Dia5, setJustifique17Dia5]=useState();
const[justifique18Dia5, setJustifique18Dia5]=useState();
const[justifique19Dia5, setJustifique19Dia5]=useState();
const[justifique20Dia5, setJustifique20Dia5]=useState();
const[justifique21Dia5, setJustifique21Dia5]=useState();
const[justifique22Dia5, setJustifique22Dia5]=useState();
const[justifique23Dia5, setJustifique23Dia5]=useState();
const[justifique24Dia5, setJustifique24Dia5]=useState();
const[justifique25Dia5, setJustifique25Dia5]=useState();
const[justifique26Dia5, setJustifique26Dia5]=useState();
const[justifique27Dia5, setJustifique27Dia5]=useState();
const[justifique28Dia5, setJustifique28Dia5]=useState();
const[justifique29Dia5, setJustifique29Dia5]=useState();
const[justifique30Dia5, setJustifique30Dia5]=useState();
const[justifique31Dia5, setJustifique31Dia5]=useState();  

const[sonda1Dia5, setSonda1Dia5]=useState();
const[responsavel1Dia5, setResponsavel1Dia5]=useState();


//dia 6
const[selecione1Dia6, setSelecione1Dia6]=useState();
const[selecione2Dia6, setSelecione2Dia6]=useState();
const[selecione3Dia6, setSelecione3Dia6]=useState();
const[selecione4Dia6, setSelecione4Dia6]=useState();
const[selecione5Dia6, setSelecione5Dia6]=useState();
const[selecione6Dia6, setSelecione6Dia6]=useState();
const[selecione7Dia6, setSelecione7Dia6]=useState();
const[selecione8Dia6, setSelecione8Dia6]=useState();
const[selecione9Dia6, setSelecione9Dia6]=useState();
const[selecione10Dia6, setSelecione10Dia6]=useState();
const[selecione11Dia6, setSelecione11Dia6]=useState();
const[selecione12Dia6, setSelecione12Dia6]=useState();
const[selecione13Dia6, setSelecione13Dia6]=useState();
const[selecione14Dia6, setSelecione14Dia6]=useState();
const[selecione15Dia6, setSelecione15Dia6]=useState();
const[selecione16Dia6, setSelecione16Dia6]=useState();
const[selecione17Dia6, setSelecione17Dia6]=useState();
const[selecione18Dia6, setSelecione18Dia6]=useState();
const[selecione19Dia6, setSelecione19Dia6]=useState();
const[selecione20Dia6, setSelecione20Dia6]=useState();
const[selecione21Dia6, setSelecione21Dia6]=useState();
const[selecione22Dia6, setSelecione22Dia6]=useState();
const[selecione23Dia6, setSelecione23Dia6]=useState();
const[selecione24Dia6, setSelecione24Dia6]=useState();
const[selecione25Dia6, setSelecione25Dia6]=useState();
const[selecione26Dia6, setSelecione26Dia6]=useState();
const[selecione27Dia6, setSelecione27Dia6]=useState();
const[selecione28Dia6, setSelecione28Dia6]=useState();
const[selecione29Dia6, setSelecione29Dia6]=useState();
const[selecione30Dia6, setSelecione30Dia6]=useState();
const[selecione31Dia6, setSelecione31Dia6]=useState();

const[justifique1Dia6, setJustifique1Dia6]=useState();
const[justifique2Dia6, setJustifique2Dia6]=useState();
const[justifique3Dia6, setJustifique3Dia6]=useState();
const[justifique4Dia6, setJustifique4Dia6]=useState();
const[justifique5Dia6, setJustifique5Dia6]=useState();
const[justifique6Dia6, setJustifique6Dia6]=useState();
const[justifique7Dia6, setJustifique7Dia6]=useState();
const[justifique8Dia6, setJustifique8Dia6]=useState();
const[justifique9Dia6, setJustifique9Dia6]=useState();
const[justifique10Dia6, setJustifique10Dia6]=useState();
const[justifique11Dia6, setJustifique11Dia6]=useState();
const[justifique12Dia6, setJustifique12Dia6]=useState();
const[justifique13Dia6, setJustifique13Dia6]=useState();
const[justifique14Dia6, setJustifique14Dia6]=useState();
const[justifique15Dia6, setJustifique15Dia6]=useState();
const[justifique16Dia6, setJustifique16Dia6]=useState();
const[justifique17Dia6, setJustifique17Dia6]=useState();
const[justifique18Dia6, setJustifique18Dia6]=useState();
const[justifique19Dia6, setJustifique19Dia6]=useState();
const[justifique20Dia6, setJustifique20Dia6]=useState();
const[justifique21Dia6, setJustifique21Dia6]=useState();
const[justifique22Dia6, setJustifique22Dia6]=useState();
const[justifique23Dia6, setJustifique23Dia6]=useState();
const[justifique24Dia6, setJustifique24Dia6]=useState();
const[justifique25Dia6, setJustifique25Dia6]=useState();
const[justifique26Dia6, setJustifique26Dia6]=useState();
const[justifique27Dia6, setJustifique27Dia6]=useState();
const[justifique28Dia6, setJustifique28Dia6]=useState();
const[justifique29Dia6, setJustifique29Dia6]=useState();
const[justifique30Dia6, setJustifique30Dia6]=useState();
const[justifique31Dia6, setJustifique31Dia6]=useState();  

const[sonda1Dia6, setSonda1Dia6]=useState();
const[responsavel1Dia6, setResponsavel1Dia6]=useState();


//dia 7
const[selecione1Dia7, setSelecione1Dia7]=useState();
const[selecione2Dia7, setSelecione2Dia7]=useState();
const[selecione3Dia7, setSelecione3Dia7]=useState();
const[selecione4Dia7, setSelecione4Dia7]=useState();
const[selecione5Dia7, setSelecione5Dia7]=useState();
const[selecione6Dia7, setSelecione6Dia7]=useState();
const[selecione7Dia7, setSelecione7Dia7]=useState();
const[selecione8Dia7, setSelecione8Dia7]=useState();
const[selecione9Dia7, setSelecione9Dia7]=useState();
const[selecione10Dia7, setSelecione10Dia7]=useState();
const[selecione11Dia7, setSelecione11Dia7]=useState();
const[selecione12Dia7, setSelecione12Dia7]=useState();
const[selecione13Dia7, setSelecione13Dia7]=useState();
const[selecione14Dia7, setSelecione14Dia7]=useState();
const[selecione15Dia7, setSelecione15Dia7]=useState();
const[selecione16Dia7, setSelecione16Dia7]=useState();
const[selecione17Dia7, setSelecione17Dia7]=useState();
const[selecione18Dia7, setSelecione18Dia7]=useState();
const[selecione19Dia7, setSelecione19Dia7]=useState();
const[selecione20Dia7, setSelecione20Dia7]=useState();
const[selecione21Dia7, setSelecione21Dia7]=useState();
const[selecione22Dia7, setSelecione22Dia7]=useState();
const[selecione23Dia7, setSelecione23Dia7]=useState();
const[selecione24Dia7, setSelecione24Dia7]=useState();
const[selecione25Dia7, setSelecione25Dia7]=useState();
const[selecione26Dia7, setSelecione26Dia7]=useState();
const[selecione27Dia7, setSelecione27Dia7]=useState();
const[selecione28Dia7, setSelecione28Dia7]=useState();
const[selecione29Dia7, setSelecione29Dia7]=useState();
const[selecione30Dia7, setSelecione30Dia7]=useState();
const[selecione31Dia7, setSelecione31Dia7]=useState();

const[justifique1Dia7, setJustifique1Dia7]=useState();
const[justifique2Dia7, setJustifique2Dia7]=useState();
const[justifique3Dia7, setJustifique3Dia7]=useState();
const[justifique4Dia7, setJustifique4Dia7]=useState();
const[justifique5Dia7, setJustifique5Dia7]=useState();
const[justifique6Dia7, setJustifique6Dia7]=useState();
const[justifique7Dia7, setJustifique7Dia7]=useState();
const[justifique8Dia7, setJustifique8Dia7]=useState();
const[justifique9Dia7, setJustifique9Dia7]=useState();
const[justifique10Dia7, setJustifique10Dia7]=useState();
const[justifique11Dia7, setJustifique11Dia7]=useState();
const[justifique12Dia7, setJustifique12Dia7]=useState();
const[justifique13Dia7, setJustifique13Dia7]=useState();
const[justifique14Dia7, setJustifique14Dia7]=useState();
const[justifique15Dia7, setJustifique15Dia7]=useState();
const[justifique16Dia7, setJustifique16Dia7]=useState();
const[justifique17Dia7, setJustifique17Dia7]=useState();
const[justifique18Dia7, setJustifique18Dia7]=useState();
const[justifique19Dia7, setJustifique19Dia7]=useState();
const[justifique20Dia7, setJustifique20Dia7]=useState();
const[justifique21Dia7, setJustifique21Dia7]=useState();
const[justifique22Dia7, setJustifique22Dia7]=useState();
const[justifique23Dia7, setJustifique23Dia7]=useState();
const[justifique24Dia7, setJustifique24Dia7]=useState();
const[justifique25Dia7, setJustifique25Dia7]=useState();
const[justifique26Dia7, setJustifique26Dia7]=useState();
const[justifique27Dia7, setJustifique27Dia7]=useState();
const[justifique28Dia7, setJustifique28Dia7]=useState();
const[justifique29Dia7, setJustifique29Dia7]=useState();
const[justifique30Dia7, setJustifique30Dia7]=useState();
const[justifique31Dia7, setJustifique31Dia7]=useState();  

const[sonda1Dia7, setSonda1Dia7]=useState();
const[responsavel1Dia7, setResponsavel1Dia7]=useState();


//dia 8
const[selecione1Dia8, setSelecione1Dia8]=useState();
const[selecione2Dia8, setSelecione2Dia8]=useState();
const[selecione3Dia8, setSelecione3Dia8]=useState();
const[selecione4Dia8, setSelecione4Dia8]=useState();
const[selecione5Dia8, setSelecione5Dia8]=useState();
const[selecione6Dia8, setSelecione6Dia8]=useState();
const[selecione7Dia8, setSelecione7Dia8]=useState();
const[selecione8Dia8, setSelecione8Dia8]=useState();
const[selecione9Dia8, setSelecione9Dia8]=useState();
const[selecione10Dia8, setSelecione10Dia8]=useState();
const[selecione11Dia8, setSelecione11Dia8]=useState();
const[selecione12Dia8, setSelecione12Dia8]=useState();
const[selecione13Dia8, setSelecione13Dia8]=useState();
const[selecione14Dia8, setSelecione14Dia8]=useState();
const[selecione15Dia8, setSelecione15Dia8]=useState();
const[selecione16Dia8, setSelecione16Dia8]=useState();
const[selecione17Dia8, setSelecione17Dia8]=useState();
const[selecione18Dia8, setSelecione18Dia8]=useState();
const[selecione19Dia8, setSelecione19Dia8]=useState();
const[selecione20Dia8, setSelecione20Dia8]=useState();
const[selecione21Dia8, setSelecione21Dia8]=useState();
const[selecione22Dia8, setSelecione22Dia8]=useState();
const[selecione23Dia8, setSelecione23Dia8]=useState();
const[selecione24Dia8, setSelecione24Dia8]=useState();
const[selecione25Dia8, setSelecione25Dia8]=useState();
const[selecione26Dia8, setSelecione26Dia8]=useState();
const[selecione27Dia8, setSelecione27Dia8]=useState();
const[selecione28Dia8, setSelecione28Dia8]=useState();
const[selecione29Dia8, setSelecione29Dia8]=useState();
const[selecione30Dia8, setSelecione30Dia8]=useState();
const[selecione31Dia8, setSelecione31Dia8]=useState();

const[justifique1Dia8, setJustifique1Dia8]=useState();
const[justifique2Dia8, setJustifique2Dia8]=useState();
const[justifique3Dia8, setJustifique3Dia8]=useState();
const[justifique4Dia8, setJustifique4Dia8]=useState();
const[justifique5Dia8, setJustifique5Dia8]=useState();
const[justifique6Dia8, setJustifique6Dia8]=useState();
const[justifique7Dia8, setJustifique7Dia8]=useState();
const[justifique8Dia8, setJustifique8Dia8]=useState();
const[justifique9Dia8, setJustifique9Dia8]=useState();
const[justifique10Dia8, setJustifique10Dia8]=useState();
const[justifique11Dia8, setJustifique11Dia8]=useState();
const[justifique12Dia8, setJustifique12Dia8]=useState();
const[justifique13Dia8, setJustifique13Dia8]=useState();
const[justifique14Dia8, setJustifique14Dia8]=useState();
const[justifique15Dia8, setJustifique15Dia8]=useState();
const[justifique16Dia8, setJustifique16Dia8]=useState();
const[justifique17Dia8, setJustifique17Dia8]=useState();
const[justifique18Dia8, setJustifique18Dia8]=useState();
const[justifique19Dia8, setJustifique19Dia8]=useState();
const[justifique20Dia8, setJustifique20Dia8]=useState();
const[justifique21Dia8, setJustifique21Dia8]=useState();
const[justifique22Dia8, setJustifique22Dia8]=useState();
const[justifique23Dia8, setJustifique23Dia8]=useState();
const[justifique24Dia8, setJustifique24Dia8]=useState();
const[justifique25Dia8, setJustifique25Dia8]=useState();
const[justifique26Dia8, setJustifique26Dia8]=useState();
const[justifique27Dia8, setJustifique27Dia8]=useState();
const[justifique28Dia8, setJustifique28Dia8]=useState();
const[justifique29Dia8, setJustifique29Dia8]=useState();
const[justifique30Dia8, setJustifique30Dia8]=useState();
const[justifique31Dia8, setJustifique31Dia8]=useState();  

const[sonda1Dia8, setSonda1Dia8]=useState();
const[responsavel1Dia8, setResponsavel1Dia8]=useState();


//dia 9
const[selecione1Dia9, setSelecione1Dia9]=useState();
const[selecione2Dia9, setSelecione2Dia9]=useState();
const[selecione3Dia9, setSelecione3Dia9]=useState();
const[selecione4Dia9, setSelecione4Dia9]=useState();
const[selecione5Dia9, setSelecione5Dia9]=useState();
const[selecione6Dia9, setSelecione6Dia9]=useState();
const[selecione7Dia9, setSelecione7Dia9]=useState();
const[selecione8Dia9, setSelecione8Dia9]=useState();
const[selecione9Dia9, setSelecione9Dia9]=useState();
const[selecione10Dia9, setSelecione10Dia9]=useState();
const[selecione11Dia9, setSelecione11Dia9]=useState();
const[selecione12Dia9, setSelecione12Dia9]=useState();
const[selecione13Dia9, setSelecione13Dia9]=useState();
const[selecione14Dia9, setSelecione14Dia9]=useState();
const[selecione15Dia9, setSelecione15Dia9]=useState();
const[selecione16Dia9, setSelecione16Dia9]=useState();
const[selecione17Dia9, setSelecione17Dia9]=useState();
const[selecione18Dia9, setSelecione18Dia9]=useState();
const[selecione19Dia9, setSelecione19Dia9]=useState();
const[selecione20Dia9, setSelecione20Dia9]=useState();
const[selecione21Dia9, setSelecione21Dia9]=useState();
const[selecione22Dia9, setSelecione22Dia9]=useState();
const[selecione23Dia9, setSelecione23Dia9]=useState();
const[selecione24Dia9, setSelecione24Dia9]=useState();
const[selecione25Dia9, setSelecione25Dia9]=useState();
const[selecione26Dia9, setSelecione26Dia9]=useState();
const[selecione27Dia9, setSelecione27Dia9]=useState();
const[selecione28Dia9, setSelecione28Dia9]=useState();
const[selecione29Dia9, setSelecione29Dia9]=useState();
const[selecione30Dia9, setSelecione30Dia9]=useState();
const[selecione31Dia9, setSelecione31Dia9]=useState();

const[justifique1Dia9, setJustifique1Dia9]=useState();
const[justifique2Dia9, setJustifique2Dia9]=useState();
const[justifique3Dia9, setJustifique3Dia9]=useState();
const[justifique4Dia9, setJustifique4Dia9]=useState();
const[justifique5Dia9, setJustifique5Dia9]=useState();
const[justifique6Dia9, setJustifique6Dia9]=useState();
const[justifique7Dia9, setJustifique7Dia9]=useState();
const[justifique8Dia9, setJustifique8Dia9]=useState();
const[justifique9Dia9, setJustifique9Dia9]=useState();
const[justifique10Dia9, setJustifique10Dia9]=useState();
const[justifique11Dia9, setJustifique11Dia9]=useState();
const[justifique12Dia9, setJustifique12Dia9]=useState();
const[justifique13Dia9, setJustifique13Dia9]=useState();
const[justifique14Dia9, setJustifique14Dia9]=useState();
const[justifique15Dia9, setJustifique15Dia9]=useState();
const[justifique16Dia9, setJustifique16Dia9]=useState();
const[justifique17Dia9, setJustifique17Dia9]=useState();
const[justifique18Dia9, setJustifique18Dia9]=useState();
const[justifique19Dia9, setJustifique19Dia9]=useState();
const[justifique20Dia9, setJustifique20Dia9]=useState();
const[justifique21Dia9, setJustifique21Dia9]=useState();
const[justifique22Dia9, setJustifique22Dia9]=useState();
const[justifique23Dia9, setJustifique23Dia9]=useState();
const[justifique24Dia9, setJustifique24Dia9]=useState();
const[justifique25Dia9, setJustifique25Dia9]=useState();
const[justifique26Dia9, setJustifique26Dia9]=useState();
const[justifique27Dia9, setJustifique27Dia9]=useState();
const[justifique28Dia9, setJustifique28Dia9]=useState();
const[justifique29Dia9, setJustifique29Dia9]=useState();
const[justifique30Dia9, setJustifique30Dia9]=useState();
const[justifique31Dia9, setJustifique31Dia9]=useState();  

const[sonda1Dia9, setSonda1Dia9]=useState();
const[responsavel1Dia9, setResponsavel1Dia9]=useState();


//dia 10
const[selecione1Dia10, setSelecione1Dia10]=useState();
const[selecione2Dia10, setSelecione2Dia10]=useState();
const[selecione3Dia10, setSelecione3Dia10]=useState();
const[selecione4Dia10, setSelecione4Dia10]=useState();
const[selecione5Dia10, setSelecione5Dia10]=useState();
const[selecione6Dia10, setSelecione6Dia10]=useState();
const[selecione7Dia10, setSelecione7Dia10]=useState();
const[selecione8Dia10, setSelecione8Dia10]=useState();
const[selecione9Dia10, setSelecione9Dia10]=useState();
const[selecione10Dia10, setSelecione10Dia10]=useState();
const[selecione11Dia10, setSelecione11Dia10]=useState();
const[selecione12Dia10, setSelecione12Dia10]=useState();
const[selecione13Dia10, setSelecione13Dia10]=useState();
const[selecione14Dia10, setSelecione14Dia10]=useState();
const[selecione15Dia10, setSelecione15Dia10]=useState();
const[selecione16Dia10, setSelecione16Dia10]=useState();
const[selecione17Dia10, setSelecione17Dia10]=useState();
const[selecione18Dia10, setSelecione18Dia10]=useState();
const[selecione19Dia10, setSelecione19Dia10]=useState();
const[selecione20Dia10, setSelecione20Dia10]=useState();
const[selecione21Dia10, setSelecione21Dia10]=useState();
const[selecione22Dia10, setSelecione22Dia10]=useState();
const[selecione23Dia10, setSelecione23Dia10]=useState();
const[selecione24Dia10, setSelecione24Dia10]=useState();
const[selecione25Dia10, setSelecione25Dia10]=useState();
const[selecione26Dia10, setSelecione26Dia10]=useState();
const[selecione27Dia10, setSelecione27Dia10]=useState();
const[selecione28Dia10, setSelecione28Dia10]=useState();
const[selecione29Dia10, setSelecione29Dia10]=useState();
const[selecione30Dia10, setSelecione30Dia10]=useState();
const[selecione31Dia10, setSelecione31Dia10]=useState();

const[justifique1Dia10, setJustifique1Dia10]=useState();
const[justifique2Dia10, setJustifique2Dia10]=useState();
const[justifique3Dia10, setJustifique3Dia10]=useState();
const[justifique4Dia10, setJustifique4Dia10]=useState();
const[justifique5Dia10, setJustifique5Dia10]=useState();
const[justifique6Dia10, setJustifique6Dia10]=useState();
const[justifique7Dia10, setJustifique7Dia10]=useState();
const[justifique8Dia10, setJustifique8Dia10]=useState();
const[justifique9Dia10, setJustifique9Dia10]=useState();
const[justifique10Dia10, setJustifique10Dia10]=useState();
const[justifique11Dia10, setJustifique11Dia10]=useState();
const[justifique12Dia10, setJustifique12Dia10]=useState();
const[justifique13Dia10, setJustifique13Dia10]=useState();
const[justifique14Dia10, setJustifique14Dia10]=useState();
const[justifique15Dia10, setJustifique15Dia10]=useState();
const[justifique16Dia10, setJustifique16Dia10]=useState();
const[justifique17Dia10, setJustifique17Dia10]=useState();
const[justifique18Dia10, setJustifique18Dia10]=useState();
const[justifique19Dia10, setJustifique19Dia10]=useState();
const[justifique20Dia10, setJustifique20Dia10]=useState();
const[justifique21Dia10, setJustifique21Dia10]=useState();
const[justifique22Dia10, setJustifique22Dia10]=useState();
const[justifique23Dia10, setJustifique23Dia10]=useState();
const[justifique24Dia10, setJustifique24Dia10]=useState();
const[justifique25Dia10, setJustifique25Dia10]=useState();
const[justifique26Dia10, setJustifique26Dia10]=useState();
const[justifique27Dia10, setJustifique27Dia10]=useState();
const[justifique28Dia10, setJustifique28Dia10]=useState();
const[justifique29Dia10, setJustifique29Dia10]=useState();
const[justifique30Dia10, setJustifique30Dia10]=useState();
const[justifique31Dia10, setJustifique31Dia10]=useState();  

const[sonda1Dia10, setSonda1Dia10]=useState();
const[responsavel1Dia10, setResponsavel1Dia10]=useState();


//dia11
const[selecione1Dia11, setSelecione1Dia11]=useState();
const[selecione2Dia11, setSelecione2Dia11]=useState();
const[selecione3Dia11, setSelecione3Dia11]=useState();
const[selecione4Dia11, setSelecione4Dia11]=useState();
const[selecione5Dia11, setSelecione5Dia11]=useState();
const[selecione6Dia11, setSelecione6Dia11]=useState();
const[selecione7Dia11, setSelecione7Dia11]=useState();
const[selecione8Dia11, setSelecione8Dia11]=useState();
const[selecione9Dia11, setSelecione9Dia11]=useState();
const[selecione10Dia11, setSelecione10Dia11]=useState();
const[selecione11Dia11, setSelecione11Dia11]=useState();
const[selecione12Dia11, setSelecione12Dia11]=useState();
const[selecione13Dia11, setSelecione13Dia11]=useState();
const[selecione14Dia11, setSelecione14Dia11]=useState();
const[selecione15Dia11, setSelecione15Dia11]=useState();
const[selecione16Dia11, setSelecione16Dia11]=useState();
const[selecione17Dia11, setSelecione17Dia11]=useState();
const[selecione18Dia11, setSelecione18Dia11]=useState();
const[selecione19Dia11, setSelecione19Dia11]=useState();
const[selecione20Dia11, setSelecione20Dia11]=useState();
const[selecione21Dia11, setSelecione21Dia11]=useState();
const[selecione22Dia11, setSelecione22Dia11]=useState();
const[selecione23Dia11, setSelecione23Dia11]=useState();
const[selecione24Dia11, setSelecione24Dia11]=useState();
const[selecione25Dia11, setSelecione25Dia11]=useState();
const[selecione26Dia11, setSelecione26Dia11]=useState();
const[selecione27Dia11, setSelecione27Dia11]=useState();
const[selecione28Dia11, setSelecione28Dia11]=useState();
const[selecione29Dia11, setSelecione29Dia11]=useState();
const[selecione30Dia11, setSelecione30Dia11]=useState();
const[selecione31Dia11, setSelecione31Dia11]=useState();

const[justifique1Dia11, setJustifique1Dia11]=useState();
const[justifique2Dia11, setJustifique2Dia11]=useState();
const[justifique3Dia11, setJustifique3Dia11]=useState();
const[justifique4Dia11, setJustifique4Dia11]=useState();
const[justifique5Dia11, setJustifique5Dia11]=useState();
const[justifique6Dia11, setJustifique6Dia11]=useState();
const[justifique7Dia11, setJustifique7Dia11]=useState();
const[justifique8Dia11, setJustifique8Dia11]=useState();
const[justifique9Dia11, setJustifique9Dia11]=useState();
const[justifique10Dia11, setJustifique10Dia11]=useState();
const[justifique11Dia11, setJustifique11Dia11]=useState();
const[justifique12Dia11, setJustifique12Dia11]=useState();
const[justifique13Dia11, setJustifique13Dia11]=useState();
const[justifique14Dia11, setJustifique14Dia11]=useState();
const[justifique15Dia11, setJustifique15Dia11]=useState();
const[justifique16Dia11, setJustifique16Dia11]=useState();
const[justifique17Dia11, setJustifique17Dia11]=useState();
const[justifique18Dia11, setJustifique18Dia11]=useState();
const[justifique19Dia11, setJustifique19Dia11]=useState();
const[justifique20Dia11, setJustifique20Dia11]=useState();
const[justifique21Dia11, setJustifique21Dia11]=useState();
const[justifique22Dia11, setJustifique22Dia11]=useState();
const[justifique23Dia11, setJustifique23Dia11]=useState();
const[justifique24Dia11, setJustifique24Dia11]=useState();
const[justifique25Dia11, setJustifique25Dia11]=useState();
const[justifique26Dia11, setJustifique26Dia11]=useState();
const[justifique27Dia11, setJustifique27Dia11]=useState();
const[justifique28Dia11, setJustifique28Dia11]=useState();
const[justifique29Dia11, setJustifique29Dia11]=useState();
const[justifique30Dia11, setJustifique30Dia11]=useState();
const[justifique31Dia11, setJustifique31Dia11]=useState();  

const[sonda1Dia11, setSonda1Dia11]=useState();
const[responsavel1Dia11, setResponsavel1Dia11]=useState();


//dia 12
const[selecione1Dia12, setSelecione1Dia12]=useState();
const[selecione2Dia12, setSelecione2Dia12]=useState();
const[selecione3Dia12, setSelecione3Dia12]=useState();
const[selecione4Dia12, setSelecione4Dia12]=useState();
const[selecione5Dia12, setSelecione5Dia12]=useState();
const[selecione6Dia12, setSelecione6Dia12]=useState();
const[selecione7Dia12, setSelecione7Dia12]=useState();
const[selecione8Dia12, setSelecione8Dia12]=useState();
const[selecione9Dia12, setSelecione9Dia12]=useState();
const[selecione10Dia12, setSelecione10Dia12]=useState();
const[selecione11Dia12, setSelecione11Dia12]=useState();
const[selecione12Dia12, setSelecione12Dia12]=useState();
const[selecione13Dia12, setSelecione13Dia12]=useState();
const[selecione14Dia12, setSelecione14Dia12]=useState();
const[selecione15Dia12, setSelecione15Dia12]=useState();
const[selecione16Dia12, setSelecione16Dia12]=useState();
const[selecione17Dia12, setSelecione17Dia12]=useState();
const[selecione18Dia12, setSelecione18Dia12]=useState();
const[selecione19Dia12, setSelecione19Dia12]=useState();
const[selecione20Dia12, setSelecione20Dia12]=useState();
const[selecione21Dia12, setSelecione21Dia12]=useState();
const[selecione22Dia12, setSelecione22Dia12]=useState();
const[selecione23Dia12, setSelecione23Dia12]=useState();
const[selecione24Dia12, setSelecione24Dia12]=useState();
const[selecione25Dia12, setSelecione25Dia12]=useState();
const[selecione26Dia12, setSelecione26Dia12]=useState();
const[selecione27Dia12, setSelecione27Dia12]=useState();
const[selecione28Dia12, setSelecione28Dia12]=useState();
const[selecione29Dia12, setSelecione29Dia12]=useState();
const[selecione30Dia12, setSelecione30Dia12]=useState();
const[selecione31Dia12, setSelecione31Dia12]=useState();

const[justifique1Dia12, setJustifique1Dia12]=useState();
const[justifique2Dia12, setJustifique2Dia12]=useState();
const[justifique3Dia12, setJustifique3Dia12]=useState();
const[justifique4Dia12, setJustifique4Dia12]=useState();
const[justifique5Dia12, setJustifique5Dia12]=useState();
const[justifique6Dia12, setJustifique6Dia12]=useState();
const[justifique7Dia12, setJustifique7Dia12]=useState();
const[justifique8Dia12, setJustifique8Dia12]=useState();
const[justifique9Dia12, setJustifique9Dia12]=useState();
const[justifique10Dia12, setJustifique10Dia12]=useState();
const[justifique11Dia12, setJustifique11Dia12]=useState();
const[justifique12Dia12, setJustifique12Dia12]=useState();
const[justifique13Dia12, setJustifique13Dia12]=useState();
const[justifique14Dia12, setJustifique14Dia12]=useState();
const[justifique15Dia12, setJustifique15Dia12]=useState();
const[justifique16Dia12, setJustifique16Dia12]=useState();
const[justifique17Dia12, setJustifique17Dia12]=useState();
const[justifique18Dia12, setJustifique18Dia12]=useState();
const[justifique19Dia12, setJustifique19Dia12]=useState();
const[justifique20Dia12, setJustifique20Dia12]=useState();
const[justifique21Dia12, setJustifique21Dia12]=useState();
const[justifique22Dia12, setJustifique22Dia12]=useState();
const[justifique23Dia12, setJustifique23Dia12]=useState();
const[justifique24Dia12, setJustifique24Dia12]=useState();
const[justifique25Dia12, setJustifique25Dia12]=useState();
const[justifique26Dia12, setJustifique26Dia12]=useState();
const[justifique27Dia12, setJustifique27Dia12]=useState();
const[justifique28Dia12, setJustifique28Dia12]=useState();
const[justifique29Dia12, setJustifique29Dia12]=useState();
const[justifique30Dia12, setJustifique30Dia12]=useState();
const[justifique31Dia12, setJustifique31Dia12]=useState();  

const[sonda1Dia12, setSonda1Dia12]=useState();
const[responsavel1Dia12, setResponsavel1Dia12]=useState();


//dia 13
const[selecione1Dia13, setSelecione1Dia13]=useState();
const[selecione2Dia13, setSelecione2Dia13]=useState();
const[selecione3Dia13, setSelecione3Dia13]=useState();
const[selecione4Dia13, setSelecione4Dia13]=useState();
const[selecione5Dia13, setSelecione5Dia13]=useState();
const[selecione6Dia13, setSelecione6Dia13]=useState();
const[selecione7Dia13, setSelecione7Dia13]=useState();
const[selecione8Dia13, setSelecione8Dia13]=useState();
const[selecione9Dia13, setSelecione9Dia13]=useState();
const[selecione10Dia13, setSelecione10Dia13]=useState();
const[selecione11Dia13, setSelecione11Dia13]=useState();
const[selecione12Dia13, setSelecione12Dia13]=useState();
const[selecione13Dia13, setSelecione13Dia13]=useState();
const[selecione14Dia13, setSelecione14Dia13]=useState();
const[selecione15Dia13, setSelecione15Dia13]=useState();
const[selecione16Dia13, setSelecione16Dia13]=useState();
const[selecione17Dia13, setSelecione17Dia13]=useState();
const[selecione18Dia13, setSelecione18Dia13]=useState();
const[selecione19Dia13, setSelecione19Dia13]=useState();
const[selecione20Dia13, setSelecione20Dia13]=useState();
const[selecione21Dia13, setSelecione21Dia13]=useState();
const[selecione22Dia13, setSelecione22Dia13]=useState();
const[selecione23Dia13, setSelecione23Dia13]=useState();
const[selecione24Dia13, setSelecione24Dia13]=useState();
const[selecione25Dia13, setSelecione25Dia13]=useState();
const[selecione26Dia13, setSelecione26Dia13]=useState();
const[selecione27Dia13, setSelecione27Dia13]=useState();
const[selecione28Dia13, setSelecione28Dia13]=useState();
const[selecione29Dia13, setSelecione29Dia13]=useState();
const[selecione30Dia13, setSelecione30Dia13]=useState();
const[selecione31Dia13, setSelecione31Dia13]=useState();

const[justifique1Dia13, setJustifique1Dia13]=useState();
const[justifique2Dia13, setJustifique2Dia13]=useState();
const[justifique3Dia13, setJustifique3Dia13]=useState();
const[justifique4Dia13, setJustifique4Dia13]=useState();
const[justifique5Dia13, setJustifique5Dia13]=useState();
const[justifique6Dia13, setJustifique6Dia13]=useState();
const[justifique7Dia13, setJustifique7Dia13]=useState();
const[justifique8Dia13, setJustifique8Dia13]=useState();
const[justifique9Dia13, setJustifique9Dia13]=useState();
const[justifique10Dia13, setJustifique10Dia13]=useState();
const[justifique11Dia13, setJustifique11Dia13]=useState();
const[justifique12Dia13, setJustifique12Dia13]=useState();
const[justifique13Dia13, setJustifique13Dia13]=useState();
const[justifique14Dia13, setJustifique14Dia13]=useState();
const[justifique15Dia13, setJustifique15Dia13]=useState();
const[justifique16Dia13, setJustifique16Dia13]=useState();
const[justifique17Dia13, setJustifique17Dia13]=useState();
const[justifique18Dia13, setJustifique18Dia13]=useState();
const[justifique19Dia13, setJustifique19Dia13]=useState();
const[justifique20Dia13, setJustifique20Dia13]=useState();
const[justifique21Dia13, setJustifique21Dia13]=useState();
const[justifique22Dia13, setJustifique22Dia13]=useState();
const[justifique23Dia13, setJustifique23Dia13]=useState();
const[justifique24Dia13, setJustifique24Dia13]=useState();
const[justifique25Dia13, setJustifique25Dia13]=useState();
const[justifique26Dia13, setJustifique26Dia13]=useState();
const[justifique27Dia13, setJustifique27Dia13]=useState();
const[justifique28Dia13, setJustifique28Dia13]=useState();
const[justifique29Dia13, setJustifique29Dia13]=useState();
const[justifique30Dia13, setJustifique30Dia13]=useState();
const[justifique31Dia13, setJustifique31Dia13]=useState();  

const[sonda1Dia13, setSonda1Dia13]=useState();
const[responsavel1Dia13, setResponsavel1Dia13]=useState();


//dia 14   
const[selecione1Dia14, setSelecione1Dia14]=useState();
const[selecione2Dia14, setSelecione2Dia14]=useState();
const[selecione3Dia14, setSelecione3Dia14]=useState();
const[selecione4Dia14, setSelecione4Dia14]=useState();
const[selecione5Dia14, setSelecione5Dia14]=useState();
const[selecione6Dia14, setSelecione6Dia14]=useState();
const[selecione7Dia14, setSelecione7Dia14]=useState();
const[selecione8Dia14, setSelecione8Dia14]=useState();
const[selecione9Dia14, setSelecione9Dia14]=useState();
const[selecione10Dia14, setSelecione10Dia14]=useState();
const[selecione11Dia14, setSelecione11Dia14]=useState();
const[selecione12Dia14, setSelecione12Dia14]=useState();
const[selecione13Dia14, setSelecione13Dia14]=useState();
const[selecione14Dia14, setSelecione14Dia14]=useState();
const[selecione15Dia14, setSelecione15Dia14]=useState();
const[selecione16Dia14, setSelecione16Dia14]=useState();
const[selecione17Dia14, setSelecione17Dia14]=useState();
const[selecione18Dia14, setSelecione18Dia14]=useState();
const[selecione19Dia14, setSelecione19Dia14]=useState();
const[selecione20Dia14, setSelecione20Dia14]=useState();
const[selecione21Dia14, setSelecione21Dia14]=useState();
const[selecione22Dia14, setSelecione22Dia14]=useState();
const[selecione23Dia14, setSelecione23Dia14]=useState();
const[selecione24Dia14, setSelecione24Dia14]=useState();
const[selecione25Dia14, setSelecione25Dia14]=useState();
const[selecione26Dia14, setSelecione26Dia14]=useState();
const[selecione27Dia14, setSelecione27Dia14]=useState();
const[selecione28Dia14, setSelecione28Dia14]=useState();
const[selecione29Dia14, setSelecione29Dia14]=useState();
const[selecione30Dia14, setSelecione30Dia14]=useState();
const[selecione31Dia14, setSelecione31Dia14]=useState();

const[justifique1Dia14, setJustifique1Dia14]=useState();
const[justifique2Dia14, setJustifique2Dia14]=useState();
const[justifique3Dia14, setJustifique3Dia14]=useState();
const[justifique4Dia14, setJustifique4Dia14]=useState();
const[justifique5Dia14, setJustifique5Dia14]=useState();
const[justifique6Dia14, setJustifique6Dia14]=useState();
const[justifique7Dia14, setJustifique7Dia14]=useState();
const[justifique8Dia14, setJustifique8Dia14]=useState();
const[justifique9Dia14, setJustifique9Dia14]=useState();
const[justifique10Dia14, setJustifique10Dia14]=useState();
const[justifique11Dia14, setJustifique11Dia14]=useState();
const[justifique12Dia14, setJustifique12Dia14]=useState();
const[justifique13Dia14, setJustifique13Dia14]=useState();
const[justifique14Dia14, setJustifique14Dia14]=useState();
const[justifique15Dia14, setJustifique15Dia14]=useState();
const[justifique16Dia14, setJustifique16Dia14]=useState();
const[justifique17Dia14, setJustifique17Dia14]=useState();
const[justifique18Dia14, setJustifique18Dia14]=useState();
const[justifique19Dia14, setJustifique19Dia14]=useState();
const[justifique20Dia14, setJustifique20Dia14]=useState();
const[justifique21Dia14, setJustifique21Dia14]=useState();
const[justifique22Dia14, setJustifique22Dia14]=useState();
const[justifique23Dia14, setJustifique23Dia14]=useState();
const[justifique24Dia14, setJustifique24Dia14]=useState();
const[justifique25Dia14, setJustifique25Dia14]=useState();
const[justifique26Dia14, setJustifique26Dia14]=useState();
const[justifique27Dia14, setJustifique27Dia14]=useState();
const[justifique28Dia14, setJustifique28Dia14]=useState();
const[justifique29Dia14, setJustifique29Dia14]=useState();
const[justifique30Dia14, setJustifique30Dia14]=useState();
const[justifique31Dia14, setJustifique31Dia14]=useState();  

const[sonda1Dia14, setSonda1Dia14]=useState();
const[responsavel1Dia14, setResponsavel1Dia14]=useState();



//dia 15
const[selecione1Dia15, setSelecione1Dia15]=useState();
const[selecione2Dia15, setSelecione2Dia15]=useState();
const[selecione3Dia15, setSelecione3Dia15]=useState();
const[selecione4Dia15, setSelecione4Dia15]=useState();
const[selecione5Dia15, setSelecione5Dia15]=useState();
const[selecione6Dia15, setSelecione6Dia15]=useState();
const[selecione7Dia15, setSelecione7Dia15]=useState();
const[selecione8Dia15, setSelecione8Dia15]=useState();
const[selecione9Dia15, setSelecione9Dia15]=useState();
const[selecione10Dia15, setSelecione10Dia15]=useState();
const[selecione11Dia15, setSelecione11Dia15]=useState();
const[selecione12Dia15, setSelecione12Dia15]=useState();
const[selecione13Dia15, setSelecione13Dia15]=useState();
const[selecione14Dia15, setSelecione14Dia15]=useState();
const[selecione15Dia15, setSelecione15Dia15]=useState();
const[selecione16Dia15, setSelecione16Dia15]=useState();
const[selecione17Dia15, setSelecione17Dia15]=useState();
const[selecione18Dia15, setSelecione18Dia15]=useState();
const[selecione19Dia15, setSelecione19Dia15]=useState();
const[selecione20Dia15, setSelecione20Dia15]=useState();
const[selecione21Dia15, setSelecione21Dia15]=useState();
const[selecione22Dia15, setSelecione22Dia15]=useState();
const[selecione23Dia15, setSelecione23Dia15]=useState();
const[selecione24Dia15, setSelecione24Dia15]=useState();
const[selecione25Dia15, setSelecione25Dia15]=useState();
const[selecione26Dia15, setSelecione26Dia15]=useState();
const[selecione27Dia15, setSelecione27Dia15]=useState();
const[selecione28Dia15, setSelecione28Dia15]=useState();
const[selecione29Dia15, setSelecione29Dia15]=useState();
const[selecione30Dia15, setSelecione30Dia15]=useState();
const[selecione31Dia15, setSelecione31Dia15]=useState();

const[justifique1Dia15, setJustifique1Dia15]=useState();
const[justifique2Dia15, setJustifique2Dia15]=useState();
const[justifique3Dia15, setJustifique3Dia15]=useState();
const[justifique4Dia15, setJustifique4Dia15]=useState();
const[justifique5Dia15, setJustifique5Dia15]=useState();
const[justifique6Dia15, setJustifique6Dia15]=useState();
const[justifique7Dia15, setJustifique7Dia15]=useState();
const[justifique8Dia15, setJustifique8Dia15]=useState();
const[justifique9Dia15, setJustifique9Dia15]=useState();
const[justifique10Dia15, setJustifique10Dia15]=useState();
const[justifique11Dia15, setJustifique11Dia15]=useState();
const[justifique12Dia15, setJustifique12Dia15]=useState();
const[justifique13Dia15, setJustifique13Dia15]=useState();
const[justifique14Dia15, setJustifique14Dia15]=useState();
const[justifique15Dia15, setJustifique15Dia15]=useState();
const[justifique16Dia15, setJustifique16Dia15]=useState();
const[justifique17Dia15, setJustifique17Dia15]=useState();
const[justifique18Dia15, setJustifique18Dia15]=useState();
const[justifique19Dia15, setJustifique19Dia15]=useState();
const[justifique20Dia15, setJustifique20Dia15]=useState();
const[justifique21Dia15, setJustifique21Dia15]=useState();
const[justifique22Dia15, setJustifique22Dia15]=useState();
const[justifique23Dia15, setJustifique23Dia15]=useState();
const[justifique24Dia15, setJustifique24Dia15]=useState();
const[justifique25Dia15, setJustifique25Dia15]=useState();
const[justifique26Dia15, setJustifique26Dia15]=useState();
const[justifique27Dia15, setJustifique27Dia15]=useState();
const[justifique28Dia15, setJustifique28Dia15]=useState();
const[justifique29Dia15, setJustifique29Dia15]=useState();
const[justifique30Dia15, setJustifique30Dia15]=useState();
const[justifique31Dia15, setJustifique31Dia15]=useState();  

const[sonda1Dia15, setSonda1Dia15]=useState();
const[responsavel1Dia15, setResponsavel1Dia15]=useState();


//dia 16
const[selecione1Dia16, setSelecione1Dia16]=useState();
const[selecione2Dia16, setSelecione2Dia16]=useState();
const[selecione3Dia16, setSelecione3Dia16]=useState();
const[selecione4Dia16, setSelecione4Dia16]=useState();
const[selecione5Dia16, setSelecione5Dia16]=useState();
const[selecione6Dia16, setSelecione6Dia16]=useState();
const[selecione7Dia16, setSelecione7Dia16]=useState();
const[selecione8Dia16, setSelecione8Dia16]=useState();
const[selecione9Dia16, setSelecione9Dia16]=useState();
const[selecione10Dia16, setSelecione10Dia16]=useState();
const[selecione11Dia16, setSelecione11Dia16]=useState();
const[selecione12Dia16, setSelecione12Dia16]=useState();
const[selecione13Dia16, setSelecione13Dia16]=useState();
const[selecione14Dia16, setSelecione14Dia16]=useState();
const[selecione15Dia16, setSelecione15Dia16]=useState();
const[selecione16Dia16, setSelecione16Dia16]=useState();
const[selecione17Dia16, setSelecione17Dia16]=useState();
const[selecione18Dia16, setSelecione18Dia16]=useState();
const[selecione19Dia16, setSelecione19Dia16]=useState();
const[selecione20Dia16, setSelecione20Dia16]=useState();
const[selecione21Dia16, setSelecione21Dia16]=useState();
const[selecione22Dia16, setSelecione22Dia16]=useState();
const[selecione23Dia16, setSelecione23Dia16]=useState();
const[selecione24Dia16, setSelecione24Dia16]=useState();
const[selecione25Dia16, setSelecione25Dia16]=useState();
const[selecione26Dia16, setSelecione26Dia16]=useState();
const[selecione27Dia16, setSelecione27Dia16]=useState();
const[selecione28Dia16, setSelecione28Dia16]=useState();
const[selecione29Dia16, setSelecione29Dia16]=useState();
const[selecione30Dia16, setSelecione30Dia16]=useState();
const[selecione31Dia16, setSelecione31Dia16]=useState();

const[justifique1Dia16, setJustifique1Dia16]=useState();
const[justifique2Dia16, setJustifique2Dia16]=useState();
const[justifique3Dia16, setJustifique3Dia16]=useState();
const[justifique4Dia16, setJustifique4Dia16]=useState();
const[justifique5Dia16, setJustifique5Dia16]=useState();
const[justifique6Dia16, setJustifique6Dia16]=useState();
const[justifique7Dia16, setJustifique7Dia16]=useState();
const[justifique8Dia16, setJustifique8Dia16]=useState();
const[justifique9Dia16, setJustifique9Dia16]=useState();
const[justifique10Dia16, setJustifique10Dia16]=useState();
const[justifique11Dia16, setJustifique11Dia16]=useState();
const[justifique12Dia16, setJustifique12Dia16]=useState();
const[justifique13Dia16, setJustifique13Dia16]=useState();
const[justifique14Dia16, setJustifique14Dia16]=useState();
const[justifique15Dia16, setJustifique15Dia16]=useState();
const[justifique16Dia16, setJustifique16Dia16]=useState();
const[justifique17Dia16, setJustifique17Dia16]=useState();
const[justifique18Dia16, setJustifique18Dia16]=useState();
const[justifique19Dia16, setJustifique19Dia16]=useState();
const[justifique20Dia16, setJustifique20Dia16]=useState();
const[justifique21Dia16, setJustifique21Dia16]=useState();
const[justifique22Dia16, setJustifique22Dia16]=useState();
const[justifique23Dia16, setJustifique23Dia16]=useState();
const[justifique24Dia16, setJustifique24Dia16]=useState();
const[justifique25Dia16, setJustifique25Dia16]=useState();
const[justifique26Dia16, setJustifique26Dia16]=useState();
const[justifique27Dia16, setJustifique27Dia16]=useState();
const[justifique28Dia16, setJustifique28Dia16]=useState();
const[justifique29Dia16, setJustifique29Dia16]=useState();
const[justifique30Dia16, setJustifique30Dia16]=useState();
const[justifique31Dia16, setJustifique31Dia16]=useState();  

const[sonda1Dia16, setSonda1Dia16]=useState();
const[responsavel1Dia16, setResponsavel1Dia16]=useState();


//dia 17
const[selecione1Dia17, setSelecione1Dia17]=useState();
const[selecione2Dia17, setSelecione2Dia17]=useState();
const[selecione3Dia17, setSelecione3Dia17]=useState();
const[selecione4Dia17, setSelecione4Dia17]=useState();
const[selecione5Dia17, setSelecione5Dia17]=useState();
const[selecione6Dia17, setSelecione6Dia17]=useState();
const[selecione7Dia17, setSelecione7Dia17]=useState();
const[selecione8Dia17, setSelecione8Dia17]=useState();
const[selecione9Dia17, setSelecione9Dia17]=useState();
const[selecione10Dia17, setSelecione10Dia17]=useState();
const[selecione11Dia17, setSelecione11Dia17]=useState();
const[selecione12Dia17, setSelecione12Dia17]=useState();
const[selecione13Dia17, setSelecione13Dia17]=useState();
const[selecione14Dia17, setSelecione14Dia17]=useState();
const[selecione15Dia17, setSelecione15Dia17]=useState();
const[selecione16Dia17, setSelecione16Dia17]=useState();
const[selecione17Dia17, setSelecione17Dia17]=useState();
const[selecione18Dia17, setSelecione18Dia17]=useState();
const[selecione19Dia17, setSelecione19Dia17]=useState();
const[selecione20Dia17, setSelecione20Dia17]=useState();
const[selecione21Dia17, setSelecione21Dia17]=useState();
const[selecione22Dia17, setSelecione22Dia17]=useState();
const[selecione23Dia17, setSelecione23Dia17]=useState();
const[selecione24Dia17, setSelecione24Dia17]=useState();
const[selecione25Dia17, setSelecione25Dia17]=useState();
const[selecione26Dia17, setSelecione26Dia17]=useState();
const[selecione27Dia17, setSelecione27Dia17]=useState();
const[selecione28Dia17, setSelecione28Dia17]=useState();
const[selecione29Dia17, setSelecione29Dia17]=useState();
const[selecione30Dia17, setSelecione30Dia17]=useState();
const[selecione31Dia17, setSelecione31Dia17]=useState();

const[justifique1Dia17, setJustifique1Dia17]=useState();
const[justifique2Dia17, setJustifique2Dia17]=useState();
const[justifique3Dia17, setJustifique3Dia17]=useState();
const[justifique4Dia17, setJustifique4Dia17]=useState();
const[justifique5Dia17, setJustifique5Dia17]=useState();
const[justifique6Dia17, setJustifique6Dia17]=useState();
const[justifique7Dia17, setJustifique7Dia17]=useState();
const[justifique8Dia17, setJustifique8Dia17]=useState();
const[justifique9Dia17, setJustifique9Dia17]=useState();
const[justifique10Dia17, setJustifique10Dia17]=useState();
const[justifique11Dia17, setJustifique11Dia17]=useState();
const[justifique12Dia17, setJustifique12Dia17]=useState();
const[justifique13Dia17, setJustifique13Dia17]=useState();
const[justifique14Dia17, setJustifique14Dia17]=useState();
const[justifique15Dia17, setJustifique15Dia17]=useState();
const[justifique16Dia17, setJustifique16Dia17]=useState();
const[justifique17Dia17, setJustifique17Dia17]=useState();
const[justifique18Dia17, setJustifique18Dia17]=useState();
const[justifique19Dia17, setJustifique19Dia17]=useState();
const[justifique20Dia17, setJustifique20Dia17]=useState();
const[justifique21Dia17, setJustifique21Dia17]=useState();
const[justifique22Dia17, setJustifique22Dia17]=useState();
const[justifique23Dia17, setJustifique23Dia17]=useState();
const[justifique24Dia17, setJustifique24Dia17]=useState();
const[justifique25Dia17, setJustifique25Dia17]=useState();
const[justifique26Dia17, setJustifique26Dia17]=useState();
const[justifique27Dia17, setJustifique27Dia17]=useState();
const[justifique28Dia17, setJustifique28Dia17]=useState();
const[justifique29Dia17, setJustifique29Dia17]=useState();
const[justifique30Dia17, setJustifique30Dia17]=useState();
const[justifique31Dia17, setJustifique31Dia17]=useState();  

const[sonda1Dia17, setSonda1Dia17]=useState();
const[responsavel1Dia17, setResponsavel1Dia17]=useState();


//dia 18
const[selecione1Dia18, setSelecione1Dia18]=useState();
const[selecione2Dia18, setSelecione2Dia18]=useState();
const[selecione3Dia18, setSelecione3Dia18]=useState();
const[selecione4Dia18, setSelecione4Dia18]=useState();
const[selecione5Dia18, setSelecione5Dia18]=useState();
const[selecione6Dia18, setSelecione6Dia18]=useState();
const[selecione7Dia18, setSelecione7Dia18]=useState();
const[selecione8Dia18, setSelecione8Dia18]=useState();
const[selecione9Dia18, setSelecione9Dia18]=useState();
const[selecione10Dia18, setSelecione10Dia18]=useState();
const[selecione11Dia18, setSelecione11Dia18]=useState();
const[selecione12Dia18, setSelecione12Dia18]=useState();
const[selecione13Dia18, setSelecione13Dia18]=useState();
const[selecione14Dia18, setSelecione14Dia18]=useState();
const[selecione15Dia18, setSelecione15Dia18]=useState();
const[selecione16Dia18, setSelecione16Dia18]=useState();
const[selecione17Dia18, setSelecione17Dia18]=useState();
const[selecione18Dia18, setSelecione18Dia18]=useState();
const[selecione19Dia18, setSelecione19Dia18]=useState();
const[selecione20Dia18, setSelecione20Dia18]=useState();
const[selecione21Dia18, setSelecione21Dia18]=useState();
const[selecione22Dia18, setSelecione22Dia18]=useState();
const[selecione23Dia18, setSelecione23Dia18]=useState();
const[selecione24Dia18, setSelecione24Dia18]=useState();
const[selecione25Dia18, setSelecione25Dia18]=useState();
const[selecione26Dia18, setSelecione26Dia18]=useState();
const[selecione27Dia18, setSelecione27Dia18]=useState();
const[selecione28Dia18, setSelecione28Dia18]=useState();
const[selecione29Dia18, setSelecione29Dia18]=useState();
const[selecione30Dia18, setSelecione30Dia18]=useState();
const[selecione31Dia18, setSelecione31Dia18]=useState();

const[justifique1Dia18, setJustifique1Dia18]=useState();
const[justifique2Dia18, setJustifique2Dia18]=useState();
const[justifique3Dia18, setJustifique3Dia18]=useState();
const[justifique4Dia18, setJustifique4Dia18]=useState();
const[justifique5Dia18, setJustifique5Dia18]=useState();
const[justifique6Dia18, setJustifique6Dia18]=useState();
const[justifique7Dia18, setJustifique7Dia18]=useState();
const[justifique8Dia18, setJustifique8Dia18]=useState();
const[justifique9Dia18, setJustifique9Dia18]=useState();
const[justifique10Dia18, setJustifique10Dia18]=useState();
const[justifique11Dia18, setJustifique11Dia18]=useState();
const[justifique12Dia18, setJustifique12Dia18]=useState();
const[justifique13Dia18, setJustifique13Dia18]=useState();
const[justifique14Dia18, setJustifique14Dia18]=useState();
const[justifique15Dia18, setJustifique15Dia18]=useState();
const[justifique16Dia18, setJustifique16Dia18]=useState();
const[justifique17Dia18, setJustifique17Dia18]=useState();
const[justifique18Dia18, setJustifique18Dia18]=useState();
const[justifique19Dia18, setJustifique19Dia18]=useState();
const[justifique20Dia18, setJustifique20Dia18]=useState();
const[justifique21Dia18, setJustifique21Dia18]=useState();
const[justifique22Dia18, setJustifique22Dia18]=useState();
const[justifique23Dia18, setJustifique23Dia18]=useState();
const[justifique24Dia18, setJustifique24Dia18]=useState();
const[justifique25Dia18, setJustifique25Dia18]=useState();
const[justifique26Dia18, setJustifique26Dia18]=useState();
const[justifique27Dia18, setJustifique27Dia18]=useState();
const[justifique28Dia18, setJustifique28Dia18]=useState();
const[justifique29Dia18, setJustifique29Dia18]=useState();
const[justifique30Dia18, setJustifique30Dia18]=useState();
const[justifique31Dia18, setJustifique31Dia18]=useState();  

const[sonda1Dia18, setSonda1Dia18]=useState();
const[responsavel1Dia18, setResponsavel1Dia18]=useState();


//dia 19
const[selecione1Dia19, setSelecione1Dia19]=useState();
const[selecione2Dia19, setSelecione2Dia19]=useState();
const[selecione3Dia19, setSelecione3Dia19]=useState();
const[selecione4Dia19, setSelecione4Dia19]=useState();
const[selecione5Dia19, setSelecione5Dia19]=useState();
const[selecione6Dia19, setSelecione6Dia19]=useState();
const[selecione7Dia19, setSelecione7Dia19]=useState();
const[selecione8Dia19, setSelecione8Dia19]=useState();
const[selecione9Dia19, setSelecione9Dia19]=useState();
const[selecione10Dia19, setSelecione10Dia19]=useState();
const[selecione11Dia19, setSelecione11Dia19]=useState();
const[selecione12Dia19, setSelecione12Dia19]=useState();
const[selecione13Dia19, setSelecione13Dia19]=useState();
const[selecione14Dia19, setSelecione14Dia19]=useState();
const[selecione15Dia19, setSelecione15Dia19]=useState();
const[selecione16Dia19, setSelecione16Dia19]=useState();
const[selecione17Dia19, setSelecione17Dia19]=useState();
const[selecione18Dia19, setSelecione18Dia19]=useState();
const[selecione19Dia19, setSelecione19Dia19]=useState();
const[selecione20Dia19, setSelecione20Dia19]=useState();
const[selecione21Dia19, setSelecione21Dia19]=useState();
const[selecione22Dia19, setSelecione22Dia19]=useState();
const[selecione23Dia19, setSelecione23Dia19]=useState();
const[selecione24Dia19, setSelecione24Dia19]=useState();
const[selecione25Dia19, setSelecione25Dia19]=useState();
const[selecione26Dia19, setSelecione26Dia19]=useState();
const[selecione27Dia19, setSelecione27Dia19]=useState();
const[selecione28Dia19, setSelecione28Dia19]=useState();
const[selecione29Dia19, setSelecione29Dia19]=useState();
const[selecione30Dia19, setSelecione30Dia19]=useState();
const[selecione31Dia19, setSelecione31Dia19]=useState();

const[justifique1Dia19, setJustifique1Dia19]=useState();
const[justifique2Dia19, setJustifique2Dia19]=useState();
const[justifique3Dia19, setJustifique3Dia19]=useState();
const[justifique4Dia19, setJustifique4Dia19]=useState();
const[justifique5Dia19, setJustifique5Dia19]=useState();
const[justifique6Dia19, setJustifique6Dia19]=useState();
const[justifique7Dia19, setJustifique7Dia19]=useState();
const[justifique8Dia19, setJustifique8Dia19]=useState();
const[justifique9Dia19, setJustifique9Dia19]=useState();
const[justifique10Dia19, setJustifique10Dia19]=useState();
const[justifique11Dia19, setJustifique11Dia19]=useState();
const[justifique12Dia19, setJustifique12Dia19]=useState();
const[justifique13Dia19, setJustifique13Dia19]=useState();
const[justifique14Dia19, setJustifique14Dia19]=useState();
const[justifique15Dia19, setJustifique15Dia19]=useState();
const[justifique16Dia19, setJustifique16Dia19]=useState();
const[justifique17Dia19, setJustifique17Dia19]=useState();
const[justifique18Dia19, setJustifique18Dia19]=useState();
const[justifique19Dia19, setJustifique19Dia19]=useState();
const[justifique20Dia19, setJustifique20Dia19]=useState();
const[justifique21Dia19, setJustifique21Dia19]=useState();
const[justifique22Dia19, setJustifique22Dia19]=useState();
const[justifique23Dia19, setJustifique23Dia19]=useState();
const[justifique24Dia19, setJustifique24Dia19]=useState();
const[justifique25Dia19, setJustifique25Dia19]=useState();
const[justifique26Dia19, setJustifique26Dia19]=useState();
const[justifique27Dia19, setJustifique27Dia19]=useState();
const[justifique28Dia19, setJustifique28Dia19]=useState();
const[justifique29Dia19, setJustifique29Dia19]=useState();
const[justifique30Dia19, setJustifique30Dia19]=useState();
const[justifique31Dia19, setJustifique31Dia19]=useState();  

const[sonda1Dia19, setSonda1Dia19]=useState();
const[responsavel1Dia19, setResponsavel1Dia19]=useState();


//dia 20
const[selecione1Dia20, setSelecione1Dia20]=useState();
const[selecione2Dia20, setSelecione2Dia20]=useState();
const[selecione3Dia20, setSelecione3Dia20]=useState();
const[selecione4Dia20, setSelecione4Dia20]=useState();
const[selecione5Dia20, setSelecione5Dia20]=useState();
const[selecione6Dia20, setSelecione6Dia20]=useState();
const[selecione7Dia20, setSelecione7Dia20]=useState();
const[selecione8Dia20, setSelecione8Dia20]=useState();
const[selecione9Dia20, setSelecione9Dia20]=useState();
const[selecione10Dia20, setSelecione10Dia20]=useState();
const[selecione11Dia20, setSelecione11Dia20]=useState();
const[selecione12Dia20, setSelecione12Dia20]=useState();
const[selecione13Dia20, setSelecione13Dia20]=useState();
const[selecione14Dia20, setSelecione14Dia20]=useState();
const[selecione15Dia20, setSelecione15Dia20]=useState();
const[selecione16Dia20, setSelecione16Dia20]=useState();
const[selecione17Dia20, setSelecione17Dia20]=useState();
const[selecione18Dia20, setSelecione18Dia20]=useState();
const[selecione19Dia20, setSelecione19Dia20]=useState();
const[selecione20Dia20, setSelecione20Dia20]=useState();
const[selecione21Dia20, setSelecione21Dia20]=useState();
const[selecione22Dia20, setSelecione22Dia20]=useState();
const[selecione23Dia20, setSelecione23Dia20]=useState();
const[selecione24Dia20, setSelecione24Dia20]=useState();
const[selecione25Dia20, setSelecione25Dia20]=useState();
const[selecione26Dia20, setSelecione26Dia20]=useState();
const[selecione27Dia20, setSelecione27Dia20]=useState();
const[selecione28Dia20, setSelecione28Dia20]=useState();
const[selecione29Dia20, setSelecione29Dia20]=useState();
const[selecione30Dia20, setSelecione30Dia20]=useState();
const[selecione31Dia20, setSelecione31Dia20]=useState();

const[justifique1Dia20, setJustifique1Dia20]=useState();
const[justifique2Dia20, setJustifique2Dia20]=useState();
const[justifique3Dia20, setJustifique3Dia20]=useState();
const[justifique4Dia20, setJustifique4Dia20]=useState();
const[justifique5Dia20, setJustifique5Dia20]=useState();
const[justifique6Dia20, setJustifique6Dia20]=useState();
const[justifique7Dia20, setJustifique7Dia20]=useState();
const[justifique8Dia20, setJustifique8Dia20]=useState();
const[justifique9Dia20, setJustifique9Dia20]=useState();
const[justifique10Dia20, setJustifique10Dia20]=useState();
const[justifique11Dia20, setJustifique11Dia20]=useState();
const[justifique12Dia20, setJustifique12Dia20]=useState();
const[justifique13Dia20, setJustifique13Dia20]=useState();
const[justifique14Dia20, setJustifique14Dia20]=useState();
const[justifique15Dia20, setJustifique15Dia20]=useState();
const[justifique16Dia20, setJustifique16Dia20]=useState();
const[justifique17Dia20, setJustifique17Dia20]=useState();
const[justifique18Dia20, setJustifique18Dia20]=useState();
const[justifique19Dia20, setJustifique19Dia20]=useState();
const[justifique20Dia20, setJustifique20Dia20]=useState();
const[justifique21Dia20, setJustifique21Dia20]=useState();
const[justifique22Dia20, setJustifique22Dia20]=useState();
const[justifique23Dia20, setJustifique23Dia20]=useState();
const[justifique24Dia20, setJustifique24Dia20]=useState();
const[justifique25Dia20, setJustifique25Dia20]=useState();
const[justifique26Dia20, setJustifique26Dia20]=useState();
const[justifique27Dia20, setJustifique27Dia20]=useState();
const[justifique28Dia20, setJustifique28Dia20]=useState();
const[justifique29Dia20, setJustifique29Dia20]=useState();
const[justifique30Dia20, setJustifique30Dia20]=useState();
const[justifique31Dia20, setJustifique31Dia20]=useState();  

const[sonda1Dia20, setSonda1Dia20]=useState();
const[responsavel1Dia20, setResponsavel1Dia20]=useState();


//dia 21
const[selecione1Dia21, setSelecione1Dia21]=useState();
const[selecione2Dia21, setSelecione2Dia21]=useState();
const[selecione3Dia21, setSelecione3Dia21]=useState();
const[selecione4Dia21, setSelecione4Dia21]=useState();
const[selecione5Dia21, setSelecione5Dia21]=useState();
const[selecione6Dia21, setSelecione6Dia21]=useState();
const[selecione7Dia21, setSelecione7Dia21]=useState();
const[selecione8Dia21, setSelecione8Dia21]=useState();
const[selecione9Dia21, setSelecione9Dia21]=useState();
const[selecione10Dia21, setSelecione10Dia21]=useState();
const[selecione11Dia21, setSelecione11Dia21]=useState();
const[selecione12Dia21, setSelecione12Dia21]=useState();
const[selecione13Dia21, setSelecione13Dia21]=useState();
const[selecione14Dia21, setSelecione14Dia21]=useState();
const[selecione15Dia21, setSelecione15Dia21]=useState();
const[selecione16Dia21, setSelecione16Dia21]=useState();
const[selecione17Dia21, setSelecione17Dia21]=useState();
const[selecione18Dia21, setSelecione18Dia21]=useState();
const[selecione19Dia21, setSelecione19Dia21]=useState();
const[selecione20Dia21, setSelecione20Dia21]=useState();
const[selecione21Dia21, setSelecione21Dia21]=useState();
const[selecione22Dia21, setSelecione22Dia21]=useState();
const[selecione23Dia21, setSelecione23Dia21]=useState();
const[selecione24Dia21, setSelecione24Dia21]=useState();
const[selecione25Dia21, setSelecione25Dia21]=useState();
const[selecione26Dia21, setSelecione26Dia21]=useState();
const[selecione27Dia21, setSelecione27Dia21]=useState();
const[selecione28Dia21, setSelecione28Dia21]=useState();
const[selecione29Dia21, setSelecione29Dia21]=useState();
const[selecione30Dia21, setSelecione30Dia21]=useState();
const[selecione31Dia21, setSelecione31Dia21]=useState();

const[justifique1Dia21, setJustifique1Dia21]=useState();
const[justifique2Dia21, setJustifique2Dia21]=useState();
const[justifique3Dia21, setJustifique3Dia21]=useState();
const[justifique4Dia21, setJustifique4Dia21]=useState();
const[justifique5Dia21, setJustifique5Dia21]=useState();
const[justifique6Dia21, setJustifique6Dia21]=useState();
const[justifique7Dia21, setJustifique7Dia21]=useState();
const[justifique8Dia21, setJustifique8Dia21]=useState();
const[justifique9Dia21, setJustifique9Dia21]=useState();
const[justifique10Dia21, setJustifique10Dia21]=useState();
const[justifique11Dia21, setJustifique11Dia21]=useState();
const[justifique12Dia21, setJustifique12Dia21]=useState();
const[justifique13Dia21, setJustifique13Dia21]=useState();
const[justifique14Dia21, setJustifique14Dia21]=useState();
const[justifique15Dia21, setJustifique15Dia21]=useState();
const[justifique16Dia21, setJustifique16Dia21]=useState();
const[justifique17Dia21, setJustifique17Dia21]=useState();
const[justifique18Dia21, setJustifique18Dia21]=useState();
const[justifique19Dia21, setJustifique19Dia21]=useState();
const[justifique20Dia21, setJustifique20Dia21]=useState();
const[justifique21Dia21, setJustifique21Dia21]=useState();
const[justifique22Dia21, setJustifique22Dia21]=useState();
const[justifique23Dia21, setJustifique23Dia21]=useState();
const[justifique24Dia21, setJustifique24Dia21]=useState();
const[justifique25Dia21, setJustifique25Dia21]=useState();
const[justifique26Dia21, setJustifique26Dia21]=useState();
const[justifique27Dia21, setJustifique27Dia21]=useState();
const[justifique28Dia21, setJustifique28Dia21]=useState();
const[justifique29Dia21, setJustifique29Dia21]=useState();
const[justifique30Dia21, setJustifique30Dia21]=useState();
const[justifique31Dia21, setJustifique31Dia21]=useState();  

const[sonda1Dia21, setSonda1Dia21]=useState();
const[responsavel1Dia21, setResponsavel1Dia21]=useState();


//dia 22
const[selecione1Dia22, setSelecione1Dia22]=useState();
const[selecione2Dia22, setSelecione2Dia22]=useState();
const[selecione3Dia22, setSelecione3Dia22]=useState();
const[selecione4Dia22, setSelecione4Dia22]=useState();
const[selecione5Dia22, setSelecione5Dia22]=useState();
const[selecione6Dia22, setSelecione6Dia22]=useState();
const[selecione7Dia22, setSelecione7Dia22]=useState();
const[selecione8Dia22, setSelecione8Dia22]=useState();
const[selecione9Dia22, setSelecione9Dia22]=useState();
const[selecione10Dia22, setSelecione10Dia22]=useState();
const[selecione11Dia22, setSelecione11Dia22]=useState();
const[selecione12Dia22, setSelecione12Dia22]=useState();
const[selecione13Dia22, setSelecione13Dia22]=useState();
const[selecione14Dia22, setSelecione14Dia22]=useState();
const[selecione15Dia22, setSelecione15Dia22]=useState();
const[selecione16Dia22, setSelecione16Dia22]=useState();
const[selecione17Dia22, setSelecione17Dia22]=useState();
const[selecione18Dia22, setSelecione18Dia22]=useState();
const[selecione19Dia22, setSelecione19Dia22]=useState();
const[selecione20Dia22, setSelecione20Dia22]=useState();
const[selecione21Dia22, setSelecione21Dia22]=useState();
const[selecione22Dia22, setSelecione22Dia22]=useState();
const[selecione23Dia22, setSelecione23Dia22]=useState();
const[selecione24Dia22, setSelecione24Dia22]=useState();
const[selecione25Dia22, setSelecione25Dia22]=useState();
const[selecione26Dia22, setSelecione26Dia22]=useState();
const[selecione27Dia22, setSelecione27Dia22]=useState();
const[selecione28Dia22, setSelecione28Dia22]=useState();
const[selecione29Dia22, setSelecione29Dia22]=useState();
const[selecione30Dia22, setSelecione30Dia22]=useState();
const[selecione31Dia22, setSelecione31Dia22]=useState();

const[justifique1Dia22, setJustifique1Dia22]=useState();
const[justifique2Dia22, setJustifique2Dia22]=useState();
const[justifique3Dia22, setJustifique3Dia22]=useState();
const[justifique4Dia22, setJustifique4Dia22]=useState();
const[justifique5Dia22, setJustifique5Dia22]=useState();
const[justifique6Dia22, setJustifique6Dia22]=useState();
const[justifique7Dia22, setJustifique7Dia22]=useState();
const[justifique8Dia22, setJustifique8Dia22]=useState();
const[justifique9Dia22, setJustifique9Dia22]=useState();
const[justifique10Dia22, setJustifique10Dia22]=useState();
const[justifique11Dia22, setJustifique11Dia22]=useState();
const[justifique12Dia22, setJustifique12Dia22]=useState();
const[justifique13Dia22, setJustifique13Dia22]=useState();
const[justifique14Dia22, setJustifique14Dia22]=useState();
const[justifique15Dia22, setJustifique15Dia22]=useState();
const[justifique16Dia22, setJustifique16Dia22]=useState();
const[justifique17Dia22, setJustifique17Dia22]=useState();
const[justifique18Dia22, setJustifique18Dia22]=useState();
const[justifique19Dia22, setJustifique19Dia22]=useState();
const[justifique20Dia22, setJustifique20Dia22]=useState();
const[justifique21Dia22, setJustifique21Dia22]=useState();
const[justifique22Dia22, setJustifique22Dia22]=useState();
const[justifique23Dia22, setJustifique23Dia22]=useState();
const[justifique24Dia22, setJustifique24Dia22]=useState();
const[justifique25Dia22, setJustifique25Dia22]=useState();
const[justifique26Dia22, setJustifique26Dia22]=useState();
const[justifique27Dia22, setJustifique27Dia22]=useState();
const[justifique28Dia22, setJustifique28Dia22]=useState();
const[justifique29Dia22, setJustifique29Dia22]=useState();
const[justifique30Dia22, setJustifique30Dia22]=useState();
const[justifique31Dia22, setJustifique31Dia22]=useState();  

const[sonda1Dia22, setSonda1Dia22]=useState();
const[responsavel1Dia22, setResponsavel1Dia22]=useState();


//dia 23
const[selecione1Dia23, setSelecione1Dia23]=useState();
const[selecione2Dia23, setSelecione2Dia23]=useState();
const[selecione3Dia23, setSelecione3Dia23]=useState();
const[selecione4Dia23, setSelecione4Dia23]=useState();
const[selecione5Dia23, setSelecione5Dia23]=useState();
const[selecione6Dia23, setSelecione6Dia23]=useState();
const[selecione7Dia23, setSelecione7Dia23]=useState();
const[selecione8Dia23, setSelecione8Dia23]=useState();
const[selecione9Dia23, setSelecione9Dia23]=useState();
const[selecione10Dia23, setSelecione10Dia23]=useState();
const[selecione11Dia23, setSelecione11Dia23]=useState();
const[selecione12Dia23, setSelecione12Dia23]=useState();
const[selecione13Dia23, setSelecione13Dia23]=useState();
const[selecione14Dia23, setSelecione14Dia23]=useState();
const[selecione15Dia23, setSelecione15Dia23]=useState();
const[selecione16Dia23, setSelecione16Dia23]=useState();
const[selecione17Dia23, setSelecione17Dia23]=useState();
const[selecione18Dia23, setSelecione18Dia23]=useState();
const[selecione19Dia23, setSelecione19Dia23]=useState();
const[selecione20Dia23, setSelecione20Dia23]=useState();
const[selecione21Dia23, setSelecione21Dia23]=useState();
const[selecione22Dia23, setSelecione22Dia23]=useState();
const[selecione23Dia23, setSelecione23Dia23]=useState();
const[selecione24Dia23, setSelecione24Dia23]=useState();
const[selecione25Dia23, setSelecione25Dia23]=useState();
const[selecione26Dia23, setSelecione26Dia23]=useState();
const[selecione27Dia23, setSelecione27Dia23]=useState();
const[selecione28Dia23, setSelecione28Dia23]=useState();
const[selecione29Dia23, setSelecione29Dia23]=useState();
const[selecione30Dia23, setSelecione30Dia23]=useState();
const[selecione31Dia23, setSelecione31Dia23]=useState();

const[justifique1Dia23, setJustifique1Dia23]=useState();
const[justifique2Dia23, setJustifique2Dia23]=useState();
const[justifique3Dia23, setJustifique3Dia23]=useState();
const[justifique4Dia23, setJustifique4Dia23]=useState();
const[justifique5Dia23, setJustifique5Dia23]=useState();
const[justifique6Dia23, setJustifique6Dia23]=useState();
const[justifique7Dia23, setJustifique7Dia23]=useState();
const[justifique8Dia23, setJustifique8Dia23]=useState();
const[justifique9Dia23, setJustifique9Dia23]=useState();
const[justifique10Dia23, setJustifique10Dia23]=useState();
const[justifique11Dia23, setJustifique11Dia23]=useState();
const[justifique12Dia23, setJustifique12Dia23]=useState();
const[justifique13Dia23, setJustifique13Dia23]=useState();
const[justifique14Dia23, setJustifique14Dia23]=useState();
const[justifique15Dia23, setJustifique15Dia23]=useState();
const[justifique16Dia23, setJustifique16Dia23]=useState();
const[justifique17Dia23, setJustifique17Dia23]=useState();
const[justifique18Dia23, setJustifique18Dia23]=useState();
const[justifique19Dia23, setJustifique19Dia23]=useState();
const[justifique20Dia23, setJustifique20Dia23]=useState();
const[justifique21Dia23, setJustifique21Dia23]=useState();
const[justifique22Dia23, setJustifique22Dia23]=useState();
const[justifique23Dia23, setJustifique23Dia23]=useState();
const[justifique24Dia23, setJustifique24Dia23]=useState();
const[justifique25Dia23, setJustifique25Dia23]=useState();
const[justifique26Dia23, setJustifique26Dia23]=useState();
const[justifique27Dia23, setJustifique27Dia23]=useState();
const[justifique28Dia23, setJustifique28Dia23]=useState();
const[justifique29Dia23, setJustifique29Dia23]=useState();
const[justifique30Dia23, setJustifique30Dia23]=useState();
const[justifique31Dia23, setJustifique31Dia23]=useState();  

const[sonda1Dia23, setSonda1Dia23]=useState();
const[responsavel1Dia23, setResponsavel1Dia23]=useState();


//dia 24
const[selecione1Dia24, setSelecione1Dia24]=useState();
const[selecione2Dia24, setSelecione2Dia24]=useState();
const[selecione3Dia24, setSelecione3Dia24]=useState();
const[selecione4Dia24, setSelecione4Dia24]=useState();
const[selecione5Dia24, setSelecione5Dia24]=useState();
const[selecione6Dia24, setSelecione6Dia24]=useState();
const[selecione7Dia24, setSelecione7Dia24]=useState();
const[selecione8Dia24, setSelecione8Dia24]=useState();
const[selecione9Dia24, setSelecione9Dia24]=useState();
const[selecione10Dia24, setSelecione10Dia24]=useState();
const[selecione11Dia24, setSelecione11Dia24]=useState();
const[selecione12Dia24, setSelecione12Dia24]=useState();
const[selecione13Dia24, setSelecione13Dia24]=useState();
const[selecione14Dia24, setSelecione14Dia24]=useState();
const[selecione15Dia24, setSelecione15Dia24]=useState();
const[selecione16Dia24, setSelecione16Dia24]=useState();
const[selecione17Dia24, setSelecione17Dia24]=useState();
const[selecione18Dia24, setSelecione18Dia24]=useState();
const[selecione19Dia24, setSelecione19Dia24]=useState();
const[selecione20Dia24, setSelecione20Dia24]=useState();
const[selecione21Dia24, setSelecione21Dia24]=useState();
const[selecione22Dia24, setSelecione22Dia24]=useState();
const[selecione23Dia24, setSelecione23Dia24]=useState();
const[selecione24Dia24, setSelecione24Dia24]=useState();
const[selecione25Dia24, setSelecione25Dia24]=useState();
const[selecione26Dia24, setSelecione26Dia24]=useState();
const[selecione27Dia24, setSelecione27Dia24]=useState();
const[selecione28Dia24, setSelecione28Dia24]=useState();
const[selecione29Dia24, setSelecione29Dia24]=useState();
const[selecione30Dia24, setSelecione30Dia24]=useState();
const[selecione31Dia24, setSelecione31Dia24]=useState();

const[justifique1Dia24, setJustifique1Dia24]=useState();
const[justifique2Dia24, setJustifique2Dia24]=useState();
const[justifique3Dia24, setJustifique3Dia24]=useState();
const[justifique4Dia24, setJustifique4Dia24]=useState();
const[justifique5Dia24, setJustifique5Dia24]=useState();
const[justifique6Dia24, setJustifique6Dia24]=useState();
const[justifique7Dia24, setJustifique7Dia24]=useState();
const[justifique8Dia24, setJustifique8Dia24]=useState();
const[justifique9Dia24, setJustifique9Dia24]=useState();
const[justifique10Dia24, setJustifique10Dia24]=useState();
const[justifique11Dia24, setJustifique11Dia24]=useState();
const[justifique12Dia24, setJustifique12Dia24]=useState();
const[justifique13Dia24, setJustifique13Dia24]=useState();
const[justifique14Dia24, setJustifique14Dia24]=useState();
const[justifique15Dia24, setJustifique15Dia24]=useState();
const[justifique16Dia24, setJustifique16Dia24]=useState();
const[justifique17Dia24, setJustifique17Dia24]=useState();
const[justifique18Dia24, setJustifique18Dia24]=useState();
const[justifique19Dia24, setJustifique19Dia24]=useState();
const[justifique20Dia24, setJustifique20Dia24]=useState();
const[justifique21Dia24, setJustifique21Dia24]=useState();
const[justifique22Dia24, setJustifique22Dia24]=useState();
const[justifique23Dia24, setJustifique23Dia24]=useState();
const[justifique24Dia24, setJustifique24Dia24]=useState();
const[justifique25Dia24, setJustifique25Dia24]=useState();
const[justifique26Dia24, setJustifique26Dia24]=useState();
const[justifique27Dia24, setJustifique27Dia24]=useState();
const[justifique28Dia24, setJustifique28Dia24]=useState();
const[justifique29Dia24, setJustifique29Dia24]=useState();
const[justifique30Dia24, setJustifique30Dia24]=useState();
const[justifique31Dia24, setJustifique31Dia24]=useState();  

const[sonda1Dia24, setSonda1Dia24]=useState();
const[responsavel1Dia24, setResponsavel1Dia24]=useState();


//dia 25
const[selecione1Dia25, setSelecione1Dia25]=useState();
const[selecione2Dia25, setSelecione2Dia25]=useState();
const[selecione3Dia25, setSelecione3Dia25]=useState();
const[selecione4Dia25, setSelecione4Dia25]=useState();
const[selecione5Dia25, setSelecione5Dia25]=useState();
const[selecione6Dia25, setSelecione6Dia25]=useState();
const[selecione7Dia25, setSelecione7Dia25]=useState();
const[selecione8Dia25, setSelecione8Dia25]=useState();
const[selecione9Dia25, setSelecione9Dia25]=useState();
const[selecione10Dia25, setSelecione10Dia25]=useState();
const[selecione11Dia25, setSelecione11Dia25]=useState();
const[selecione12Dia25, setSelecione12Dia25]=useState();
const[selecione13Dia25, setSelecione13Dia25]=useState();
const[selecione14Dia25, setSelecione14Dia25]=useState();
const[selecione15Dia25, setSelecione15Dia25]=useState();
const[selecione16Dia25, setSelecione16Dia25]=useState();
const[selecione17Dia25, setSelecione17Dia25]=useState();
const[selecione18Dia25, setSelecione18Dia25]=useState();
const[selecione19Dia25, setSelecione19Dia25]=useState();
const[selecione20Dia25, setSelecione20Dia25]=useState();
const[selecione21Dia25, setSelecione21Dia25]=useState();
const[selecione22Dia25, setSelecione22Dia25]=useState();
const[selecione23Dia25, setSelecione23Dia25]=useState();
const[selecione24Dia25, setSelecione24Dia25]=useState();
const[selecione25Dia25, setSelecione25Dia25]=useState();
const[selecione26Dia25, setSelecione26Dia25]=useState();
const[selecione27Dia25, setSelecione27Dia25]=useState();
const[selecione28Dia25, setSelecione28Dia25]=useState();
const[selecione29Dia25, setSelecione29Dia25]=useState();
const[selecione30Dia25, setSelecione30Dia25]=useState();
const[selecione31Dia25, setSelecione31Dia25]=useState();

const[justifique1Dia25, setJustifique1Dia25]=useState();
const[justifique2Dia25, setJustifique2Dia25]=useState();
const[justifique3Dia25, setJustifique3Dia25]=useState();
const[justifique4Dia25, setJustifique4Dia25]=useState();
const[justifique5Dia25, setJustifique5Dia25]=useState();
const[justifique6Dia25, setJustifique6Dia25]=useState();
const[justifique7Dia25, setJustifique7Dia25]=useState();
const[justifique8Dia25, setJustifique8Dia25]=useState();
const[justifique9Dia25, setJustifique9Dia25]=useState();
const[justifique10Dia25, setJustifique10Dia25]=useState();
const[justifique11Dia25, setJustifique11Dia25]=useState();
const[justifique12Dia25, setJustifique12Dia25]=useState();
const[justifique13Dia25, setJustifique13Dia25]=useState();
const[justifique14Dia25, setJustifique14Dia25]=useState();
const[justifique15Dia25, setJustifique15Dia25]=useState();
const[justifique16Dia25, setJustifique16Dia25]=useState();
const[justifique17Dia25, setJustifique17Dia25]=useState();
const[justifique18Dia25, setJustifique18Dia25]=useState();
const[justifique19Dia25, setJustifique19Dia25]=useState();
const[justifique20Dia25, setJustifique20Dia25]=useState();
const[justifique21Dia25, setJustifique21Dia25]=useState();
const[justifique22Dia25, setJustifique22Dia25]=useState();
const[justifique23Dia25, setJustifique23Dia25]=useState();
const[justifique24Dia25, setJustifique24Dia25]=useState();
const[justifique25Dia25, setJustifique25Dia25]=useState();
const[justifique26Dia25, setJustifique26Dia25]=useState();
const[justifique27Dia25, setJustifique27Dia25]=useState();
const[justifique28Dia25, setJustifique28Dia25]=useState();
const[justifique29Dia25, setJustifique29Dia25]=useState();
const[justifique30Dia25, setJustifique30Dia25]=useState();
const[justifique31Dia25, setJustifique31Dia25]=useState();  

const[sonda1Dia25, setSonda1Dia25]=useState();
const[responsavel1Dia25, setResponsavel1Dia25]=useState();


//dia 26
const[selecione1Dia26, setSelecione1Dia26]=useState();
const[selecione2Dia26, setSelecione2Dia26]=useState();
const[selecione3Dia26, setSelecione3Dia26]=useState();
const[selecione4Dia26, setSelecione4Dia26]=useState();
const[selecione5Dia26, setSelecione5Dia26]=useState();
const[selecione6Dia26, setSelecione6Dia26]=useState();
const[selecione7Dia26, setSelecione7Dia26]=useState();
const[selecione8Dia26, setSelecione8Dia26]=useState();
const[selecione9Dia26, setSelecione9Dia26]=useState();
const[selecione10Dia26, setSelecione10Dia26]=useState();
const[selecione11Dia26, setSelecione11Dia26]=useState();
const[selecione12Dia26, setSelecione12Dia26]=useState();
const[selecione13Dia26, setSelecione13Dia26]=useState();
const[selecione14Dia26, setSelecione14Dia26]=useState();
const[selecione15Dia26, setSelecione15Dia26]=useState();
const[selecione16Dia26, setSelecione16Dia26]=useState();
const[selecione17Dia26, setSelecione17Dia26]=useState();
const[selecione18Dia26, setSelecione18Dia26]=useState();
const[selecione19Dia26, setSelecione19Dia26]=useState();
const[selecione20Dia26, setSelecione20Dia26]=useState();
const[selecione21Dia26, setSelecione21Dia26]=useState();
const[selecione22Dia26, setSelecione22Dia26]=useState();
const[selecione23Dia26, setSelecione23Dia26]=useState();
const[selecione24Dia26, setSelecione24Dia26]=useState();
const[selecione25Dia26, setSelecione25Dia26]=useState();
const[selecione26Dia26, setSelecione26Dia26]=useState();
const[selecione27Dia26, setSelecione27Dia26]=useState();
const[selecione28Dia26, setSelecione28Dia26]=useState();
const[selecione29Dia26, setSelecione29Dia26]=useState();
const[selecione30Dia26, setSelecione30Dia26]=useState();
const[selecione31Dia26, setSelecione31Dia26]=useState();

const[justifique1Dia26, setJustifique1Dia26]=useState();
const[justifique2Dia26, setJustifique2Dia26]=useState();
const[justifique3Dia26, setJustifique3Dia26]=useState();
const[justifique4Dia26, setJustifique4Dia26]=useState();
const[justifique5Dia26, setJustifique5Dia26]=useState();
const[justifique6Dia26, setJustifique6Dia26]=useState();
const[justifique7Dia26, setJustifique7Dia26]=useState();
const[justifique8Dia26, setJustifique8Dia26]=useState();
const[justifique9Dia26, setJustifique9Dia26]=useState();
const[justifique10Dia26, setJustifique10Dia26]=useState();
const[justifique11Dia26, setJustifique11Dia26]=useState();
const[justifique12Dia26, setJustifique12Dia26]=useState();
const[justifique13Dia26, setJustifique13Dia26]=useState();
const[justifique14Dia26, setJustifique14Dia26]=useState();
const[justifique15Dia26, setJustifique15Dia26]=useState();
const[justifique16Dia26, setJustifique16Dia26]=useState();
const[justifique17Dia26, setJustifique17Dia26]=useState();
const[justifique18Dia26, setJustifique18Dia26]=useState();
const[justifique19Dia26, setJustifique19Dia26]=useState();
const[justifique20Dia26, setJustifique20Dia26]=useState();
const[justifique21Dia26, setJustifique21Dia26]=useState();
const[justifique22Dia26, setJustifique22Dia26]=useState();
const[justifique23Dia26, setJustifique23Dia26]=useState();
const[justifique24Dia26, setJustifique24Dia26]=useState();
const[justifique25Dia26, setJustifique25Dia26]=useState();
const[justifique26Dia26, setJustifique26Dia26]=useState();
const[justifique27Dia26, setJustifique27Dia26]=useState();
const[justifique28Dia26, setJustifique28Dia26]=useState();
const[justifique29Dia26, setJustifique29Dia26]=useState();
const[justifique30Dia26, setJustifique30Dia26]=useState();
const[justifique31Dia26, setJustifique31Dia26]=useState();  

const[sonda1Dia26, setSonda1Dia26]=useState();
const[responsavel1Dia26, setResponsavel1Dia26]=useState();


//dia 27    
const[selecione1Dia27, setSelecione1Dia27]=useState();
const[selecione2Dia27, setSelecione2Dia27]=useState();
const[selecione3Dia27, setSelecione3Dia27]=useState();
const[selecione4Dia27, setSelecione4Dia27]=useState();
const[selecione5Dia27, setSelecione5Dia27]=useState();
const[selecione6Dia27, setSelecione6Dia27]=useState();
const[selecione7Dia27, setSelecione7Dia27]=useState();
const[selecione8Dia27, setSelecione8Dia27]=useState();
const[selecione9Dia27, setSelecione9Dia27]=useState();
const[selecione10Dia27, setSelecione10Dia27]=useState();
const[selecione11Dia27, setSelecione11Dia27]=useState();
const[selecione12Dia27, setSelecione12Dia27]=useState();
const[selecione13Dia27, setSelecione13Dia27]=useState();
const[selecione14Dia27, setSelecione14Dia27]=useState();
const[selecione15Dia27, setSelecione15Dia27]=useState();
const[selecione16Dia27, setSelecione16Dia27]=useState();
const[selecione17Dia27, setSelecione17Dia27]=useState();
const[selecione18Dia27, setSelecione18Dia27]=useState();
const[selecione19Dia27, setSelecione19Dia27]=useState();
const[selecione20Dia27, setSelecione20Dia27]=useState();
const[selecione21Dia27, setSelecione21Dia27]=useState();
const[selecione22Dia27, setSelecione22Dia27]=useState();
const[selecione23Dia27, setSelecione23Dia27]=useState();
const[selecione24Dia27, setSelecione24Dia27]=useState();
const[selecione25Dia27, setSelecione25Dia27]=useState();
const[selecione26Dia27, setSelecione26Dia27]=useState();
const[selecione27Dia27, setSelecione27Dia27]=useState();
const[selecione28Dia27, setSelecione28Dia27]=useState();
const[selecione29Dia27, setSelecione29Dia27]=useState();
const[selecione30Dia27, setSelecione30Dia27]=useState();
const[selecione31Dia27, setSelecione31Dia27]=useState();

const[justifique1Dia27, setJustifique1Dia27]=useState();
const[justifique2Dia27, setJustifique2Dia27]=useState();
const[justifique3Dia27, setJustifique3Dia27]=useState();
const[justifique4Dia27, setJustifique4Dia27]=useState();
const[justifique5Dia27, setJustifique5Dia27]=useState();
const[justifique6Dia27, setJustifique6Dia27]=useState();
const[justifique7Dia27, setJustifique7Dia27]=useState();
const[justifique8Dia27, setJustifique8Dia27]=useState();
const[justifique9Dia27, setJustifique9Dia27]=useState();
const[justifique10Dia27, setJustifique10Dia27]=useState();
const[justifique11Dia27, setJustifique11Dia27]=useState();
const[justifique12Dia27, setJustifique12Dia27]=useState();
const[justifique13Dia27, setJustifique13Dia27]=useState();
const[justifique14Dia27, setJustifique14Dia27]=useState();
const[justifique15Dia27, setJustifique15Dia27]=useState();
const[justifique16Dia27, setJustifique16Dia27]=useState();
const[justifique17Dia27, setJustifique17Dia27]=useState();
const[justifique18Dia27, setJustifique18Dia27]=useState();
const[justifique19Dia27, setJustifique19Dia27]=useState();
const[justifique20Dia27, setJustifique20Dia27]=useState();
const[justifique21Dia27, setJustifique21Dia27]=useState();
const[justifique22Dia27, setJustifique22Dia27]=useState();
const[justifique23Dia27, setJustifique23Dia27]=useState();
const[justifique24Dia27, setJustifique24Dia27]=useState();
const[justifique25Dia27, setJustifique25Dia27]=useState();
const[justifique26Dia27, setJustifique26Dia27]=useState();
const[justifique27Dia27, setJustifique27Dia27]=useState();
const[justifique28Dia27, setJustifique28Dia27]=useState();
const[justifique29Dia27, setJustifique29Dia27]=useState();
const[justifique30Dia27, setJustifique30Dia27]=useState();
const[justifique31Dia27, setJustifique31Dia27]=useState();  

const[sonda1Dia27, setSonda1Dia27]=useState();
const[responsavel1Dia27, setResponsavel1Dia27]=useState();



//dia 28
const[selecione1Dia28, setSelecione1Dia28]=useState();
const[selecione2Dia28, setSelecione2Dia28]=useState();
const[selecione3Dia28, setSelecione3Dia28]=useState();
const[selecione4Dia28, setSelecione4Dia28]=useState();
const[selecione5Dia28, setSelecione5Dia28]=useState();
const[selecione6Dia28, setSelecione6Dia28]=useState();
const[selecione7Dia28, setSelecione7Dia28]=useState();
const[selecione8Dia28, setSelecione8Dia28]=useState();
const[selecione9Dia28, setSelecione9Dia28]=useState();
const[selecione10Dia28, setSelecione10Dia28]=useState();
const[selecione11Dia28, setSelecione11Dia28]=useState();
const[selecione12Dia28, setSelecione12Dia28]=useState();
const[selecione13Dia28, setSelecione13Dia28]=useState();
const[selecione14Dia28, setSelecione14Dia28]=useState();
const[selecione15Dia28, setSelecione15Dia28]=useState();
const[selecione16Dia28, setSelecione16Dia28]=useState();
const[selecione17Dia28, setSelecione17Dia28]=useState();
const[selecione18Dia28, setSelecione18Dia28]=useState();
const[selecione19Dia28, setSelecione19Dia28]=useState();
const[selecione20Dia28, setSelecione20Dia28]=useState();
const[selecione21Dia28, setSelecione21Dia28]=useState();
const[selecione22Dia28, setSelecione22Dia28]=useState();
const[selecione23Dia28, setSelecione23Dia28]=useState();
const[selecione24Dia28, setSelecione24Dia28]=useState();
const[selecione25Dia28, setSelecione25Dia28]=useState();
const[selecione26Dia28, setSelecione26Dia28]=useState();
const[selecione27Dia28, setSelecione27Dia28]=useState();
const[selecione28Dia28, setSelecione28Dia28]=useState();
const[selecione29Dia28, setSelecione29Dia28]=useState();
const[selecione30Dia28, setSelecione30Dia28]=useState();
const[selecione31Dia28, setSelecione31Dia28]=useState();

const[justifique1Dia28, setJustifique1Dia28]=useState();
const[justifique2Dia28, setJustifique2Dia28]=useState();
const[justifique3Dia28, setJustifique3Dia28]=useState();
const[justifique4Dia28, setJustifique4Dia28]=useState();
const[justifique5Dia28, setJustifique5Dia28]=useState();
const[justifique6Dia28, setJustifique6Dia28]=useState();
const[justifique7Dia28, setJustifique7Dia28]=useState();
const[justifique8Dia28, setJustifique8Dia28]=useState();
const[justifique9Dia28, setJustifique9Dia28]=useState();
const[justifique10Dia28, setJustifique10Dia28]=useState();
const[justifique11Dia28, setJustifique11Dia28]=useState();
const[justifique12Dia28, setJustifique12Dia28]=useState();
const[justifique13Dia28, setJustifique13Dia28]=useState();
const[justifique14Dia28, setJustifique14Dia28]=useState();
const[justifique15Dia28, setJustifique15Dia28]=useState();
const[justifique16Dia28, setJustifique16Dia28]=useState();
const[justifique17Dia28, setJustifique17Dia28]=useState();
const[justifique18Dia28, setJustifique18Dia28]=useState();
const[justifique19Dia28, setJustifique19Dia28]=useState();
const[justifique20Dia28, setJustifique20Dia28]=useState();
const[justifique21Dia28, setJustifique21Dia28]=useState();
const[justifique22Dia28, setJustifique22Dia28]=useState();
const[justifique23Dia28, setJustifique23Dia28]=useState();
const[justifique24Dia28, setJustifique24Dia28]=useState();
const[justifique25Dia28, setJustifique25Dia28]=useState();
const[justifique26Dia28, setJustifique26Dia28]=useState();
const[justifique27Dia28, setJustifique27Dia28]=useState();
const[justifique28Dia28, setJustifique28Dia28]=useState();
const[justifique29Dia28, setJustifique29Dia28]=useState();
const[justifique30Dia28, setJustifique30Dia28]=useState();
const[justifique31Dia28, setJustifique31Dia28]=useState();  

const[sonda1Dia28, setSonda1Dia28]=useState();
const[responsavel1Dia28, setResponsavel1Dia28]=useState();


//dia 29
const[selecione1Dia29, setSelecione1Dia29]=useState();
const[selecione2Dia29, setSelecione2Dia29]=useState();
const[selecione3Dia29, setSelecione3Dia29]=useState();
const[selecione4Dia29, setSelecione4Dia29]=useState();
const[selecione5Dia29, setSelecione5Dia29]=useState();
const[selecione6Dia29, setSelecione6Dia29]=useState();
const[selecione7Dia29, setSelecione7Dia29]=useState();
const[selecione8Dia29, setSelecione8Dia29]=useState();
const[selecione9Dia29, setSelecione9Dia29]=useState();
const[selecione10Dia29, setSelecione10Dia29]=useState();
const[selecione11Dia29, setSelecione11Dia29]=useState();
const[selecione12Dia29, setSelecione12Dia29]=useState();
const[selecione13Dia29, setSelecione13Dia29]=useState();
const[selecione14Dia29, setSelecione14Dia29]=useState();
const[selecione15Dia29, setSelecione15Dia29]=useState();
const[selecione16Dia29, setSelecione16Dia29]=useState();
const[selecione17Dia29, setSelecione17Dia29]=useState();
const[selecione18Dia29, setSelecione18Dia29]=useState();
const[selecione19Dia29, setSelecione19Dia29]=useState();
const[selecione20Dia29, setSelecione20Dia29]=useState();
const[selecione21Dia29, setSelecione21Dia29]=useState();
const[selecione22Dia29, setSelecione22Dia29]=useState();
const[selecione23Dia29, setSelecione23Dia29]=useState();
const[selecione24Dia29, setSelecione24Dia29]=useState();
const[selecione25Dia29, setSelecione25Dia29]=useState();
const[selecione26Dia29, setSelecione26Dia29]=useState();
const[selecione27Dia29, setSelecione27Dia29]=useState();
const[selecione28Dia29, setSelecione28Dia29]=useState();
const[selecione29Dia29, setSelecione29Dia29]=useState();
const[selecione30Dia29, setSelecione30Dia29]=useState();
const[selecione31Dia29, setSelecione31Dia29]=useState();

const[justifique1Dia29, setJustifique1Dia29]=useState();
const[justifique2Dia29, setJustifique2Dia29]=useState();
const[justifique3Dia29, setJustifique3Dia29]=useState();
const[justifique4Dia29, setJustifique4Dia29]=useState();
const[justifique5Dia29, setJustifique5Dia29]=useState();
const[justifique6Dia29, setJustifique6Dia29]=useState();
const[justifique7Dia29, setJustifique7Dia29]=useState();
const[justifique8Dia29, setJustifique8Dia29]=useState();
const[justifique9Dia29, setJustifique9Dia29]=useState();
const[justifique10Dia29, setJustifique10Dia29]=useState();
const[justifique11Dia29, setJustifique11Dia29]=useState();
const[justifique12Dia29, setJustifique12Dia29]=useState();
const[justifique13Dia29, setJustifique13Dia29]=useState();
const[justifique14Dia29, setJustifique14Dia29]=useState();
const[justifique15Dia29, setJustifique15Dia29]=useState();
const[justifique16Dia29, setJustifique16Dia29]=useState();
const[justifique17Dia29, setJustifique17Dia29]=useState();
const[justifique18Dia29, setJustifique18Dia29]=useState();
const[justifique19Dia29, setJustifique19Dia29]=useState();
const[justifique20Dia29, setJustifique20Dia29]=useState();
const[justifique21Dia29, setJustifique21Dia29]=useState();
const[justifique22Dia29, setJustifique22Dia29]=useState();
const[justifique23Dia29, setJustifique23Dia29]=useState();
const[justifique24Dia29, setJustifique24Dia29]=useState();
const[justifique25Dia29, setJustifique25Dia29]=useState();
const[justifique26Dia29, setJustifique26Dia29]=useState();
const[justifique27Dia29, setJustifique27Dia29]=useState();
const[justifique28Dia29, setJustifique28Dia29]=useState();
const[justifique29Dia29, setJustifique29Dia29]=useState();
const[justifique30Dia29, setJustifique30Dia29]=useState();
const[justifique31Dia29, setJustifique31Dia29]=useState();  

const[sonda1Dia29, setSonda1Dia29]=useState();
const[responsavel1Dia29, setResponsavel1Dia29]=useState();


//dia 30
const[selecione1Dia30, setSelecione1Dia30]=useState();
const[selecione2Dia30, setSelecione2Dia30]=useState();
const[selecione3Dia30, setSelecione3Dia30]=useState();
const[selecione4Dia30, setSelecione4Dia30]=useState();
const[selecione5Dia30, setSelecione5Dia30]=useState();
const[selecione6Dia30, setSelecione6Dia30]=useState();
const[selecione7Dia30, setSelecione7Dia30]=useState();
const[selecione8Dia30, setSelecione8Dia30]=useState();
const[selecione9Dia30, setSelecione9Dia30]=useState();
const[selecione10Dia30, setSelecione10Dia30]=useState();
const[selecione11Dia30, setSelecione11Dia30]=useState();
const[selecione12Dia30, setSelecione12Dia30]=useState();
const[selecione13Dia30, setSelecione13Dia30]=useState();
const[selecione14Dia30, setSelecione14Dia30]=useState();
const[selecione15Dia30, setSelecione15Dia30]=useState();
const[selecione16Dia30, setSelecione16Dia30]=useState();
const[selecione17Dia30, setSelecione17Dia30]=useState();
const[selecione18Dia30, setSelecione18Dia30]=useState();
const[selecione19Dia30, setSelecione19Dia30]=useState();
const[selecione20Dia30, setSelecione20Dia30]=useState();
const[selecione21Dia30, setSelecione21Dia30]=useState();
const[selecione22Dia30, setSelecione22Dia30]=useState();
const[selecione23Dia30, setSelecione23Dia30]=useState();
const[selecione24Dia30, setSelecione24Dia30]=useState();
const[selecione25Dia30, setSelecione25Dia30]=useState();
const[selecione26Dia30, setSelecione26Dia30]=useState();
const[selecione27Dia30, setSelecione27Dia30]=useState();
const[selecione28Dia30, setSelecione28Dia30]=useState();
const[selecione29Dia30, setSelecione29Dia30]=useState();
const[selecione30Dia30, setSelecione30Dia30]=useState();
const[selecione31Dia30, setSelecione31Dia30]=useState();

const[justifique1Dia30, setJustifique1Dia30]=useState();
const[justifique2Dia30, setJustifique2Dia30]=useState();
const[justifique3Dia30, setJustifique3Dia30]=useState();
const[justifique4Dia30, setJustifique4Dia30]=useState();
const[justifique5Dia30, setJustifique5Dia30]=useState();
const[justifique6Dia30, setJustifique6Dia30]=useState();
const[justifique7Dia30, setJustifique7Dia30]=useState();
const[justifique8Dia30, setJustifique8Dia30]=useState();
const[justifique9Dia30, setJustifique9Dia30]=useState();
const[justifique10Dia30, setJustifique10Dia30]=useState();
const[justifique11Dia30, setJustifique11Dia30]=useState();
const[justifique12Dia30, setJustifique12Dia30]=useState();
const[justifique13Dia30, setJustifique13Dia30]=useState();
const[justifique14Dia30, setJustifique14Dia30]=useState();
const[justifique15Dia30, setJustifique15Dia30]=useState();
const[justifique16Dia30, setJustifique16Dia30]=useState();
const[justifique17Dia30, setJustifique17Dia30]=useState();
const[justifique18Dia30, setJustifique18Dia30]=useState();
const[justifique19Dia30, setJustifique19Dia30]=useState();
const[justifique20Dia30, setJustifique20Dia30]=useState();
const[justifique21Dia30, setJustifique21Dia30]=useState();
const[justifique22Dia30, setJustifique22Dia30]=useState();
const[justifique23Dia30, setJustifique23Dia30]=useState();
const[justifique24Dia30, setJustifique24Dia30]=useState();
const[justifique25Dia30, setJustifique25Dia30]=useState();
const[justifique26Dia30, setJustifique26Dia30]=useState();
const[justifique27Dia30, setJustifique27Dia30]=useState();
const[justifique28Dia30, setJustifique28Dia30]=useState();
const[justifique29Dia30, setJustifique29Dia30]=useState();
const[justifique30Dia30, setJustifique30Dia30]=useState();
const[justifique31Dia30, setJustifique31Dia30]=useState();  

const[sonda1Dia30, setSonda1Dia30]=useState();
const[responsavel1Dia30, setResponsavel1Dia30]=useState();


//dia 31
const[selecione1Dia31, setSelecione1Dia31]=useState();
const[selecione2Dia31, setSelecione2Dia31]=useState();
const[selecione3Dia31, setSelecione3Dia31]=useState();
const[selecione4Dia31, setSelecione4Dia31]=useState();
const[selecione5Dia31, setSelecione5Dia31]=useState();
const[selecione6Dia31, setSelecione6Dia31]=useState();
const[selecione7Dia31, setSelecione7Dia31]=useState();
const[selecione8Dia31, setSelecione8Dia31]=useState();
const[selecione9Dia31, setSelecione9Dia31]=useState();
const[selecione10Dia31, setSelecione10Dia31]=useState();
const[selecione11Dia31, setSelecione11Dia31]=useState();
const[selecione12Dia31, setSelecione12Dia31]=useState();
const[selecione13Dia31, setSelecione13Dia31]=useState();
const[selecione14Dia31, setSelecione14Dia31]=useState();
const[selecione15Dia31, setSelecione15Dia31]=useState();
const[selecione16Dia31, setSelecione16Dia31]=useState();
const[selecione17Dia31, setSelecione17Dia31]=useState();
const[selecione18Dia31, setSelecione18Dia31]=useState();
const[selecione19Dia31, setSelecione19Dia31]=useState();
const[selecione20Dia31, setSelecione20Dia31]=useState();
const[selecione21Dia31, setSelecione21Dia31]=useState();
const[selecione22Dia31, setSelecione22Dia31]=useState();
const[selecione23Dia31, setSelecione23Dia31]=useState();
const[selecione24Dia31, setSelecione24Dia31]=useState();
const[selecione25Dia31, setSelecione25Dia31]=useState();
const[selecione26Dia31, setSelecione26Dia31]=useState();
const[selecione27Dia31, setSelecione27Dia31]=useState();
const[selecione28Dia31, setSelecione28Dia31]=useState();
const[selecione29Dia31, setSelecione29Dia31]=useState();
const[selecione30Dia31, setSelecione30Dia31]=useState();
const[selecione31Dia31, setSelecione31Dia31]=useState();

const[justifique1Dia31, setJustifique1Dia31]=useState();
const[justifique2Dia31, setJustifique2Dia31]=useState();
const[justifique3Dia31, setJustifique3Dia31]=useState();
const[justifique4Dia31, setJustifique4Dia31]=useState();
const[justifique5Dia31, setJustifique5Dia31]=useState();
const[justifique6Dia31, setJustifique6Dia31]=useState();
const[justifique7Dia31, setJustifique7Dia31]=useState();
const[justifique8Dia31, setJustifique8Dia31]=useState();
const[justifique9Dia31, setJustifique9Dia31]=useState();
const[justifique10Dia31, setJustifique10Dia31]=useState();
const[justifique11Dia31, setJustifique11Dia31]=useState();
const[justifique12Dia31, setJustifique12Dia31]=useState();
const[justifique13Dia31, setJustifique13Dia31]=useState();
const[justifique14Dia31, setJustifique14Dia31]=useState();
const[justifique15Dia31, setJustifique15Dia31]=useState();
const[justifique16Dia31, setJustifique16Dia31]=useState();
const[justifique17Dia31, setJustifique17Dia31]=useState();
const[justifique18Dia31, setJustifique18Dia31]=useState();
const[justifique19Dia31, setJustifique19Dia31]=useState();
const[justifique20Dia31, setJustifique20Dia31]=useState();
const[justifique21Dia31, setJustifique21Dia31]=useState();
const[justifique22Dia31, setJustifique22Dia31]=useState();
const[justifique23Dia31, setJustifique23Dia31]=useState();
const[justifique24Dia31, setJustifique24Dia31]=useState();
const[justifique25Dia31, setJustifique25Dia31]=useState();
const[justifique26Dia31, setJustifique26Dia31]=useState();
const[justifique27Dia31, setJustifique27Dia31]=useState();
const[justifique28Dia31, setJustifique28Dia31]=useState();
const[justifique29Dia31, setJustifique29Dia31]=useState();
const[justifique30Dia31, setJustifique30Dia31]=useState();
const[justifique31Dia31, setJustifique31Dia31]=useState();  

const[sonda1Dia31, setSonda1Dia31]=useState();
const[responsavel1Dia31, setResponsavel1Dia31]=useState();




  

   function Limpar(){

    setMesEAno('');
    setEquipamento('');

   };

   function Limpar2(){

   // setMesEAno('');
    setEquipamento('');

   };
    


    async function getDados() {  
        const res = await axios.get(Conexao.api + 'ListaCadastroProjetoWEB.php?projeto='+ projeto ); 
     
        if (res.data.success === false) { 
        } else {
            setListaDados(res.data.result);
        }   
      };

      async function getDados2() {  
        const res = await axios.get(Conexao.api + 'ListaCadatroProjetosWEB2.php?projeto='+ projeto + '&mesEAno=' + mesEAno ); 
     
        if (res.data.success === false) { 
        } else {
            setListaDados2(res.data.result);
        }   
      };

      async function getDados3() {  
        const res = await axios.get(Conexao.api + 'ListaCadastroProjetoWEB3.php' ); 
     
        if (res.data.success === false) { 
        } else {
           // setListaDados3(res.data.result);

           const projetosUnicos = [...new Set(res.data.result.map((dados3) => dados3.projeto))];
      setListaDados3(projetosUnicos);
        }   
      };

      useEffect(()=>{getDados()},[projeto])

      useEffect(()=>{getDados2()},[mesEAno ])

      useEffect(()=>{getDados3()},[projeto])



    function AbrirDia1(){
        setAbrirDia1(!abrirDia1);

       // setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);
    }; 

    function AbrirDia2(){
        setAbrirDia1(false);
        /* setAbrirDia2(false); */ setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia2(!abrirDia2);
    }; 

    function AbrirDia3(){
        setAbrirDia1(false);
        setAbrirDia2(false); /* setAbrirDia3(false); */  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia3(!abrirDia3);
    }; 
        
    function AbrirDia4(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  /* setAbrirDia4(false); */
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia4(!abrirDia4);
    }; 
        
    function AbrirDia5(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        /* setAbrirDia5(false); */ setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia5(!abrirDia5);
    }; 
        
    function AbrirDia6(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); /* setAbrirDia6(false); */ setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia6(!abrirDia6);
    }; 
        
    function AbrirDia7(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); /* setAbrirDia7(false); */ setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia7(!abrirDia7);
    }; 
        
    function AbrirDia8(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); /* setAbrirDia8(false); */ setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia8(!abrirDia8);
    }; 
        
    function AbrirDia9(){

        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia9(!abrirDia9);
    }; 
        
    function AbrirDia10(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia10(!abrirDia10);
    }; 
       

    function AbrirDia11(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia11(!abrirDia11);
    }; 

    function AbrirDia12(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia12(!abrirDia12);
    }; 

    function AbrirDia13(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia13(!abrirDia13);
    }; 
        
    function AbrirDia14(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia14(!abrirDia14);
    }; 
        
    function AbrirDia15(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia15(!abrirDia15);
    }; 
        
    function AbrirDia16(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia16(!abrirDia16);
    }; 
        
    function AbrirDia17(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia17(!abrirDia17);
    }; 
        
    function AbrirDia18(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia18(!abrirDia18);
    }; 
        
    function AbrirDia19(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia19(!abrirDia19);
    }; 
        
    function AbrirDia20(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia20(!abrirDia20);
    }; 
    
    function AbrirDia21(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia21(!abrirDia21);
    }; 

    function AbrirDia22(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia22(!abrirDia22);
    }; 

    function AbrirDia23(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia23(!abrirDia23);
    }; 
        
    function AbrirDia24(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia24(!abrirDia24);
    }; 
        
    function AbrirDia25(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia25(!abrirDia25);
    }; 
        
    function AbrirDia26(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia26(!abrirDia26);
    }; 
        
    function AbrirDia27(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia27(!abrirDia27);
    }; 
        
    function AbrirDia28(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia28(!abrirDia28);
    }; 
        
    function AbrirDia29(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia29(!abrirDia29);
    }; 
        
    function AbrirDia30(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia30(!abrirDia30);
    }; 
            
    function AbrirDia31(){
        setAbrirDia1(false);
        setAbrirDia2(false); setAbrirDia3(false);  setAbrirDia4(false);
        setAbrirDia5(false); setAbrirDia6(false); setAbrirDia7(false); setAbrirDia8(false); setAbrirDia9(false); setAbrirDia10(false); setAbrirDia11(false);
        setAbrirDia12(false); setAbrirDia13(false);  setAbrirDia14(false); setAbrirDia15(false); setAbrirDia16(false); setAbrirDia17(false);
        setAbrirDia18(false); setAbrirDia19(false); setAbrirDia20(false); setAbrirDia21(false); setAbrirDia22(false); setAbrirDia23(false); setAbrirDia24(false);
        setAbrirDia25(false); setAbrirDia26(false); setAbrirDia27(false); setAbrirDia28(false); setAbrirDia29(false); setAbrirDia30(false); setAbrirDia31(false);

        setAbrirDia31(!abrirDia31);
    };




    return <body>

<Navbar />

 <br/>
<div className='titulolaboratorio container-fluid '>
  <h1 className='texttitulo'>Check-list de inspeção diária de sonda</h1>
</div> 

<br/> 

<body className="col lign-items-center text-center mt-2">
    <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" > 
           <div class="col-1 ">
                <h4    >Projeto</h4>   
            </div>
            <div class="col-2  ">
                <input list="ListProjeto" onChange={(e)=> setProjeto(e.target.value) & Limpar()} value={projeto} placeholder='Selecione o projeto'  class="borda form-control w-100 text-center colorInput"  ></input> 
                <datalist id="ListProjeto">
        {listaDados3.map((projeto, index) => (
          <option key={index}>{projeto}</option>
        ))}
      </datalist>    
            </div>                  
     </div> 

     <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" > 
           <div class="col-1  ">
                <h6   >Mês/ano:</h6>   
            </div>
            <div class="col-2  ">
                <input list="ListMesEAno" onChange={(e)=> setMesEAno(e.target.value) & Limpar2()} value={mesEAno} placeholder='Selecione o mês/ano' class="borda form-control w-100 text-center colorInput"  ></input>    
                     <datalist id="ListMesEAno"> {listaDados.map((dados) => ( <option key={dados.id} > {dados.mesEAno} </option> ))}</datalist> 
            </div> 
     </div> 

   
     <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" > 
 
            <div class="col-1 ">
            <h6   >Equipamento:</h6>           
            </div>
            <div class="col-2  ">
                <input list="ListEquipamento" onChange={(e)=> setEquipamento(e.target.value)} value={equipamento} placeholder='Selecione o equipamento' class="borda form-control w-100 text-center colorInput"  ></input>  
                     <datalist id="ListEquipamento"> {listaDados2.map((dados2) => ( <option key={dados2.id} > {dados2.equipamento} </option> ))}</datalist>    
            </div> 
     </div>   

</body>



    {/*  <h6>{listaDados.map((dados) => ( <option key={dados.id} > {dados.mesEAno} </option> ))}</h6> */}







     <div className="  row d-flex justify-content-center  align-items-center p-1 mt-3" > 
                
            <div class="col-auto ">
                 <button    class="btnlogin"  >Buscar</button>           
            </div>
     </div> 


 <div className="   container d-flex   justify-content-center  align-items-center p-2 mt-2" >
    
 <button onClick={()=> AbrirDia1()} className=" borda col  mt-3"> DIA 1</button>
 <button onClick={()=> AbrirDia2()} className=" borda col ms-1 mt-3"> DIA 2</button>
 <button onClick={()=> AbrirDia3()} className=" borda col ms-1 mt-3"> DIA 3</button>
 <button onClick={()=> AbrirDia4()} className=" borda col ms-1 mt-3"> DIA 4</button>
 <button onClick={()=> AbrirDia5()} className=" borda col ms-1 mt-3"> DIA 5</button>
 <button onClick={()=> AbrirDia6()} className=" borda col ms-1 mt-3"> DIA 6</button>
 <button onClick={()=> AbrirDia7()} className=" borda col ms-1 mt-3"> DIA 7</button>
 <button onClick={()=> AbrirDia8()} className=" borda col ms-1 mt-3"> DIA 8</button>
 <button onClick={()=> AbrirDia9()} className=" borda col ms-1 mt-3"> DIA 9</button>
 <button onClick={()=> AbrirDia10()} className=" borda col ms-1 mt-3"> DIA 10</button>
 <button onClick={()=> AbrirDia11()} className=" borda col ms-1 mt-3"> DIA 11</button>
 <button onClick={()=> AbrirDia12()} className=" borda col ms-1 mt-3"> DIA 12</button>
 <button onClick={()=> AbrirDia13()} className=" borda col ms-1 mt-3"> DIA 13</button>
 <button onClick={()=> AbrirDia14()} className=" borda col ms-1 mt-3"> DIA 14</button>
 <button onClick={()=> AbrirDia15()} className=" borda col ms-1 mt-3"> DIA 15</button>
 <button onClick={()=> AbrirDia16()} className=" borda col ms-1 mt-3"> DIA 16</button>
 <button onClick={()=> AbrirDia17()} className=" borda col ms-1 mt-3"> DIA 17</button>
 <button onClick={()=> AbrirDia18()} className=" borda col ms-1 mt-3"> DIA 18</button>
 <button onClick={()=> AbrirDia19()} className=" borda col ms-1 mt-3"> DIA 19</button>
 <button onClick={()=> AbrirDia20()} className=" borda col ms-1 mt-3"> DIA 20</button>
 <button onClick={()=> AbrirDia21()} className=" borda col ms-1 mt-3"> DIA 21</button>
 <button onClick={()=> AbrirDia22()} className=" borda col ms-1 mt-3"> DIA 22</button>
 <button onClick={()=> AbrirDia23()} className=" borda col ms-1 mt-3"> DIA 23</button>
 <button onClick={()=> AbrirDia24()} className=" borda col ms-1 mt-3"> DIA 24</button>
 <button onClick={()=> AbrirDia25()} className=" borda col ms-1 mt-3"> DIA 25</button>
 <button onClick={()=> AbrirDia26()} className=" borda col ms-1 mt-3"> DIA 26</button>
 <button onClick={()=> AbrirDia27()} className=" borda col ms-1 mt-3"> DIA 27</button>
 <button onClick={()=> AbrirDia28()} className=" borda col ms-1 mt-3"> DIA 28</button>
 <button onClick={()=> AbrirDia29()} className=" borda col ms-1 mt-3"> DIA 29</button>
 <button onClick={()=> AbrirDia30()} className=" borda col ms-1 mt-3"> DIA 30</button>
 <button onClick={()=> AbrirDia31()} className=" borda col ms-1 mt-3"> DIA 31</button>
    
</div> 

{abrirDia1 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 1</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia1(e.target.value)} value={selecione1Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia1(e.target.value)} value={justifique1Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia1(e.target.value)} value={selecione2Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia1(e.target.value)} value={justifique2Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia1(e.target.value)} value={selecione3Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia1(e.target.value)} value={justifique3Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia1(e.target.value)} value={selecione4Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia1(e.target.value)} value={justifique4Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia1(e.target.value)} value={selecione5Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia1(e.target.value)} value={justifique5Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia1(e.target.value)} value={selecione6Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia1(e.target.value)} value={justifique6Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia1(e.target.value)} value={selecione7Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia1(e.target.value)} value={justifique7Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia1(e.target.value)} value={selecione8Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia1(e.target.value)} value={justifique8Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia1(e.target.value)} value={selecione9Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia1(e.target.value)} value={justifique9Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia1(e.target.value)} value={selecione10Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia1(e.target.value)} value={justifique10Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia1(e.target.value)} value={selecione11Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia1(e.target.value)} value={justifique11Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia1(e.target.value)} value={selecione12Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia1(e.target.value)} value={justifique12Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia1(e.target.value)} value={selecione13Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia1(e.target.value)} value={justifique13Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia1(e.target.value)} value={selecione14Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia1(e.target.value)} value={justifique14Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia1(e.target.value)} value={selecione15Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia1(e.target.value)} value={justifique15Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia1(e.target.value)} value={selecione16Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia1(e.target.value)} value={justifique16Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia1(e.target.value)} value={selecione17Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia1(e.target.value)} value={justifique17Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia1(e.target.value)} value={selecione18Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia1(e.target.value)} value={justifique18Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia1(e.target.value)} value={selecione19Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia1(e.target.value)} value={justifique19Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia1(e.target.value)} value={selecione20Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia1(e.target.value)} value={justifique20Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia1(e.target.value)} value={selecione21Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia1(e.target.value)} value={justifique21Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia1(e.target.value)} value={selecione22Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia1(e.target.value)} value={justifique22Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia1(e.target.value)} value={selecione23Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia1(e.target.value)} value={justifique23Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia1(e.target.value)} value={selecione24Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia1(e.target.value)} value={justifique24Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia1(e.target.value)} value={selecione25Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia1(e.target.value)} value={justifique25Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia1(e.target.value)} value={selecione26Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia1(e.target.value)} value={justifique26Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia1(e.target.value)} value={selecione27Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia1(e.target.value)} value={justifique27Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia1(e.target.value)} value={selecione28Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia1(e.target.value)} value={justifique28Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia1(e.target.value)} value={selecione29Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia1(e.target.value)} value={justifique29Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia1(e.target.value)} value={selecione30Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia1(e.target.value)} value={justifique30Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia1(e.target.value)} value={selecione31Dia1} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia1 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia1(e.target.value)} value={justifique31Dia1} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia1(e.target.value)} value={sonda1Dia1} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia1(e.target.value)} value={responsavel1Dia1} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    

</div> 


):null}

{abrirDia2 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 2</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia2(e.target.value)} value={selecione1Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia2(e.target.value)} value={justifique1Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia2(e.target.value)} value={selecione2Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia2(e.target.value)} value={justifique2Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia2(e.target.value)} value={selecione3Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia2(e.target.value)} value={justifique3Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia2(e.target.value)} value={selecione4Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia2(e.target.value)} value={justifique4Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia2(e.target.value)} value={selecione5Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia2(e.target.value)} value={justifique5Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia2(e.target.value)} value={selecione6Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia2(e.target.value)} value={justifique6Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia2(e.target.value)} value={selecione7Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia2(e.target.value)} value={justifique7Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia2(e.target.value)} value={selecione8Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia2(e.target.value)} value={justifique8Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia2(e.target.value)} value={selecione9Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia2(e.target.value)} value={justifique9Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia2(e.target.value)} value={selecione10Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia2(e.target.value)} value={justifique10Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia2(e.target.value)} value={selecione11Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia2(e.target.value)} value={justifique11Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia2(e.target.value)} value={selecione12Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia2(e.target.value)} value={justifique12Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia2(e.target.value)} value={selecione13Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia2(e.target.value)} value={justifique13Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia2(e.target.value)} value={selecione14Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia2(e.target.value)} value={justifique14Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia2(e.target.value)} value={selecione15Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia2(e.target.value)} value={justifique15Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia2(e.target.value)} value={selecione16Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia2(e.target.value)} value={justifique16Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia2(e.target.value)} value={selecione17Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia2(e.target.value)} value={justifique17Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia2(e.target.value)} value={selecione18Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia2(e.target.value)} value={justifique18Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia2(e.target.value)} value={selecione19Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia2(e.target.value)} value={justifique19Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia2(e.target.value)} value={selecione20Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia2(e.target.value)} value={justifique20Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia2(e.target.value)} value={selecione21Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia2(e.target.value)} value={justifique21Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia2(e.target.value)} value={selecione22Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia2(e.target.value)} value={justifique22Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia2(e.target.value)} value={selecione23Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia2(e.target.value)} value={justifique23Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia2(e.target.value)} value={selecione24Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia2(e.target.value)} value={justifique24Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia2(e.target.value)} value={selecione25Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia2(e.target.value)} value={justifique25Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia2(e.target.value)} value={selecione26Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia2(e.target.value)} value={justifique26Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia2(e.target.value)} value={selecione27Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia2(e.target.value)} value={justifique27Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia2(e.target.value)} value={selecione28Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia2(e.target.value)} value={justifique28Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia2(e.target.value)} value={selecione29Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia2(e.target.value)} value={justifique29Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia2(e.target.value)} value={selecione30Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia2(e.target.value)} value={justifique30Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia2(e.target.value)} value={selecione31Dia2} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia2 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia2(e.target.value)} value={justifique31Dia2} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia2(e.target.value)} value={sonda1Dia2} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia2(e.target.value)} value={responsavel1Dia2} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    
</div> 

):null}

{abrirDia3 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 3</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia3(e.target.value)} value={selecione1Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia3(e.target.value)} value={justifique1Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia3(e.target.value)} value={selecione2Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia3(e.target.value)} value={justifique2Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia3(e.target.value)} value={selecione3Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia3(e.target.value)} value={justifique3Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia3(e.target.value)} value={selecione4Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia3(e.target.value)} value={justifique4Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia3(e.target.value)} value={selecione5Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia3(e.target.value)} value={justifique5Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia3(e.target.value)} value={selecione6Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia3(e.target.value)} value={justifique6Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia3(e.target.value)} value={selecione7Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia3(e.target.value)} value={justifique7Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia3(e.target.value)} value={selecione8Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia3(e.target.value)} value={justifique8Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia3(e.target.value)} value={selecione9Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia3(e.target.value)} value={justifique9Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia3(e.target.value)} value={selecione10Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia3(e.target.value)} value={justifique10Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia3(e.target.value)} value={selecione11Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia3(e.target.value)} value={justifique11Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia3(e.target.value)} value={selecione12Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia3(e.target.value)} value={justifique12Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia3(e.target.value)} value={selecione13Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia3(e.target.value)} value={justifique13Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia3(e.target.value)} value={selecione14Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia3(e.target.value)} value={justifique14Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia3(e.target.value)} value={selecione15Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia3(e.target.value)} value={justifique15Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia3(e.target.value)} value={selecione16Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia3(e.target.value)} value={justifique16Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia3(e.target.value)} value={selecione17Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia3(e.target.value)} value={justifique17Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia3(e.target.value)} value={selecione18Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia3(e.target.value)} value={justifique18Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia3(e.target.value)} value={selecione19Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia3(e.target.value)} value={justifique19Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia3(e.target.value)} value={selecione20Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia3(e.target.value)} value={justifique20Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia3(e.target.value)} value={selecione21Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia3(e.target.value)} value={justifique21Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia3(e.target.value)} value={selecione22Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia3(e.target.value)} value={justifique22Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia3(e.target.value)} value={selecione23Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia3(e.target.value)} value={justifique23Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia3(e.target.value)} value={selecione24Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia3(e.target.value)} value={justifique24Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia3(e.target.value)} value={selecione25Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia3(e.target.value)} value={justifique25Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia3(e.target.value)} value={selecione26Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia3(e.target.value)} value={justifique26Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia3(e.target.value)} value={selecione27Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia3(e.target.value)} value={justifique27Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia3(e.target.value)} value={selecione28Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia3(e.target.value)} value={justifique28Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia3(e.target.value)} value={selecione29Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia3(e.target.value)} value={justifique29Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia3(e.target.value)} value={selecione30Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia3(e.target.value)} value={justifique30Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia3(e.target.value)} value={selecione31Dia3} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia3 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia3(e.target.value)} value={justifique31Dia3} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia3(e.target.value)} value={sonda1Dia3} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia3(e.target.value)} value={responsavel1Dia3} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    




</div> 





):null}


{abrirDia4 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 4</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia4(e.target.value)} value={selecione1Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia4(e.target.value)} value={justifique1Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia4(e.target.value)} value={selecione2Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia4(e.target.value)} value={justifique2Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia4(e.target.value)} value={selecione3Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia4(e.target.value)} value={justifique3Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia4(e.target.value)} value={selecione4Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia4(e.target.value)} value={justifique4Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia4(e.target.value)} value={selecione5Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia4(e.target.value)} value={justifique5Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia4(e.target.value)} value={selecione6Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia4(e.target.value)} value={justifique6Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia4(e.target.value)} value={selecione7Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia4(e.target.value)} value={justifique7Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia4(e.target.value)} value={selecione8Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia4(e.target.value)} value={justifique8Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia4(e.target.value)} value={selecione9Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia4(e.target.value)} value={justifique9Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia4(e.target.value)} value={selecione10Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia4(e.target.value)} value={justifique10Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia4(e.target.value)} value={selecione11Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia4(e.target.value)} value={justifique11Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia4(e.target.value)} value={selecione12Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia4(e.target.value)} value={justifique12Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia4(e.target.value)} value={selecione13Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia4(e.target.value)} value={justifique13Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia4(e.target.value)} value={selecione14Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia4(e.target.value)} value={justifique14Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia4(e.target.value)} value={selecione15Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia4(e.target.value)} value={justifique15Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia4(e.target.value)} value={selecione16Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia4(e.target.value)} value={justifique16Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia4(e.target.value)} value={selecione17Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia4(e.target.value)} value={justifique17Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia4(e.target.value)} value={selecione18Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia4(e.target.value)} value={justifique18Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia4(e.target.value)} value={selecione19Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia4(e.target.value)} value={justifique19Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia4(e.target.value)} value={selecione20Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia4(e.target.value)} value={justifique20Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia4(e.target.value)} value={selecione21Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia4(e.target.value)} value={justifique21Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia4(e.target.value)} value={selecione22Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia4(e.target.value)} value={justifique22Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia4(e.target.value)} value={selecione23Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia4(e.target.value)} value={justifique23Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia4(e.target.value)} value={selecione24Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia4(e.target.value)} value={justifique24Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia4(e.target.value)} value={selecione25Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia4(e.target.value)} value={justifique25Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia4(e.target.value)} value={selecione26Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia4(e.target.value)} value={justifique26Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia4(e.target.value)} value={selecione27Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia4(e.target.value)} value={justifique27Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia4(e.target.value)} value={selecione28Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia4(e.target.value)} value={justifique28Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia4(e.target.value)} value={selecione29Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia4(e.target.value)} value={justifique29Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia4(e.target.value)} value={selecione30Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia4(e.target.value)} value={justifique30Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia4(e.target.value)} value={selecione31Dia4} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia4 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia4(e.target.value)} value={justifique31Dia4} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia4(e.target.value)} value={sonda1Dia4} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia4(e.target.value)} value={responsavel1Dia4} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    




</div> 





):null}


{abrirDia5 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 5</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia5(e.target.value)} value={selecione1Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia5(e.target.value)} value={justifique1Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia5(e.target.value)} value={selecione2Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia5(e.target.value)} value={justifique2Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia5(e.target.value)} value={selecione3Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia5(e.target.value)} value={justifique3Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia5(e.target.value)} value={selecione4Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia5(e.target.value)} value={justifique4Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia5(e.target.value)} value={selecione5Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia5(e.target.value)} value={justifique5Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia5(e.target.value)} value={selecione6Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia5(e.target.value)} value={justifique6Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia5(e.target.value)} value={selecione7Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia5(e.target.value)} value={justifique7Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia5(e.target.value)} value={selecione8Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia5(e.target.value)} value={justifique8Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia5(e.target.value)} value={selecione9Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia5(e.target.value)} value={justifique9Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia5(e.target.value)} value={selecione10Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia5(e.target.value)} value={justifique10Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia5(e.target.value)} value={selecione11Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia5(e.target.value)} value={justifique11Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia5(e.target.value)} value={selecione12Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia5(e.target.value)} value={justifique12Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia5(e.target.value)} value={selecione13Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia5(e.target.value)} value={justifique13Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia5(e.target.value)} value={selecione14Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia5(e.target.value)} value={justifique14Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia5(e.target.value)} value={selecione15Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia5(e.target.value)} value={justifique15Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia5(e.target.value)} value={selecione16Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia5(e.target.value)} value={justifique16Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia5(e.target.value)} value={selecione17Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia5(e.target.value)} value={justifique17Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia5(e.target.value)} value={selecione18Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia5(e.target.value)} value={justifique18Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia5(e.target.value)} value={selecione19Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia5(e.target.value)} value={justifique19Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia5(e.target.value)} value={selecione20Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia5(e.target.value)} value={justifique20Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia5(e.target.value)} value={selecione21Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia5(e.target.value)} value={justifique21Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia5(e.target.value)} value={selecione22Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia5(e.target.value)} value={justifique22Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia5(e.target.value)} value={selecione23Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia5(e.target.value)} value={justifique23Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia5(e.target.value)} value={selecione24Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia5(e.target.value)} value={justifique24Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia5(e.target.value)} value={selecione25Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia5(e.target.value)} value={justifique25Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia5(e.target.value)} value={selecione26Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia5(e.target.value)} value={justifique26Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia5(e.target.value)} value={selecione27Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia5(e.target.value)} value={justifique27Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia5(e.target.value)} value={selecione28Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia5(e.target.value)} value={justifique28Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia5(e.target.value)} value={selecione29Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia5(e.target.value)} value={justifique29Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia5(e.target.value)} value={selecione30Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia5(e.target.value)} value={justifique30Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia5(e.target.value)} value={selecione31Dia5} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia5 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia5(e.target.value)} value={justifique31Dia5} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia5(e.target.value)} value={sonda1Dia5} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia5(e.target.value)} value={responsavel1Dia5} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    




</div> 





):null}

{abrirDia6 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 6</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia6(e.target.value)} value={selecione1Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia6(e.target.value)} value={justifique1Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia6(e.target.value)} value={selecione2Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia6(e.target.value)} value={justifique2Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia6(e.target.value)} value={selecione3Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia6(e.target.value)} value={justifique3Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia6(e.target.value)} value={selecione4Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia6(e.target.value)} value={justifique4Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia6(e.target.value)} value={selecione5Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia6(e.target.value)} value={justifique5Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia6(e.target.value)} value={selecione6Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia6(e.target.value)} value={justifique6Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia6(e.target.value)} value={selecione7Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia6(e.target.value)} value={justifique7Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia6(e.target.value)} value={selecione8Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia6(e.target.value)} value={justifique8Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia6(e.target.value)} value={selecione9Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia6(e.target.value)} value={justifique9Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia6(e.target.value)} value={selecione10Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia6(e.target.value)} value={justifique10Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia6(e.target.value)} value={selecione11Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia6(e.target.value)} value={justifique11Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia6(e.target.value)} value={selecione12Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia6(e.target.value)} value={justifique12Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia6(e.target.value)} value={selecione13Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia6(e.target.value)} value={justifique13Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia6(e.target.value)} value={selecione14Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia6(e.target.value)} value={justifique14Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia6(e.target.value)} value={selecione15Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia6(e.target.value)} value={justifique15Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia6(e.target.value)} value={selecione16Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia6(e.target.value)} value={justifique16Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia6(e.target.value)} value={selecione17Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia6(e.target.value)} value={justifique17Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia6(e.target.value)} value={selecione18Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia6(e.target.value)} value={justifique18Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia6(e.target.value)} value={selecione19Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia6(e.target.value)} value={justifique19Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia6(e.target.value)} value={selecione20Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia6(e.target.value)} value={justifique20Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia6(e.target.value)} value={selecione21Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia6(e.target.value)} value={justifique21Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia6(e.target.value)} value={selecione22Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia6(e.target.value)} value={justifique22Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia6(e.target.value)} value={selecione23Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia6(e.target.value)} value={justifique23Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia6(e.target.value)} value={selecione24Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia6(e.target.value)} value={justifique24Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia6(e.target.value)} value={selecione25Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia6(e.target.value)} value={justifique25Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia6(e.target.value)} value={selecione26Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia6(e.target.value)} value={justifique26Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia6(e.target.value)} value={selecione27Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia6(e.target.value)} value={justifique27Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia6(e.target.value)} value={selecione28Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia6(e.target.value)} value={justifique28Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia6(e.target.value)} value={selecione29Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia6(e.target.value)} value={justifique29Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia6(e.target.value)} value={selecione30Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia6(e.target.value)} value={justifique30Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia6(e.target.value)} value={selecione31Dia6} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia6 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia6(e.target.value)} value={justifique31Dia6} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia6(e.target.value)} value={sonda1Dia6} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia6(e.target.value)} value={responsavel1Dia6} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    




</div> 





):null}


{abrirDia7 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 7</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia7(e.target.value)} value={selecione1Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia7(e.target.value)} value={justifique1Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia7(e.target.value)} value={selecione2Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia7(e.target.value)} value={justifique2Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia7(e.target.value)} value={selecione3Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia7(e.target.value)} value={justifique3Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia7(e.target.value)} value={selecione4Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia7(e.target.value)} value={justifique4Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia7(e.target.value)} value={selecione5Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia7(e.target.value)} value={justifique5Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia7(e.target.value)} value={selecione6Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia7(e.target.value)} value={justifique6Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia7(e.target.value)} value={selecione7Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia7(e.target.value)} value={justifique7Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia7(e.target.value)} value={selecione8Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia7(e.target.value)} value={justifique8Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia7(e.target.value)} value={selecione9Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia7(e.target.value)} value={justifique9Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia7(e.target.value)} value={selecione10Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia7(e.target.value)} value={justifique10Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia7(e.target.value)} value={selecione11Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia7(e.target.value)} value={justifique11Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia7(e.target.value)} value={selecione12Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia7(e.target.value)} value={justifique12Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia7(e.target.value)} value={selecione13Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia7(e.target.value)} value={justifique13Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia7(e.target.value)} value={selecione14Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia7(e.target.value)} value={justifique14Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia7(e.target.value)} value={selecione15Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia7(e.target.value)} value={justifique15Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia7(e.target.value)} value={selecione16Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia7(e.target.value)} value={justifique16Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia7(e.target.value)} value={selecione17Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia7(e.target.value)} value={justifique17Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia7(e.target.value)} value={selecione18Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia7(e.target.value)} value={justifique18Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia7(e.target.value)} value={selecione19Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia7(e.target.value)} value={justifique19Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia7(e.target.value)} value={selecione20Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia7(e.target.value)} value={justifique20Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia7(e.target.value)} value={selecione21Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia7(e.target.value)} value={justifique21Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia7(e.target.value)} value={selecione22Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia7(e.target.value)} value={justifique22Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia7(e.target.value)} value={selecione23Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia7(e.target.value)} value={justifique23Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia7(e.target.value)} value={selecione24Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia7(e.target.value)} value={justifique24Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia7(e.target.value)} value={selecione25Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia7(e.target.value)} value={justifique25Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia7(e.target.value)} value={selecione26Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia7(e.target.value)} value={justifique26Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia7(e.target.value)} value={selecione27Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia7(e.target.value)} value={justifique27Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia7(e.target.value)} value={selecione28Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia7(e.target.value)} value={justifique28Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia7(e.target.value)} value={selecione29Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia7(e.target.value)} value={justifique29Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia7(e.target.value)} value={selecione30Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia7(e.target.value)} value={justifique30Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia7(e.target.value)} value={selecione31Dia7} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia7 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia7(e.target.value)} value={justifique31Dia7} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia7(e.target.value)} value={sonda1Dia7} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia7(e.target.value)} value={responsavel1Dia7} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    




</div> 





):null}

{abrirDia8 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 8</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia8(e.target.value)} value={selecione1Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia8(e.target.value)} value={justifique1Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia8(e.target.value)} value={selecione2Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia8(e.target.value)} value={justifique2Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia8(e.target.value)} value={selecione3Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia8(e.target.value)} value={justifique3Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia8(e.target.value)} value={selecione4Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia8(e.target.value)} value={justifique4Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia8(e.target.value)} value={selecione5Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia8(e.target.value)} value={justifique5Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia8(e.target.value)} value={selecione6Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia8(e.target.value)} value={justifique6Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia8(e.target.value)} value={selecione7Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia8(e.target.value)} value={justifique7Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia8(e.target.value)} value={selecione8Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia8(e.target.value)} value={justifique8Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia8(e.target.value)} value={selecione9Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia8(e.target.value)} value={justifique9Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia8(e.target.value)} value={selecione10Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia8(e.target.value)} value={justifique10Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia8(e.target.value)} value={selecione11Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia8(e.target.value)} value={justifique11Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia8(e.target.value)} value={selecione12Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia8(e.target.value)} value={justifique12Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia8(e.target.value)} value={selecione13Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia8(e.target.value)} value={justifique13Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia8(e.target.value)} value={selecione14Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia8(e.target.value)} value={justifique14Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia8(e.target.value)} value={selecione15Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia8(e.target.value)} value={justifique15Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia8(e.target.value)} value={selecione16Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia8(e.target.value)} value={justifique16Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia8(e.target.value)} value={selecione17Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia8(e.target.value)} value={justifique17Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia8(e.target.value)} value={selecione18Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia8(e.target.value)} value={justifique18Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia8(e.target.value)} value={selecione19Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia8(e.target.value)} value={justifique19Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia8(e.target.value)} value={selecione20Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia8(e.target.value)} value={justifique20Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia8(e.target.value)} value={selecione21Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia8(e.target.value)} value={justifique21Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia8(e.target.value)} value={selecione22Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia8(e.target.value)} value={justifique22Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia8(e.target.value)} value={selecione23Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia8(e.target.value)} value={justifique23Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia8(e.target.value)} value={selecione24Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia8(e.target.value)} value={justifique24Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia8(e.target.value)} value={selecione25Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia8(e.target.value)} value={justifique25Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia8(e.target.value)} value={selecione26Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia8(e.target.value)} value={justifique26Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia8(e.target.value)} value={selecione27Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia8(e.target.value)} value={justifique27Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia8(e.target.value)} value={selecione28Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia8(e.target.value)} value={justifique28Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia8(e.target.value)} value={selecione29Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia8(e.target.value)} value={justifique29Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia8(e.target.value)} value={selecione30Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia8(e.target.value)} value={justifique30Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia8(e.target.value)} value={selecione31Dia8} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia8 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia8(e.target.value)} value={justifique31Dia8} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia8(e.target.value)} value={sonda1Dia8} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia8(e.target.value)} value={responsavel1Dia8} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}


{abrirDia9 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 9</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia9(e.target.value)} value={selecione1Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia9(e.target.value)} value={justifique1Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia9(e.target.value)} value={selecione2Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia9(e.target.value)} value={justifique2Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia9(e.target.value)} value={selecione3Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia9(e.target.value)} value={justifique3Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia9(e.target.value)} value={selecione4Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia9(e.target.value)} value={justifique4Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia9(e.target.value)} value={selecione5Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia9(e.target.value)} value={justifique5Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia9(e.target.value)} value={selecione6Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia9(e.target.value)} value={justifique6Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia9(e.target.value)} value={selecione7Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia9(e.target.value)} value={justifique7Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia9(e.target.value)} value={selecione8Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia9(e.target.value)} value={justifique8Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia9(e.target.value)} value={selecione9Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia9(e.target.value)} value={justifique9Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia9(e.target.value)} value={selecione10Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia9(e.target.value)} value={justifique10Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia9(e.target.value)} value={selecione11Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia9(e.target.value)} value={justifique11Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia9(e.target.value)} value={selecione12Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia9(e.target.value)} value={justifique12Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia9(e.target.value)} value={selecione13Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia9(e.target.value)} value={justifique13Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia9(e.target.value)} value={selecione14Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia9(e.target.value)} value={justifique14Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia9(e.target.value)} value={selecione15Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia9(e.target.value)} value={justifique15Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia9(e.target.value)} value={selecione16Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia9(e.target.value)} value={justifique16Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia9(e.target.value)} value={selecione17Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia9(e.target.value)} value={justifique17Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia9(e.target.value)} value={selecione18Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia9(e.target.value)} value={justifique18Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia9(e.target.value)} value={selecione19Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia9(e.target.value)} value={justifique19Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia9(e.target.value)} value={selecione20Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia9(e.target.value)} value={justifique20Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia9(e.target.value)} value={selecione21Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia9(e.target.value)} value={justifique21Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia9(e.target.value)} value={selecione22Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia9(e.target.value)} value={justifique22Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia9(e.target.value)} value={selecione23Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia9(e.target.value)} value={justifique23Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia9(e.target.value)} value={selecione24Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia9(e.target.value)} value={justifique24Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia9(e.target.value)} value={selecione25Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia9(e.target.value)} value={justifique25Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia9(e.target.value)} value={selecione26Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia9(e.target.value)} value={justifique26Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia9(e.target.value)} value={selecione27Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia9(e.target.value)} value={justifique27Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia9(e.target.value)} value={selecione28Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia9(e.target.value)} value={justifique28Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia9(e.target.value)} value={selecione29Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia9(e.target.value)} value={justifique29Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia9(e.target.value)} value={selecione30Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia9(e.target.value)} value={justifique30Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia9(e.target.value)} value={selecione31Dia9} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia9 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia9(e.target.value)} value={justifique31Dia9} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia9(e.target.value)} value={sonda1Dia9} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia9(e.target.value)} value={responsavel1Dia9} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia10 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 10</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia10(e.target.value)} value={selecione1Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia10(e.target.value)} value={justifique1Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia10(e.target.value)} value={selecione2Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia10(e.target.value)} value={justifique2Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia10(e.target.value)} value={selecione3Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia10(e.target.value)} value={justifique3Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia10(e.target.value)} value={selecione4Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia10(e.target.value)} value={justifique4Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia10(e.target.value)} value={selecione5Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia10(e.target.value)} value={justifique5Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia10(e.target.value)} value={selecione6Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia10(e.target.value)} value={justifique6Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia10(e.target.value)} value={selecione7Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia10(e.target.value)} value={justifique7Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia10(e.target.value)} value={selecione8Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia10(e.target.value)} value={justifique8Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia10(e.target.value)} value={selecione9Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia10(e.target.value)} value={justifique9Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia10(e.target.value)} value={selecione10Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia10(e.target.value)} value={justifique10Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia10(e.target.value)} value={selecione11Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia10(e.target.value)} value={justifique11Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia10(e.target.value)} value={selecione12Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia10(e.target.value)} value={justifique12Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia10(e.target.value)} value={selecione13Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia10(e.target.value)} value={justifique13Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia10(e.target.value)} value={selecione14Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia10(e.target.value)} value={justifique14Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia10(e.target.value)} value={selecione15Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia10(e.target.value)} value={justifique15Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia10(e.target.value)} value={selecione16Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia10(e.target.value)} value={justifique16Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia10(e.target.value)} value={selecione17Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia10(e.target.value)} value={justifique17Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia10(e.target.value)} value={selecione18Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia10(e.target.value)} value={justifique18Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia10(e.target.value)} value={selecione19Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia10(e.target.value)} value={justifique19Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia10(e.target.value)} value={selecione20Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia10(e.target.value)} value={justifique20Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia10(e.target.value)} value={selecione21Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia10(e.target.value)} value={justifique21Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia10(e.target.value)} value={selecione22Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia10(e.target.value)} value={justifique22Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia10(e.target.value)} value={selecione23Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia10(e.target.value)} value={justifique23Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia10(e.target.value)} value={selecione24Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia10(e.target.value)} value={justifique24Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia10(e.target.value)} value={selecione25Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia10(e.target.value)} value={justifique25Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia10(e.target.value)} value={selecione26Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia10(e.target.value)} value={justifique26Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia10(e.target.value)} value={selecione27Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia10(e.target.value)} value={justifique27Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia10(e.target.value)} value={selecione28Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia10(e.target.value)} value={justifique28Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia10(e.target.value)} value={selecione29Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia10(e.target.value)} value={justifique29Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia10(e.target.value)} value={selecione30Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia10(e.target.value)} value={justifique30Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia10(e.target.value)} value={selecione31Dia10} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia10 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia10(e.target.value)} value={justifique31Dia10} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia10(e.target.value)} value={sonda1Dia10} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia10(e.target.value)} value={responsavel1Dia10} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}


{abrirDia11 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 11</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia11(e.target.value)} value={selecione1Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia11(e.target.value)} value={justifique1Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia11(e.target.value)} value={selecione2Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia11(e.target.value)} value={justifique2Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia11(e.target.value)} value={selecione3Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia11(e.target.value)} value={justifique3Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia11(e.target.value)} value={selecione4Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia11(e.target.value)} value={justifique4Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia11(e.target.value)} value={selecione5Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia11(e.target.value)} value={justifique5Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia11(e.target.value)} value={selecione6Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia11(e.target.value)} value={justifique6Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia11(e.target.value)} value={selecione7Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia11(e.target.value)} value={justifique7Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia11(e.target.value)} value={selecione8Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia11(e.target.value)} value={justifique8Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia11(e.target.value)} value={selecione9Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia11(e.target.value)} value={justifique9Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia11(e.target.value)} value={selecione10Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia11(e.target.value)} value={justifique10Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia11(e.target.value)} value={selecione11Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia11(e.target.value)} value={justifique11Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia11(e.target.value)} value={selecione12Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia11(e.target.value)} value={justifique12Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia11(e.target.value)} value={selecione13Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia11(e.target.value)} value={justifique13Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia11(e.target.value)} value={selecione14Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia11(e.target.value)} value={justifique14Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia11(e.target.value)} value={selecione15Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia11(e.target.value)} value={justifique15Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia11(e.target.value)} value={selecione16Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia11(e.target.value)} value={justifique16Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia11(e.target.value)} value={selecione17Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia11(e.target.value)} value={justifique17Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia11(e.target.value)} value={selecione18Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia11(e.target.value)} value={justifique18Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia11(e.target.value)} value={selecione19Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia11(e.target.value)} value={justifique19Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia11(e.target.value)} value={selecione20Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia11(e.target.value)} value={justifique20Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia11(e.target.value)} value={selecione21Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia11(e.target.value)} value={justifique21Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia11(e.target.value)} value={selecione22Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia11(e.target.value)} value={justifique22Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia11(e.target.value)} value={selecione23Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia11(e.target.value)} value={justifique23Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia11(e.target.value)} value={selecione24Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia11(e.target.value)} value={justifique24Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia11(e.target.value)} value={selecione25Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia11(e.target.value)} value={justifique25Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia11(e.target.value)} value={selecione26Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia11(e.target.value)} value={justifique26Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia11(e.target.value)} value={selecione27Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia11(e.target.value)} value={justifique27Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia11(e.target.value)} value={selecione28Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia11(e.target.value)} value={justifique28Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia11(e.target.value)} value={selecione29Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia11(e.target.value)} value={justifique29Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia11(e.target.value)} value={selecione30Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia11(e.target.value)} value={justifique30Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia11(e.target.value)} value={selecione31Dia11} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia11 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia11(e.target.value)} value={justifique31Dia11} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia11(e.target.value)} value={sonda1Dia11} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia11(e.target.value)} value={responsavel1Dia11} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia12 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 12</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia12(e.target.value)} value={selecione1Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia12(e.target.value)} value={justifique1Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia12(e.target.value)} value={selecione2Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia12(e.target.value)} value={justifique2Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia12(e.target.value)} value={selecione3Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia12(e.target.value)} value={justifique3Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia12(e.target.value)} value={selecione4Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia12(e.target.value)} value={justifique4Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia12(e.target.value)} value={selecione5Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia12(e.target.value)} value={justifique5Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia12(e.target.value)} value={selecione6Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia12(e.target.value)} value={justifique6Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia12(e.target.value)} value={selecione7Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia12(e.target.value)} value={justifique7Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia12(e.target.value)} value={selecione8Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia12(e.target.value)} value={justifique8Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia12(e.target.value)} value={selecione9Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia12(e.target.value)} value={justifique9Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia12(e.target.value)} value={selecione10Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia12(e.target.value)} value={justifique10Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia12(e.target.value)} value={selecione11Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia12(e.target.value)} value={justifique11Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia12(e.target.value)} value={selecione12Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia12(e.target.value)} value={justifique12Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia12(e.target.value)} value={selecione13Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia12(e.target.value)} value={justifique13Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia12(e.target.value)} value={selecione14Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia12(e.target.value)} value={justifique14Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia12(e.target.value)} value={selecione15Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia12(e.target.value)} value={justifique15Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia12(e.target.value)} value={selecione16Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia12(e.target.value)} value={justifique16Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia12(e.target.value)} value={selecione17Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia12(e.target.value)} value={justifique17Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia12(e.target.value)} value={selecione18Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia12(e.target.value)} value={justifique18Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia12(e.target.value)} value={selecione19Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia12(e.target.value)} value={justifique19Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia12(e.target.value)} value={selecione20Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia12(e.target.value)} value={justifique20Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia12(e.target.value)} value={selecione21Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia12(e.target.value)} value={justifique21Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia12(e.target.value)} value={selecione22Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia12(e.target.value)} value={justifique22Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia12(e.target.value)} value={selecione23Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia12(e.target.value)} value={justifique23Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia12(e.target.value)} value={selecione24Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia12(e.target.value)} value={justifique24Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia12(e.target.value)} value={selecione25Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia12(e.target.value)} value={justifique25Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia12(e.target.value)} value={selecione26Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia12(e.target.value)} value={justifique26Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia12(e.target.value)} value={selecione27Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia12(e.target.value)} value={justifique27Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia12(e.target.value)} value={selecione28Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia12(e.target.value)} value={justifique28Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia12(e.target.value)} value={selecione29Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia12(e.target.value)} value={justifique29Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia12(e.target.value)} value={selecione30Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia12(e.target.value)} value={justifique30Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia12(e.target.value)} value={selecione31Dia12} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia12 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia12(e.target.value)} value={justifique31Dia12} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia12(e.target.value)} value={sonda1Dia12} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia12(e.target.value)} value={responsavel1Dia12} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia13 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 13</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia13(e.target.value)} value={selecione1Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia13(e.target.value)} value={justifique1Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia13(e.target.value)} value={selecione2Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia13(e.target.value)} value={justifique2Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia13(e.target.value)} value={selecione3Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia13(e.target.value)} value={justifique3Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia13(e.target.value)} value={selecione4Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia13(e.target.value)} value={justifique4Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia13(e.target.value)} value={selecione5Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia13(e.target.value)} value={justifique5Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia13(e.target.value)} value={selecione6Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia13(e.target.value)} value={justifique6Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia13(e.target.value)} value={selecione7Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia13(e.target.value)} value={justifique7Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia13(e.target.value)} value={selecione8Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia13(e.target.value)} value={justifique8Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia13(e.target.value)} value={selecione9Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia13(e.target.value)} value={justifique9Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia13(e.target.value)} value={selecione10Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia13(e.target.value)} value={justifique10Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia13(e.target.value)} value={selecione11Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia13(e.target.value)} value={justifique11Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia13(e.target.value)} value={selecione12Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia13(e.target.value)} value={justifique12Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia13(e.target.value)} value={selecione13Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia13(e.target.value)} value={justifique13Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia13(e.target.value)} value={selecione14Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia13(e.target.value)} value={justifique14Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia13(e.target.value)} value={selecione15Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia13(e.target.value)} value={justifique15Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia13(e.target.value)} value={selecione16Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia13(e.target.value)} value={justifique16Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia13(e.target.value)} value={selecione17Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia13(e.target.value)} value={justifique17Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia13(e.target.value)} value={selecione18Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia13(e.target.value)} value={justifique18Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia13(e.target.value)} value={selecione19Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia13(e.target.value)} value={justifique19Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia13(e.target.value)} value={selecione20Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia13(e.target.value)} value={justifique20Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia13(e.target.value)} value={selecione21Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia13(e.target.value)} value={justifique21Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia13(e.target.value)} value={selecione22Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia13(e.target.value)} value={justifique22Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia13(e.target.value)} value={selecione23Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia13(e.target.value)} value={justifique23Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia13(e.target.value)} value={selecione24Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia13(e.target.value)} value={justifique24Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia13(e.target.value)} value={selecione25Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia13(e.target.value)} value={justifique25Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia13(e.target.value)} value={selecione26Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia13(e.target.value)} value={justifique26Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia13(e.target.value)} value={selecione27Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia13(e.target.value)} value={justifique27Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia13(e.target.value)} value={selecione28Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia13(e.target.value)} value={justifique28Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia13(e.target.value)} value={selecione29Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia13(e.target.value)} value={justifique29Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia13(e.target.value)} value={selecione30Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia13(e.target.value)} value={justifique30Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia13(e.target.value)} value={selecione31Dia13} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia13 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia13(e.target.value)} value={justifique31Dia13} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia13(e.target.value)} value={sonda1Dia13} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia13(e.target.value)} value={responsavel1Dia13} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia14 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 14</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia14(e.target.value)} value={selecione1Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia14(e.target.value)} value={justifique1Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia14(e.target.value)} value={selecione2Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia14(e.target.value)} value={justifique2Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia14(e.target.value)} value={selecione3Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia14(e.target.value)} value={justifique3Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia14(e.target.value)} value={selecione4Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia14(e.target.value)} value={justifique4Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia14(e.target.value)} value={selecione5Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia14(e.target.value)} value={justifique5Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia14(e.target.value)} value={selecione6Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia14(e.target.value)} value={justifique6Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia14(e.target.value)} value={selecione7Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia14(e.target.value)} value={justifique7Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia14(e.target.value)} value={selecione8Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia14(e.target.value)} value={justifique8Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia14(e.target.value)} value={selecione9Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia14(e.target.value)} value={justifique9Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia14(e.target.value)} value={selecione10Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia14(e.target.value)} value={justifique10Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia14(e.target.value)} value={selecione11Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia14(e.target.value)} value={justifique11Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia14(e.target.value)} value={selecione12Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia14(e.target.value)} value={justifique12Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia14(e.target.value)} value={selecione13Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia14(e.target.value)} value={justifique13Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia14(e.target.value)} value={selecione14Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia14(e.target.value)} value={justifique14Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia14(e.target.value)} value={selecione15Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia14(e.target.value)} value={justifique15Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia14(e.target.value)} value={selecione16Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia14(e.target.value)} value={justifique16Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia14(e.target.value)} value={selecione17Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia14(e.target.value)} value={justifique17Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia14(e.target.value)} value={selecione18Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia14(e.target.value)} value={justifique18Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia14(e.target.value)} value={selecione19Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia14(e.target.value)} value={justifique19Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia14(e.target.value)} value={selecione20Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia14(e.target.value)} value={justifique20Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia14(e.target.value)} value={selecione21Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia14(e.target.value)} value={justifique21Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia14(e.target.value)} value={selecione22Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia14(e.target.value)} value={justifique22Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia14(e.target.value)} value={selecione23Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia14(e.target.value)} value={justifique23Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia14(e.target.value)} value={selecione24Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia14(e.target.value)} value={justifique24Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia14(e.target.value)} value={selecione25Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia14(e.target.value)} value={justifique25Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia14(e.target.value)} value={selecione26Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia14(e.target.value)} value={justifique26Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia14(e.target.value)} value={selecione27Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia14(e.target.value)} value={justifique27Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia14(e.target.value)} value={selecione28Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia14(e.target.value)} value={justifique28Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia14(e.target.value)} value={selecione29Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia14(e.target.value)} value={justifique29Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia14(e.target.value)} value={selecione30Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia14(e.target.value)} value={justifique30Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia14(e.target.value)} value={selecione31Dia14} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia14 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia14(e.target.value)} value={justifique31Dia14} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia14(e.target.value)} value={sonda1Dia14} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia14(e.target.value)} value={responsavel1Dia14} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}


{abrirDia15 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 15</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia15(e.target.value)} value={selecione1Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia15(e.target.value)} value={justifique1Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia15(e.target.value)} value={selecione2Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia15(e.target.value)} value={justifique2Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia15(e.target.value)} value={selecione3Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia15(e.target.value)} value={justifique3Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia15(e.target.value)} value={selecione4Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia15(e.target.value)} value={justifique4Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia15(e.target.value)} value={selecione5Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia15(e.target.value)} value={justifique5Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia15(e.target.value)} value={selecione6Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia15(e.target.value)} value={justifique6Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia15(e.target.value)} value={selecione7Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia15(e.target.value)} value={justifique7Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia15(e.target.value)} value={selecione8Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia15(e.target.value)} value={justifique8Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia15(e.target.value)} value={selecione9Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia15(e.target.value)} value={justifique9Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia15(e.target.value)} value={selecione10Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia15(e.target.value)} value={justifique10Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia15(e.target.value)} value={selecione11Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia15(e.target.value)} value={justifique11Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia15(e.target.value)} value={selecione12Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia15(e.target.value)} value={justifique12Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia15(e.target.value)} value={selecione13Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia15(e.target.value)} value={justifique13Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia15(e.target.value)} value={selecione14Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia15(e.target.value)} value={justifique14Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia15(e.target.value)} value={selecione15Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia15(e.target.value)} value={justifique15Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia15(e.target.value)} value={selecione16Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia15(e.target.value)} value={justifique16Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia15(e.target.value)} value={selecione17Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia15(e.target.value)} value={justifique17Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia15(e.target.value)} value={selecione18Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia15(e.target.value)} value={justifique18Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia15(e.target.value)} value={selecione19Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia15(e.target.value)} value={justifique19Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia15(e.target.value)} value={selecione20Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia15(e.target.value)} value={justifique20Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia15(e.target.value)} value={selecione21Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia15(e.target.value)} value={justifique21Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia15(e.target.value)} value={selecione22Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia15(e.target.value)} value={justifique22Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia15(e.target.value)} value={selecione23Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia15(e.target.value)} value={justifique23Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia15(e.target.value)} value={selecione24Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia15(e.target.value)} value={justifique24Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia15(e.target.value)} value={selecione25Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia15(e.target.value)} value={justifique25Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia15(e.target.value)} value={selecione26Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia15(e.target.value)} value={justifique26Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia15(e.target.value)} value={selecione27Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia15(e.target.value)} value={justifique27Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia15(e.target.value)} value={selecione28Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia15(e.target.value)} value={justifique28Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia15(e.target.value)} value={selecione29Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia15(e.target.value)} value={justifique29Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia15(e.target.value)} value={selecione30Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia15(e.target.value)} value={justifique30Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia15(e.target.value)} value={selecione31Dia15} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia15 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia15(e.target.value)} value={justifique31Dia15} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia15(e.target.value)} value={sonda1Dia15} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia15(e.target.value)} value={responsavel1Dia15} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia16 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 16</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia16(e.target.value)} value={selecione1Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia16(e.target.value)} value={justifique1Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia16(e.target.value)} value={selecione2Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia16(e.target.value)} value={justifique2Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia16(e.target.value)} value={selecione3Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia16(e.target.value)} value={justifique3Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia16(e.target.value)} value={selecione4Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia16(e.target.value)} value={justifique4Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia16(e.target.value)} value={selecione5Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia16(e.target.value)} value={justifique5Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia16(e.target.value)} value={selecione6Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia16(e.target.value)} value={justifique6Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia16(e.target.value)} value={selecione7Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia16(e.target.value)} value={justifique7Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia16(e.target.value)} value={selecione8Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia16(e.target.value)} value={justifique8Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia16(e.target.value)} value={selecione9Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia16(e.target.value)} value={justifique9Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia16(e.target.value)} value={selecione10Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia16(e.target.value)} value={justifique10Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia16(e.target.value)} value={selecione11Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia16(e.target.value)} value={justifique11Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia16(e.target.value)} value={selecione12Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia16(e.target.value)} value={justifique12Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia16(e.target.value)} value={selecione13Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia16(e.target.value)} value={justifique13Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia16(e.target.value)} value={selecione14Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia16(e.target.value)} value={justifique14Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia16(e.target.value)} value={selecione15Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia16(e.target.value)} value={justifique15Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia16(e.target.value)} value={selecione16Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia16(e.target.value)} value={justifique16Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia16(e.target.value)} value={selecione17Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia16(e.target.value)} value={justifique17Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia16(e.target.value)} value={selecione18Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia16(e.target.value)} value={justifique18Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia16(e.target.value)} value={selecione19Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia16(e.target.value)} value={justifique19Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia16(e.target.value)} value={selecione20Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia16(e.target.value)} value={justifique20Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia16(e.target.value)} value={selecione21Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia16(e.target.value)} value={justifique21Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia16(e.target.value)} value={selecione22Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia16(e.target.value)} value={justifique22Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia16(e.target.value)} value={selecione23Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia16(e.target.value)} value={justifique23Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia16(e.target.value)} value={selecione24Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia16(e.target.value)} value={justifique24Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia16(e.target.value)} value={selecione25Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia16(e.target.value)} value={justifique25Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia16(e.target.value)} value={selecione26Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia16(e.target.value)} value={justifique26Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia16(e.target.value)} value={selecione27Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia16(e.target.value)} value={justifique27Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia16(e.target.value)} value={selecione28Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia16(e.target.value)} value={justifique28Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia16(e.target.value)} value={selecione29Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia16(e.target.value)} value={justifique29Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia16(e.target.value)} value={selecione30Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia16(e.target.value)} value={justifique30Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia16(e.target.value)} value={selecione31Dia16} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia16 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia16(e.target.value)} value={justifique31Dia16} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia16(e.target.value)} value={sonda1Dia16} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia16(e.target.value)} value={responsavel1Dia16} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia17 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 17</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia17(e.target.value)} value={selecione1Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia17(e.target.value)} value={justifique1Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia17(e.target.value)} value={selecione2Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia17(e.target.value)} value={justifique2Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia17(e.target.value)} value={selecione3Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia17(e.target.value)} value={justifique3Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia17(e.target.value)} value={selecione4Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia17(e.target.value)} value={justifique4Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia17(e.target.value)} value={selecione5Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia17(e.target.value)} value={justifique5Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia17(e.target.value)} value={selecione6Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia17(e.target.value)} value={justifique6Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia17(e.target.value)} value={selecione7Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia17(e.target.value)} value={justifique7Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia17(e.target.value)} value={selecione8Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia17(e.target.value)} value={justifique8Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia17(e.target.value)} value={selecione9Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia17(e.target.value)} value={justifique9Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia17(e.target.value)} value={selecione10Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia17(e.target.value)} value={justifique10Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia17(e.target.value)} value={selecione11Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia17(e.target.value)} value={justifique11Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia17(e.target.value)} value={selecione12Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia17(e.target.value)} value={justifique12Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia17(e.target.value)} value={selecione13Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia17(e.target.value)} value={justifique13Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia17(e.target.value)} value={selecione14Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia17(e.target.value)} value={justifique14Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia17(e.target.value)} value={selecione15Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia17(e.target.value)} value={justifique15Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia17(e.target.value)} value={selecione16Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia17(e.target.value)} value={justifique16Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia17(e.target.value)} value={selecione17Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia17(e.target.value)} value={justifique17Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia17(e.target.value)} value={selecione18Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia17(e.target.value)} value={justifique18Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia17(e.target.value)} value={selecione19Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia17(e.target.value)} value={justifique19Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia17(e.target.value)} value={selecione20Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia17(e.target.value)} value={justifique20Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia17(e.target.value)} value={selecione21Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia17(e.target.value)} value={justifique21Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia17(e.target.value)} value={selecione22Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia17(e.target.value)} value={justifique22Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia17(e.target.value)} value={selecione23Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia17(e.target.value)} value={justifique23Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia17(e.target.value)} value={selecione24Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia17(e.target.value)} value={justifique24Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia17(e.target.value)} value={selecione25Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia17(e.target.value)} value={justifique25Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia17(e.target.value)} value={selecione26Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia17(e.target.value)} value={justifique26Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia17(e.target.value)} value={selecione27Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia17(e.target.value)} value={justifique27Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia17(e.target.value)} value={selecione28Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia17(e.target.value)} value={justifique28Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia17(e.target.value)} value={selecione29Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia17(e.target.value)} value={justifique29Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia17(e.target.value)} value={selecione30Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia17(e.target.value)} value={justifique30Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia17(e.target.value)} value={selecione31Dia17} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia17 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia17(e.target.value)} value={justifique31Dia17} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia17(e.target.value)} value={sonda1Dia17} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia17(e.target.value)} value={responsavel1Dia17} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia18 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 18</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia18(e.target.value)} value={selecione1Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia18(e.target.value)} value={justifique1Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia18(e.target.value)} value={selecione2Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia18(e.target.value)} value={justifique2Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia18(e.target.value)} value={selecione3Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia18(e.target.value)} value={justifique3Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia18(e.target.value)} value={selecione4Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia18(e.target.value)} value={justifique4Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia18(e.target.value)} value={selecione5Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia18(e.target.value)} value={justifique5Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia18(e.target.value)} value={selecione6Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia18(e.target.value)} value={justifique6Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia18(e.target.value)} value={selecione7Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia18(e.target.value)} value={justifique7Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia18(e.target.value)} value={selecione8Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia18(e.target.value)} value={justifique8Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia18(e.target.value)} value={selecione9Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia18(e.target.value)} value={justifique9Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia18(e.target.value)} value={selecione10Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia18(e.target.value)} value={justifique10Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia18(e.target.value)} value={selecione11Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia18(e.target.value)} value={justifique11Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia18(e.target.value)} value={selecione12Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia18(e.target.value)} value={justifique12Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia18(e.target.value)} value={selecione13Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia18(e.target.value)} value={justifique13Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia18(e.target.value)} value={selecione14Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia18(e.target.value)} value={justifique14Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia18(e.target.value)} value={selecione15Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia18(e.target.value)} value={justifique15Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia18(e.target.value)} value={selecione16Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia18(e.target.value)} value={justifique16Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia18(e.target.value)} value={selecione17Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia18(e.target.value)} value={justifique17Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia18(e.target.value)} value={selecione18Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia18(e.target.value)} value={justifique18Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia18(e.target.value)} value={selecione19Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia18(e.target.value)} value={justifique19Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia18(e.target.value)} value={selecione20Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia18(e.target.value)} value={justifique20Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia18(e.target.value)} value={selecione21Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia18(e.target.value)} value={justifique21Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia18(e.target.value)} value={selecione22Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia18(e.target.value)} value={justifique22Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia18(e.target.value)} value={selecione23Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia18(e.target.value)} value={justifique23Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia18(e.target.value)} value={selecione24Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia18(e.target.value)} value={justifique24Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia18(e.target.value)} value={selecione25Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia18(e.target.value)} value={justifique25Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia18(e.target.value)} value={selecione26Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia18(e.target.value)} value={justifique26Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia18(e.target.value)} value={selecione27Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia18(e.target.value)} value={justifique27Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia18(e.target.value)} value={selecione28Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia18(e.target.value)} value={justifique28Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia18(e.target.value)} value={selecione29Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia18(e.target.value)} value={justifique29Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia18(e.target.value)} value={selecione30Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia18(e.target.value)} value={justifique30Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia18(e.target.value)} value={selecione31Dia18} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia18 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia18(e.target.value)} value={justifique31Dia18} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia18(e.target.value)} value={sonda1Dia18} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia18(e.target.value)} value={responsavel1Dia18} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia19 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 19</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia19(e.target.value)} value={selecione1Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia19(e.target.value)} value={justifique1Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia19(e.target.value)} value={selecione2Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia19(e.target.value)} value={justifique2Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia19(e.target.value)} value={selecione3Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia19(e.target.value)} value={justifique3Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia19(e.target.value)} value={selecione4Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia19(e.target.value)} value={justifique4Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia19(e.target.value)} value={selecione5Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia19(e.target.value)} value={justifique5Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia19(e.target.value)} value={selecione6Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia19(e.target.value)} value={justifique6Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia19(e.target.value)} value={selecione7Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia19(e.target.value)} value={justifique7Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia19(e.target.value)} value={selecione8Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia19(e.target.value)} value={justifique8Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia19(e.target.value)} value={selecione9Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia19(e.target.value)} value={justifique9Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia19(e.target.value)} value={selecione10Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia19(e.target.value)} value={justifique10Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia19(e.target.value)} value={selecione11Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia19(e.target.value)} value={justifique11Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia19(e.target.value)} value={selecione12Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia19(e.target.value)} value={justifique12Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia19(e.target.value)} value={selecione13Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia19(e.target.value)} value={justifique13Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia19(e.target.value)} value={selecione14Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia19(e.target.value)} value={justifique14Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia19(e.target.value)} value={selecione15Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia19(e.target.value)} value={justifique15Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia19(e.target.value)} value={selecione16Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia19(e.target.value)} value={justifique16Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia19(e.target.value)} value={selecione17Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia19(e.target.value)} value={justifique17Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia19(e.target.value)} value={selecione18Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia19(e.target.value)} value={justifique18Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia19(e.target.value)} value={selecione19Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia19(e.target.value)} value={justifique19Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia19(e.target.value)} value={selecione20Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia19(e.target.value)} value={justifique20Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia19(e.target.value)} value={selecione21Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia19(e.target.value)} value={justifique21Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia19(e.target.value)} value={selecione22Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia19(e.target.value)} value={justifique22Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia19(e.target.value)} value={selecione23Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia19(e.target.value)} value={justifique23Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia19(e.target.value)} value={selecione24Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia19(e.target.value)} value={justifique24Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia19(e.target.value)} value={selecione25Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia19(e.target.value)} value={justifique25Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia19(e.target.value)} value={selecione26Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia19(e.target.value)} value={justifique26Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia19(e.target.value)} value={selecione27Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia19(e.target.value)} value={justifique27Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia19(e.target.value)} value={selecione28Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia19(e.target.value)} value={justifique28Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia19(e.target.value)} value={selecione29Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia19(e.target.value)} value={justifique29Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia19(e.target.value)} value={selecione30Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia19(e.target.value)} value={justifique30Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia19(e.target.value)} value={selecione31Dia19} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia19 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia19(e.target.value)} value={justifique31Dia19} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia19(e.target.value)} value={sonda1Dia19} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia19(e.target.value)} value={responsavel1Dia19} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia20 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 
<h5  className=" mb-2 " > Dia 20</h5>


<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia20(e.target.value)} value={selecione1Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia20(e.target.value)} value={justifique1Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia20(e.target.value)} value={selecione2Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia20(e.target.value)} value={justifique2Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia20(e.target.value)} value={selecione3Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia20(e.target.value)} value={justifique3Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia20(e.target.value)} value={selecione4Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia20(e.target.value)} value={justifique4Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia20(e.target.value)} value={selecione5Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia20(e.target.value)} value={justifique5Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia20(e.target.value)} value={selecione6Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia20(e.target.value)} value={justifique6Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia20(e.target.value)} value={selecione7Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia20(e.target.value)} value={justifique7Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia20(e.target.value)} value={selecione8Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia20(e.target.value)} value={justifique8Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia20(e.target.value)} value={selecione9Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia20(e.target.value)} value={justifique9Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia20(e.target.value)} value={selecione10Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia20(e.target.value)} value={justifique10Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia20(e.target.value)} value={selecione11Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia20(e.target.value)} value={justifique11Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia20(e.target.value)} value={selecione12Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia20(e.target.value)} value={justifique12Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia20(e.target.value)} value={selecione13Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia20(e.target.value)} value={justifique13Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia20(e.target.value)} value={selecione14Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia20(e.target.value)} value={justifique14Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia20(e.target.value)} value={selecione15Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia20(e.target.value)} value={justifique15Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia20(e.target.value)} value={selecione16Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia20(e.target.value)} value={justifique16Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia20(e.target.value)} value={selecione17Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia20(e.target.value)} value={justifique17Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia20(e.target.value)} value={selecione18Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia20(e.target.value)} value={justifique18Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia20(e.target.value)} value={selecione19Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia20(e.target.value)} value={justifique19Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia20(e.target.value)} value={selecione20Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia20(e.target.value)} value={justifique20Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia20(e.target.value)} value={selecione21Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia20(e.target.value)} value={justifique21Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia20(e.target.value)} value={selecione22Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia20(e.target.value)} value={justifique22Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia20(e.target.value)} value={selecione23Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia20(e.target.value)} value={justifique23Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia20(e.target.value)} value={selecione24Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia20(e.target.value)} value={justifique24Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia20(e.target.value)} value={selecione25Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia20(e.target.value)} value={justifique25Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia20(e.target.value)} value={selecione26Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia20(e.target.value)} value={justifique26Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia20(e.target.value)} value={selecione27Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia20(e.target.value)} value={justifique27Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia20(e.target.value)} value={selecione28Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia20(e.target.value)} value={justifique28Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia20(e.target.value)} value={selecione29Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia20(e.target.value)} value={justifique29Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia20(e.target.value)} value={selecione30Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia20(e.target.value)} value={justifique30Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia20(e.target.value)} value={selecione31Dia20} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia20 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia20(e.target.value)} value={justifique31Dia20} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia20(e.target.value)} value={sonda1Dia20} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia20(e.target.value)} value={responsavel1Dia20} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia21 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 21</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia21(e.target.value)} value={selecione1Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia21(e.target.value)} value={justifique1Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia21(e.target.value)} value={selecione2Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia21(e.target.value)} value={justifique2Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia21(e.target.value)} value={selecione3Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia21(e.target.value)} value={justifique3Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia21(e.target.value)} value={selecione4Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia21(e.target.value)} value={justifique4Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia21(e.target.value)} value={selecione5Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia21(e.target.value)} value={justifique5Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia21(e.target.value)} value={selecione6Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia21(e.target.value)} value={justifique6Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia21(e.target.value)} value={selecione7Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia21(e.target.value)} value={justifique7Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia21(e.target.value)} value={selecione8Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia21(e.target.value)} value={justifique8Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia21(e.target.value)} value={selecione9Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia21(e.target.value)} value={justifique9Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia21(e.target.value)} value={selecione10Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia21(e.target.value)} value={justifique10Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia21(e.target.value)} value={selecione11Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia21(e.target.value)} value={justifique11Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia21(e.target.value)} value={selecione12Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia21(e.target.value)} value={justifique12Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia21(e.target.value)} value={selecione13Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia21(e.target.value)} value={justifique13Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia21(e.target.value)} value={selecione14Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia21(e.target.value)} value={justifique14Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia21(e.target.value)} value={selecione15Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia21(e.target.value)} value={justifique15Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia21(e.target.value)} value={selecione16Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia21(e.target.value)} value={justifique16Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia21(e.target.value)} value={selecione17Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia21(e.target.value)} value={justifique17Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia21(e.target.value)} value={selecione18Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia21(e.target.value)} value={justifique18Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia21(e.target.value)} value={selecione19Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia21(e.target.value)} value={justifique19Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia21(e.target.value)} value={selecione20Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia21(e.target.value)} value={justifique20Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia21(e.target.value)} value={selecione21Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia21(e.target.value)} value={justifique21Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia21(e.target.value)} value={selecione22Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia21(e.target.value)} value={justifique22Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia21(e.target.value)} value={selecione23Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia21(e.target.value)} value={justifique23Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia21(e.target.value)} value={selecione24Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia21(e.target.value)} value={justifique24Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia21(e.target.value)} value={selecione25Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia21(e.target.value)} value={justifique25Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia21(e.target.value)} value={selecione26Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia21(e.target.value)} value={justifique26Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia21(e.target.value)} value={selecione27Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia21(e.target.value)} value={justifique27Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia21(e.target.value)} value={selecione28Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia21(e.target.value)} value={justifique28Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia21(e.target.value)} value={selecione29Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia21(e.target.value)} value={justifique29Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia21(e.target.value)} value={selecione30Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia21(e.target.value)} value={justifique30Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia21(e.target.value)} value={selecione31Dia21} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia21 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia21(e.target.value)} value={justifique31Dia21} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia21(e.target.value)} value={sonda1Dia21} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia21(e.target.value)} value={responsavel1Dia21} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia22 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 22</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia22(e.target.value)} value={selecione1Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia22(e.target.value)} value={justifique1Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia22(e.target.value)} value={selecione2Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia22(e.target.value)} value={justifique2Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia22(e.target.value)} value={selecione3Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia22(e.target.value)} value={justifique3Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia22(e.target.value)} value={selecione4Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia22(e.target.value)} value={justifique4Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia22(e.target.value)} value={selecione5Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia22(e.target.value)} value={justifique5Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia22(e.target.value)} value={selecione6Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia22(e.target.value)} value={justifique6Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia22(e.target.value)} value={selecione7Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia22(e.target.value)} value={justifique7Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia22(e.target.value)} value={selecione8Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia22(e.target.value)} value={justifique8Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia22(e.target.value)} value={selecione9Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia22(e.target.value)} value={justifique9Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia22(e.target.value)} value={selecione10Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia22(e.target.value)} value={justifique10Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia22(e.target.value)} value={selecione11Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia22(e.target.value)} value={justifique11Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia22(e.target.value)} value={selecione12Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia22(e.target.value)} value={justifique12Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia22(e.target.value)} value={selecione13Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia22(e.target.value)} value={justifique13Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia22(e.target.value)} value={selecione14Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia22(e.target.value)} value={justifique14Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia22(e.target.value)} value={selecione15Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia22(e.target.value)} value={justifique15Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia22(e.target.value)} value={selecione16Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia22(e.target.value)} value={justifique16Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia22(e.target.value)} value={selecione17Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia22(e.target.value)} value={justifique17Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia22(e.target.value)} value={selecione18Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia22(e.target.value)} value={justifique18Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia22(e.target.value)} value={selecione19Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia22(e.target.value)} value={justifique19Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia22(e.target.value)} value={selecione20Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia22(e.target.value)} value={justifique20Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia22(e.target.value)} value={selecione21Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia22(e.target.value)} value={justifique21Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia22(e.target.value)} value={selecione22Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia22(e.target.value)} value={justifique22Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia22(e.target.value)} value={selecione23Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia22(e.target.value)} value={justifique23Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia22(e.target.value)} value={selecione24Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia22(e.target.value)} value={justifique24Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia22(e.target.value)} value={selecione25Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia22(e.target.value)} value={justifique25Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia22(e.target.value)} value={selecione26Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia22(e.target.value)} value={justifique26Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia22(e.target.value)} value={selecione27Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia22(e.target.value)} value={justifique27Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia22(e.target.value)} value={selecione28Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia22(e.target.value)} value={justifique28Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia22(e.target.value)} value={selecione29Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia22(e.target.value)} value={justifique29Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia22(e.target.value)} value={selecione30Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia22(e.target.value)} value={justifique30Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia22(e.target.value)} value={selecione31Dia22} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia22 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia22(e.target.value)} value={justifique31Dia22} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia22(e.target.value)} value={sonda1Dia22} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia22(e.target.value)} value={responsavel1Dia22} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia23 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5  className=" mb-2 " > Dia 23</h5>

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia23(e.target.value)} value={selecione1Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia23(e.target.value)} value={justifique1Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia23(e.target.value)} value={selecione2Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia23(e.target.value)} value={justifique2Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia23(e.target.value)} value={selecione3Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia23(e.target.value)} value={justifique3Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia23(e.target.value)} value={selecione4Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia23(e.target.value)} value={justifique4Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia23(e.target.value)} value={selecione5Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia23(e.target.value)} value={justifique5Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia23(e.target.value)} value={selecione6Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia23(e.target.value)} value={justifique6Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia23(e.target.value)} value={selecione7Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia23(e.target.value)} value={justifique7Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia23(e.target.value)} value={selecione8Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia23(e.target.value)} value={justifique8Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia23(e.target.value)} value={selecione9Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia23(e.target.value)} value={justifique9Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia23(e.target.value)} value={selecione10Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia23(e.target.value)} value={justifique10Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia23(e.target.value)} value={selecione11Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia23(e.target.value)} value={justifique11Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia23(e.target.value)} value={selecione12Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia23(e.target.value)} value={justifique12Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia23(e.target.value)} value={selecione13Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia23(e.target.value)} value={justifique13Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia23(e.target.value)} value={selecione14Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia23(e.target.value)} value={justifique14Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia23(e.target.value)} value={selecione15Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia23(e.target.value)} value={justifique15Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia23(e.target.value)} value={selecione16Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia23(e.target.value)} value={justifique16Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia23(e.target.value)} value={selecione17Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia23(e.target.value)} value={justifique17Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia23(e.target.value)} value={selecione18Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia23(e.target.value)} value={justifique18Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia23(e.target.value)} value={selecione19Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia23(e.target.value)} value={justifique19Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia23(e.target.value)} value={selecione20Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia23(e.target.value)} value={justifique20Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia23(e.target.value)} value={selecione21Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia23(e.target.value)} value={justifique21Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia23(e.target.value)} value={selecione22Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia23(e.target.value)} value={justifique22Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia23(e.target.value)} value={selecione23Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia23(e.target.value)} value={justifique23Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia23(e.target.value)} value={selecione24Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia23(e.target.value)} value={justifique24Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia23(e.target.value)} value={selecione25Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia23(e.target.value)} value={justifique25Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia23(e.target.value)} value={selecione26Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia23(e.target.value)} value={justifique26Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia23(e.target.value)} value={selecione27Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia23(e.target.value)} value={justifique27Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia23(e.target.value)} value={selecione28Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia23(e.target.value)} value={justifique28Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia23(e.target.value)} value={selecione29Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia23(e.target.value)} value={justifique29Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia23(e.target.value)} value={selecione30Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia23(e.target.value)} value={justifique30Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia23(e.target.value)} value={selecione31Dia23} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia23 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia23(e.target.value)} value={justifique31Dia23} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia23(e.target.value)} value={sonda1Dia23} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia23(e.target.value)} value={responsavel1Dia23} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia24 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 24 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia24(e.target.value)} value={selecione1Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia24(e.target.value)} value={justifique1Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia24(e.target.value)} value={selecione2Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia24(e.target.value)} value={justifique2Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia24(e.target.value)} value={selecione3Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia24(e.target.value)} value={justifique3Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia24(e.target.value)} value={selecione4Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia24(e.target.value)} value={justifique4Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia24(e.target.value)} value={selecione5Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia24(e.target.value)} value={justifique5Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia24(e.target.value)} value={selecione6Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia24(e.target.value)} value={justifique6Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia24(e.target.value)} value={selecione7Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia24(e.target.value)} value={justifique7Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia24(e.target.value)} value={selecione8Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia24(e.target.value)} value={justifique8Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia24(e.target.value)} value={selecione9Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia24(e.target.value)} value={justifique9Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia24(e.target.value)} value={selecione10Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia24(e.target.value)} value={justifique10Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia24(e.target.value)} value={selecione11Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia24(e.target.value)} value={justifique11Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia24(e.target.value)} value={selecione12Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia24(e.target.value)} value={justifique12Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia24(e.target.value)} value={selecione13Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia24(e.target.value)} value={justifique13Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia24(e.target.value)} value={selecione14Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia24(e.target.value)} value={justifique14Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia24(e.target.value)} value={selecione15Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia24(e.target.value)} value={justifique15Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia24(e.target.value)} value={selecione16Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia24(e.target.value)} value={justifique16Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia24(e.target.value)} value={selecione17Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia24(e.target.value)} value={justifique17Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia24(e.target.value)} value={selecione18Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia24(e.target.value)} value={justifique18Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia24(e.target.value)} value={selecione19Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia24(e.target.value)} value={justifique19Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia24(e.target.value)} value={selecione20Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia24(e.target.value)} value={justifique20Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia24(e.target.value)} value={selecione21Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia24(e.target.value)} value={justifique21Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia24(e.target.value)} value={selecione22Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia24(e.target.value)} value={justifique22Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia24(e.target.value)} value={selecione23Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia24(e.target.value)} value={justifique23Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia24(e.target.value)} value={selecione24Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia24(e.target.value)} value={justifique24Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia24(e.target.value)} value={selecione25Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia24(e.target.value)} value={justifique25Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia24(e.target.value)} value={selecione26Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia24(e.target.value)} value={justifique26Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia24(e.target.value)} value={selecione27Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia24(e.target.value)} value={justifique27Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia24(e.target.value)} value={selecione28Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia24(e.target.value)} value={justifique28Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia24(e.target.value)} value={selecione29Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia24(e.target.value)} value={justifique29Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia24(e.target.value)} value={selecione30Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia24(e.target.value)} value={justifique30Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia24(e.target.value)} value={selecione31Dia24} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia24 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia24(e.target.value)} value={justifique31Dia24} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia24(e.target.value)} value={sonda1Dia24} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia24(e.target.value)} value={responsavel1Dia24} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia25 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 25 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia25(e.target.value)} value={selecione1Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia25(e.target.value)} value={justifique1Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia25(e.target.value)} value={selecione2Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia25(e.target.value)} value={justifique2Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia25(e.target.value)} value={selecione3Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia25(e.target.value)} value={justifique3Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia25(e.target.value)} value={selecione4Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia25(e.target.value)} value={justifique4Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia25(e.target.value)} value={selecione5Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia25(e.target.value)} value={justifique5Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia25(e.target.value)} value={selecione6Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia25(e.target.value)} value={justifique6Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia25(e.target.value)} value={selecione7Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia25(e.target.value)} value={justifique7Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia25(e.target.value)} value={selecione8Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia25(e.target.value)} value={justifique8Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia25(e.target.value)} value={selecione9Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia25(e.target.value)} value={justifique9Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia25(e.target.value)} value={selecione10Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia25(e.target.value)} value={justifique10Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia25(e.target.value)} value={selecione11Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia25(e.target.value)} value={justifique11Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia25(e.target.value)} value={selecione12Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia25(e.target.value)} value={justifique12Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia25(e.target.value)} value={selecione13Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia25(e.target.value)} value={justifique13Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia25(e.target.value)} value={selecione14Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia25(e.target.value)} value={justifique14Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia25(e.target.value)} value={selecione15Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia25(e.target.value)} value={justifique15Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia25(e.target.value)} value={selecione16Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia25(e.target.value)} value={justifique16Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia25(e.target.value)} value={selecione17Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia25(e.target.value)} value={justifique17Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia25(e.target.value)} value={selecione18Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia25(e.target.value)} value={justifique18Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia25(e.target.value)} value={selecione19Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia25(e.target.value)} value={justifique19Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia25(e.target.value)} value={selecione20Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia25(e.target.value)} value={justifique20Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia25(e.target.value)} value={selecione21Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia25(e.target.value)} value={justifique21Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia25(e.target.value)} value={selecione22Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia25(e.target.value)} value={justifique22Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia25(e.target.value)} value={selecione23Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia25(e.target.value)} value={justifique23Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia25(e.target.value)} value={selecione24Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia25(e.target.value)} value={justifique24Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia25(e.target.value)} value={selecione25Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia25(e.target.value)} value={justifique25Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia25(e.target.value)} value={selecione26Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia25(e.target.value)} value={justifique26Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia25(e.target.value)} value={selecione27Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia25(e.target.value)} value={justifique27Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia25(e.target.value)} value={selecione28Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia25(e.target.value)} value={justifique28Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia25(e.target.value)} value={selecione29Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia25(e.target.value)} value={justifique29Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia25(e.target.value)} value={selecione30Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia25(e.target.value)} value={justifique30Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia25(e.target.value)} value={selecione31Dia25} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia25 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia25(e.target.value)} value={justifique31Dia25} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia25(e.target.value)} value={sonda1Dia25} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia25(e.target.value)} value={responsavel1Dia25} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia26 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 26 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia26(e.target.value)} value={selecione1Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia26(e.target.value)} value={justifique1Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia26(e.target.value)} value={selecione2Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia26(e.target.value)} value={justifique2Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia26(e.target.value)} value={selecione3Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia26(e.target.value)} value={justifique3Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia26(e.target.value)} value={selecione4Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia26(e.target.value)} value={justifique4Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia26(e.target.value)} value={selecione5Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia26(e.target.value)} value={justifique5Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia26(e.target.value)} value={selecione6Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia26(e.target.value)} value={justifique6Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia26(e.target.value)} value={selecione7Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia26(e.target.value)} value={justifique7Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia26(e.target.value)} value={selecione8Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia26(e.target.value)} value={justifique8Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia26(e.target.value)} value={selecione9Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia26(e.target.value)} value={justifique9Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia26(e.target.value)} value={selecione10Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia26(e.target.value)} value={justifique10Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia26(e.target.value)} value={selecione11Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia26(e.target.value)} value={justifique11Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia26(e.target.value)} value={selecione12Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia26(e.target.value)} value={justifique12Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia26(e.target.value)} value={selecione13Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia26(e.target.value)} value={justifique13Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia26(e.target.value)} value={selecione14Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia26(e.target.value)} value={justifique14Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia26(e.target.value)} value={selecione15Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia26(e.target.value)} value={justifique15Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia26(e.target.value)} value={selecione16Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia26(e.target.value)} value={justifique16Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia26(e.target.value)} value={selecione17Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia26(e.target.value)} value={justifique17Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia26(e.target.value)} value={selecione18Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia26(e.target.value)} value={justifique18Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia26(e.target.value)} value={selecione19Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia26(e.target.value)} value={justifique19Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia26(e.target.value)} value={selecione20Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia26(e.target.value)} value={justifique20Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia26(e.target.value)} value={selecione21Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia26(e.target.value)} value={justifique21Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia26(e.target.value)} value={selecione22Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia26(e.target.value)} value={justifique22Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia26(e.target.value)} value={selecione23Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia26(e.target.value)} value={justifique23Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia26(e.target.value)} value={selecione24Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia26(e.target.value)} value={justifique24Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia26(e.target.value)} value={selecione25Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia26(e.target.value)} value={justifique25Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia26(e.target.value)} value={selecione26Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia26(e.target.value)} value={justifique26Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia26(e.target.value)} value={selecione27Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia26(e.target.value)} value={justifique27Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia26(e.target.value)} value={selecione28Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia26(e.target.value)} value={justifique28Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia26(e.target.value)} value={selecione29Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia26(e.target.value)} value={justifique29Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia26(e.target.value)} value={selecione30Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia26(e.target.value)} value={justifique30Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia26(e.target.value)} value={selecione31Dia26} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia26 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia26(e.target.value)} value={justifique31Dia26} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia26(e.target.value)} value={sonda1Dia26} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia26(e.target.value)} value={responsavel1Dia26} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia27 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 27 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia27(e.target.value)} value={selecione1Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia27(e.target.value)} value={justifique1Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia27(e.target.value)} value={selecione2Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia27(e.target.value)} value={justifique2Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia27(e.target.value)} value={selecione3Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia27(e.target.value)} value={justifique3Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia27(e.target.value)} value={selecione4Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia27(e.target.value)} value={justifique4Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia27(e.target.value)} value={selecione5Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia27(e.target.value)} value={justifique5Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia27(e.target.value)} value={selecione6Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia27(e.target.value)} value={justifique6Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia27(e.target.value)} value={selecione7Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia27(e.target.value)} value={justifique7Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia27(e.target.value)} value={selecione8Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia27(e.target.value)} value={justifique8Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia27(e.target.value)} value={selecione9Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia27(e.target.value)} value={justifique9Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia27(e.target.value)} value={selecione10Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia27(e.target.value)} value={justifique10Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia27(e.target.value)} value={selecione11Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia27(e.target.value)} value={justifique11Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia27(e.target.value)} value={selecione12Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia27(e.target.value)} value={justifique12Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia27(e.target.value)} value={selecione13Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia27(e.target.value)} value={justifique13Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia27(e.target.value)} value={selecione14Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia27(e.target.value)} value={justifique14Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia27(e.target.value)} value={selecione15Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia27(e.target.value)} value={justifique15Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia27(e.target.value)} value={selecione16Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia27(e.target.value)} value={justifique16Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia27(e.target.value)} value={selecione17Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia27(e.target.value)} value={justifique17Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia27(e.target.value)} value={selecione18Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia27(e.target.value)} value={justifique18Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia27(e.target.value)} value={selecione19Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia27(e.target.value)} value={justifique19Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia27(e.target.value)} value={selecione20Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia27(e.target.value)} value={justifique20Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia27(e.target.value)} value={selecione21Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia27(e.target.value)} value={justifique21Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia27(e.target.value)} value={selecione22Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia27(e.target.value)} value={justifique22Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia27(e.target.value)} value={selecione23Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia27(e.target.value)} value={justifique23Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia27(e.target.value)} value={selecione24Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia27(e.target.value)} value={justifique24Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia27(e.target.value)} value={selecione25Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia27(e.target.value)} value={justifique25Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia27(e.target.value)} value={selecione26Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia27(e.target.value)} value={justifique26Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia27(e.target.value)} value={selecione27Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia27(e.target.value)} value={justifique27Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia27(e.target.value)} value={selecione28Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia27(e.target.value)} value={justifique28Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia27(e.target.value)} value={selecione29Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia27(e.target.value)} value={justifique29Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia27(e.target.value)} value={selecione30Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia27(e.target.value)} value={justifique30Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia27(e.target.value)} value={selecione31Dia27} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia27 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia27(e.target.value)} value={justifique31Dia27} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia27(e.target.value)} value={sonda1Dia27} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia27(e.target.value)} value={responsavel1Dia27} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia28 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 28 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia28(e.target.value)} value={selecione1Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia28(e.target.value)} value={justifique1Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia28(e.target.value)} value={selecione2Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia28(e.target.value)} value={justifique2Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia28(e.target.value)} value={selecione3Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia28(e.target.value)} value={justifique3Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia28(e.target.value)} value={selecione4Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia28(e.target.value)} value={justifique4Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia28(e.target.value)} value={selecione5Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia28(e.target.value)} value={justifique5Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia28(e.target.value)} value={selecione6Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia28(e.target.value)} value={justifique6Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia28(e.target.value)} value={selecione7Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia28(e.target.value)} value={justifique7Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia28(e.target.value)} value={selecione8Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia28(e.target.value)} value={justifique8Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia28(e.target.value)} value={selecione9Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia28(e.target.value)} value={justifique9Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia28(e.target.value)} value={selecione10Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia28(e.target.value)} value={justifique10Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia28(e.target.value)} value={selecione11Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia28(e.target.value)} value={justifique11Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia28(e.target.value)} value={selecione12Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia28(e.target.value)} value={justifique12Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia28(e.target.value)} value={selecione13Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia28(e.target.value)} value={justifique13Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia28(e.target.value)} value={selecione14Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia28(e.target.value)} value={justifique14Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia28(e.target.value)} value={selecione15Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia28(e.target.value)} value={justifique15Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia28(e.target.value)} value={selecione16Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia28(e.target.value)} value={justifique16Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia28(e.target.value)} value={selecione17Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia28(e.target.value)} value={justifique17Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia28(e.target.value)} value={selecione18Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia28(e.target.value)} value={justifique18Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia28(e.target.value)} value={selecione19Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia28(e.target.value)} value={justifique19Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia28(e.target.value)} value={selecione20Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia28(e.target.value)} value={justifique20Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia28(e.target.value)} value={selecione21Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia28(e.target.value)} value={justifique21Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia28(e.target.value)} value={selecione22Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia28(e.target.value)} value={justifique22Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia28(e.target.value)} value={selecione23Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia28(e.target.value)} value={justifique23Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia28(e.target.value)} value={selecione24Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia28(e.target.value)} value={justifique24Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia28(e.target.value)} value={selecione25Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia28(e.target.value)} value={justifique25Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia28(e.target.value)} value={selecione26Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia28(e.target.value)} value={justifique26Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia28(e.target.value)} value={selecione27Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia28(e.target.value)} value={justifique27Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia28(e.target.value)} value={selecione28Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia28(e.target.value)} value={justifique28Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia28(e.target.value)} value={selecione29Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia28(e.target.value)} value={justifique29Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia28(e.target.value)} value={selecione30Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia28(e.target.value)} value={justifique30Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia28(e.target.value)} value={selecione31Dia28} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia28 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia28(e.target.value)} value={justifique31Dia28} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia28(e.target.value)} value={sonda1Dia28} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia28(e.target.value)} value={responsavel1Dia28} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia29 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 29 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia29(e.target.value)} value={selecione1Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia29(e.target.value)} value={justifique1Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia29(e.target.value)} value={selecione2Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia29(e.target.value)} value={justifique2Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia29(e.target.value)} value={selecione3Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia29(e.target.value)} value={justifique3Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia29(e.target.value)} value={selecione4Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia29(e.target.value)} value={justifique4Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia29(e.target.value)} value={selecione5Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia29(e.target.value)} value={justifique5Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia29(e.target.value)} value={selecione6Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia29(e.target.value)} value={justifique6Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia29(e.target.value)} value={selecione7Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia29(e.target.value)} value={justifique7Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia29(e.target.value)} value={selecione8Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia29(e.target.value)} value={justifique8Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia29(e.target.value)} value={selecione9Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia29(e.target.value)} value={justifique9Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia29(e.target.value)} value={selecione10Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia29(e.target.value)} value={justifique10Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia29(e.target.value)} value={selecione11Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia29(e.target.value)} value={justifique11Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia29(e.target.value)} value={selecione12Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia29(e.target.value)} value={justifique12Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia29(e.target.value)} value={selecione13Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia29(e.target.value)} value={justifique13Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia29(e.target.value)} value={selecione14Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia29(e.target.value)} value={justifique14Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia29(e.target.value)} value={selecione15Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia29(e.target.value)} value={justifique15Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia29(e.target.value)} value={selecione16Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia29(e.target.value)} value={justifique16Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia29(e.target.value)} value={selecione17Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia29(e.target.value)} value={justifique17Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia29(e.target.value)} value={selecione18Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia29(e.target.value)} value={justifique18Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia29(e.target.value)} value={selecione19Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia29(e.target.value)} value={justifique19Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia29(e.target.value)} value={selecione20Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia29(e.target.value)} value={justifique20Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia29(e.target.value)} value={selecione21Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia29(e.target.value)} value={justifique21Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia29(e.target.value)} value={selecione22Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia29(e.target.value)} value={justifique22Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia29(e.target.value)} value={selecione23Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia29(e.target.value)} value={justifique23Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia29(e.target.value)} value={selecione24Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia29(e.target.value)} value={justifique24Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia29(e.target.value)} value={selecione25Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia29(e.target.value)} value={justifique25Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia29(e.target.value)} value={selecione26Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia29(e.target.value)} value={justifique26Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia29(e.target.value)} value={selecione27Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia29(e.target.value)} value={justifique27Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia29(e.target.value)} value={selecione28Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia29(e.target.value)} value={justifique28Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia29(e.target.value)} value={selecione29Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia29(e.target.value)} value={justifique29Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia29(e.target.value)} value={selecione30Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia29(e.target.value)} value={justifique30Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia29(e.target.value)} value={selecione31Dia29} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia29 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia29(e.target.value)} value={justifique31Dia29} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia29(e.target.value)} value={sonda1Dia29} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia29(e.target.value)} value={responsavel1Dia29} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia30 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 30</h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia30(e.target.value)} value={selecione1Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia30(e.target.value)} value={justifique1Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia30(e.target.value)} value={selecione2Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia30(e.target.value)} value={justifique2Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia30(e.target.value)} value={selecione3Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia30(e.target.value)} value={justifique3Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia30(e.target.value)} value={selecione4Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia30(e.target.value)} value={justifique4Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia30(e.target.value)} value={selecione5Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia30(e.target.value)} value={justifique5Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia30(e.target.value)} value={selecione6Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia30(e.target.value)} value={justifique6Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia30(e.target.value)} value={selecione7Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia30(e.target.value)} value={justifique7Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia30(e.target.value)} value={selecione8Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia30(e.target.value)} value={justifique8Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia30(e.target.value)} value={selecione9Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia30(e.target.value)} value={justifique9Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia30(e.target.value)} value={selecione10Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia30(e.target.value)} value={justifique10Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia30(e.target.value)} value={selecione11Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia30(e.target.value)} value={justifique11Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia30(e.target.value)} value={selecione12Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia30(e.target.value)} value={justifique12Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia30(e.target.value)} value={selecione13Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia30(e.target.value)} value={justifique13Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia30(e.target.value)} value={selecione14Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia30(e.target.value)} value={justifique14Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia30(e.target.value)} value={selecione15Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia30(e.target.value)} value={justifique15Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia30(e.target.value)} value={selecione16Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia30(e.target.value)} value={justifique16Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia30(e.target.value)} value={selecione17Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia30(e.target.value)} value={justifique17Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia30(e.target.value)} value={selecione18Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia30(e.target.value)} value={justifique18Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia30(e.target.value)} value={selecione19Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia30(e.target.value)} value={justifique19Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia30(e.target.value)} value={selecione20Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia30(e.target.value)} value={justifique20Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia30(e.target.value)} value={selecione21Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia30(e.target.value)} value={justifique21Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia30(e.target.value)} value={selecione22Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia30(e.target.value)} value={justifique22Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia30(e.target.value)} value={selecione23Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia30(e.target.value)} value={justifique23Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia30(e.target.value)} value={selecione24Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia30(e.target.value)} value={justifique24Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia30(e.target.value)} value={selecione25Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia30(e.target.value)} value={justifique25Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia30(e.target.value)} value={selecione26Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia30(e.target.value)} value={justifique26Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia30(e.target.value)} value={selecione27Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia30(e.target.value)} value={justifique27Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia30(e.target.value)} value={selecione28Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia30(e.target.value)} value={justifique28Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia30(e.target.value)} value={selecione29Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia30(e.target.value)} value={justifique29Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia30(e.target.value)} value={selecione30Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia30(e.target.value)} value={justifique30Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia30(e.target.value)} value={selecione31Dia30} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia30 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia30(e.target.value)} value={justifique31Dia30} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia30(e.target.value)} value={sonda1Dia30} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia30(e.target.value)} value={responsavel1Dia30} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}

{abrirDia31 === true? (


<div className="  col-7 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" > 

<h5> Dia 31 </h5> 

<div className=" container-fluid text-center borda row ">
    <div className=" col-10 text-start mb-2">
    1 - [IMPEDITIVO] A Corrente e/ou malha de segurança contra queda da conexão da mangueira da cabeça d'água, estão instaladas de forma independente? Estão em perfeitas condições de uso, livre de deformações ou qualquer desgaste?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione1Dia31(e.target.value)} value={selecione1Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione1Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique1Dia31(e.target.value)} value={justifique1Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

<div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    2 -  [IMPEDITIVO] A Chave geral está protegida, de fácil acesso, sinalizada e em perfeitas condições de funcionamento e permitindo realização do bloqueio e etiquetagem?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione2Dia31(e.target.value)} value={selecione2Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione2Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique2Dia31(e.target.value)} value={justifique2Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

{/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    3 -  [IMPEDITIVO] A proteção do mandril impede o acesso voluntário ou involuntário em qualquer ângulo (em qualquer inclinação)? A proteção quando aberta, não permite o acesso simultâneo dos comandos e das partes rotativas e ferramental da sonda?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione3Dia31(e.target.value)} value={selecione3Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione3Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique3Dia31(e.target.value)} value={justifique3Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    4 - [IMPEDITIVO] A sonda dispõe no minimo de duas botoeiras de emergência em locais visíveis e de fácil acesso, em funcionamento e com sinalizações adequadas?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione4Dia31(e.target.value)} value={selecione4Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione4Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique4Dia31(e.target.value)} value={justifique4Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    5 - [IMPEDITIVO] As partes quentes, transmissões de força e partes rotativas estão devidamente protegidas, sinalizadas e/ou travadas com sistema de bloqueios com utilização de cadeados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione5Dia31(e.target.value)} value={selecione5Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione5Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique5Dia31(e.target.value)} value={justifique5Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    6 - [IMPEDITIVO] As proteções das sondas estão integras (isentas de trincas e aberturas) que possam permitir o acesso voluntário ou involuntário dos empregados?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione6Dia31(e.target.value)} value={selecione6Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione6Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique6Dia31(e.target.value)} value={justifique6Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    7 - [IMPEDITIVO] Existe Intertravamento do mandril para os movimentos rotacionais e na abertura da proteção para interromper a rotação da composição de hastes?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione7Dia31(e.target.value)} value={selecione7Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione7Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique7Dia31(e.target.value)} value={justifique7Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    8 - [IMPEDITIVO] O dispositivo de monitoramento de descargas atmosféricas está disponível na praça de sondagem e a equipe está ciente do procedimento de segurança para descargas atmosféricas? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione8Dia31(e.target.value)} value={selecione8Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione8Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique8Dia31(e.target.value)} value={justifique8Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    9 - [IMPEDITIVO] Os acessos as partes internas da maquina estão trancados e com porta cadeados? As chaves estão de posse do operador? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione9Dia31(e.target.value)} value={selecione9Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione9Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique9Dia31(e.target.value)} value={justifique9Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    10 - [IMPEDITIVO] A sonda possui pino “R” para travamento do Over Shot, além do giro para travamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione10Dia31(e.target.value)} value={selecione10Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione10Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique10Dia31(e.target.value)} value={justifique10Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    11 - [IMPEDITIVO] O Joystick sem fio está em perfeito funcionamento para a movimentação do equipamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione11Dia31(e.target.value)} value={selecione11Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione11Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique11Dia31(e.target.value)} value={justifique11Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    12 - A sonda possui centralizador de cabo de aço, sensor de fim de curso eletrônico e/ou sistema físico de batentes (modelos de nylon ou metálicos) no cabo principal e no wireline. Está funcionando e em perfeitas condições?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione12Dia31(e.target.value)} value={selecione12Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione12Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique12Dia31(e.target.value)} value={justifique12Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    13 - Os cabos de aço do sistema de tração da sonda e do Wire Line estão em perfeitas condições (sem fios rompidos, amassamento, estrangulamento, dobras, formação de gaiola de pássaro ou pontos de torção e emendas e com sua clipagem conforme padrão/ norma) ?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione13Dia31(e.target.value)} value={selecione13Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione13Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique13Dia31(e.target.value)} value={justifique13Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    14 - As mangueiras/mangotes estão firmes fixas, sem avarias que comprometa a segurança da equipe? As mangueiras pressurizadas possuem dispositivo anti-chicoteamento? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione14Dia31(e.target.value)} value={selecione14Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione14Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique14Dia31(e.target.value)} value={justifique14Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>

   


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    15 - A sirene e o giroflex de movimentação do equipamento esta em perfeito estado de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione15Dia31(e.target.value)} value={selecione15Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione15Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique15Dia31(e.target.value)} value={justifique15Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    16 - Sistema de Aterramento está em perfeitas condições de funcionamento? Equipamento devidamente aterrado? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione16Dia31(e.target.value)} value={selecione16Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione16Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique16Dia31(e.target.value)} value={justifique16Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    17 - Há bandeja de contenção em caso de vazamento de produtos Químicos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione17Dia31(e.target.value)} value={selecione17Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione17Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique17Dia31(e.target.value)} value={justifique17Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    18 - Há extintores de incêndio na praça conforme dimensionamento?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione18Dia31(e.target.value)} value={selecione18Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione18Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique18Dia31(e.target.value)} value={justifique18Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    19 - A torre do equipamento está com todos os pinos e componentes presos?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione19Dia31(e.target.value)} value={selecione19Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione19Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique19Dia31(e.target.value)} value={justifique19Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    20 - A sonda está isenta de vazamentos de óleo/água? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione20Dia31(e.target.value)} value={selecione20Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione20Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique20Dia31(e.target.value)} value={justifique20Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    21 - Existe condições adequadas no equipamento para inserção de bloqueio fisico (Bloqueio e etiquetagem) das fontes de energia e realização de teste residual? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione21Dia31(e.target.value)} value={selecione21Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione21Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique21Dia31(e.target.value)} value={justifique21Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    22 - A sonda está devidamente sinalizada (capacidade de carga dos cabos de força, zonas de perigo, volume de fluídos nos tanques/reservatórios, tag, logotipo, adesivos refletivos, indicação de peso máximo do equipamento, etc.)? As sinalizações estão visíveis e em boas condições? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione22Dia31(e.target.value)} value={selecione22Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione22Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique22Dia31(e.target.value)} value={justifique22Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    23 - Equipamento possui mapeamento das fontes e dos pontos de bloqueio de energias perigosas? A equipe da frente de trabalho esta treinada no procedimento? 
    </div>
    <div className=" mt-2  col-2">
    <select onChange={(e)=> setSelecione23Dia31(e.target.value)} value={selecione23Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione23Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique23Dia31(e.target.value)} value={justifique23Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    24 - Os suportes de içamento de carga estão isentas de trinca ou falhas nas soldas (ganchos,clips)?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione24Dia31(e.target.value)} value={selecione24Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione24Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique24Dia31(e.target.value)} value={justifique24Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    25 - A torre da sonda está devidamente fixada com porcas auto-travantes e contra pinos, sem trincas ou danos visíveis?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione25Dia31(e.target.value)} value={selecione25Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione25Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique25Dia31(e.target.value)} value={justifique25Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    26 - Sistema Hidráulico, caso exista está em perfeitas condições de funcionamento? Sem vazanentos? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione26Dia31(e.target.value)} value={selecione26Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione26Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique26Dia31(e.target.value)} value={justifique26Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    27 - O sistema de pressão / manomêtro está conforme?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione27Dia31(e.target.value)} value={selecione27Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione27Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique27Dia31(e.target.value)} value={justifique27Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>



    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mt-2 mb-2">
    28 - Sistema Elétrico, caso exista, está em perfeitas condições de funcionamento?  
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione28Dia31(e.target.value)} value={selecione28Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione28Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique28Dia31(e.target.value)} value={justifique28Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    29 - Os comandos de rotação e elevação possuem intertravamento das manetes para proteger contra acionamento involuntário?
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione29Dia31(e.target.value)} value={selecione29Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione29Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique29Dia31(e.target.value)} value={justifique29Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    30 - Nivel de óleo do motor e hidraulico está conforme ? Obs.: esta verificação deve ser realizada antes do inicio das atividades, com o equipamento desligado e devidamente bloqueado.
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione30Dia31(e.target.value)} value={selecione30Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione30Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique30Dia31(e.target.value)} value={justifique30Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


    {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
    <div className=" container-fluid text-center borda row mt-2">
    <div className=" col-10 text-start mb-2">
    31 - As esteiras e/ou pneus estão em perfeitas condições de utilização (sem trincas, rachaduras, cortes e perfurações, e indicador de desgaste da banda de rodagem - TWI dentro do limite)? 
    </div>
    <div className=" mt-2 col-2">
    <select onChange={(e)=> setSelecione31Dia31(e.target.value)} value={selecione31Dia31} className=" form-select text-center">
                   <option className="text-start" value={"-"}> Selecione</option>
                   <option className="text-start" value={"Conforme"}> Conforme</option>
                   <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                   <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
               </select>
    </div>
               { selecione31Dia31 === 'Não Conforme'?( <div className=" col-12 align-items-center mt-2 mb-2 ms-2">
            <h6 className="mt-2 ms-2 me-2">Justifique</h6> 
             <textarea   onChange={(e)=> setJustifique31Dia31(e.target.value)} value={justifique31Dia31} cols={100} rows={2} className="  form-control resize w-200 text-center me-3 " ></textarea> </div>):null
           }
    </div>


   




 <div className=" container-fluid row d-flex justify-content-center  align-items-center p-1 mt-3" > 
           <div class="col-auto  ">
           <h6 className="mt-1">Sonda interditada?</h6> 
            </div>

            <div class="col-2  ">
            <select onChange={(e)=> setSonda1Dia31(e.target.value)} value={sonda1Dia31} className=" borda form-select text-center">
            <option className="text-start" value={"-"}> Selecione</option>
            <option className="text-start" value={"sim"}> Sim</option>
            <option className="text-start" value={"não"}> Não</option>
             </select>    
            </div>  

           <div class="col-2 "></div>

            <div class="col-1 ">
            <h6 className="mt-1" >Responsável</h6>         
            </div>

            <div class="col-4 ms-2 ">
            <textarea rows={1}  onChange={(e)=> setResponsavel1Dia31(e.target.value)} value={responsavel1Dia31} className="borda form-control resize w-100 text-center mb-2" ></textarea>   
             </div> 
     </div> 
    



</div> 

):null}





<div class="row d-flex align-items-end justify-content-end p-1 mt-3 ">                   
             <div class="col-4">              
                <button   class="botaoadicionar " >Salvar</button>                                         
             </div>                                
            </div>  

<br/><br/><br/>







    </body>

};